export default {
  custom: [],
  smileys_people: [
    {
      n: ["souriant", "visage souriant"],
      u: "1f600",
      a: "1.0"
    },
    {
      n: ["souriant", "visage souriant avec la bouche ouverte"],
      u: "1f603",
      a: "0.6"
    },
    {
      n: [
        "sourire",
        "visage souriant avec la bouche ouverte et les yeux souriants"
      ],
      u: "1f604",
      a: "0.6"
    },
    {
      n: ["sourire", "visage souriant avec des yeux souriants"],
      u: "1f601",
      a: "0.6"
    },
    {
      n: [
        "en riant",
        "satisfait",
        "visage souriant avec la bouche ouverte et les yeux bien fermés"
      ],
      u: "1f606",
      a: "0.6"
    },
    {
      n: [
        "sourire en sueur",
        "visage souriant avec bouche ouverte et sueur froide"
      ],
      u: "1f605",
      a: "0.6"
    },
    {
      n: ["se rouler par terre en riant"],
      u: "1f923",
      a: "3.0"
    },
    {
      n: ["joie", "visage avec des larmes de joie"],
      u: "1f602",
      a: "0.6"
    },
    {
      n: ["visage légèrement souriant"],
      u: "1f642",
      a: "1.0"
    },
    {
      n: ["visage à l'envers", "visage à l'envers"],
      u: "1f643",
      a: "1.0"
    },
    {
      n: ["visage fondant"],
      u: "1fae0",
      a: "14.0"
    },
    { n: ["visage tremblant"], u: "1fae8", a: "15.0" },
    { n: ["tête secouant horizontalement"], u: "1f642-200d-2194-fe0f", a: "15.1" },
    { n: ["tête hochant verticalement", "tête qui hoche"], u: "1f642-200d-2195-fe0f", a: "15.1" },
    {
      n: ["clin d'œil", "visage clignotant"],
      u: "1f609",
      a: "0.6"
    },
    {
      n: ["rougir", "visage souriant aux yeux souriants"],
      u: "1f60a",
      a: "0.6"
    },
    {
      n: ["innocent", "visage souriant avec halo"],
      u: "1f607",
      a: "1.0"
    },
    {
      n: [
        "visage souriant avec 3 coeurs",
        "visage souriant avec des yeux souriants et trois coeurs"
      ],
      u: "1f970",
      a: "11.0"
    },
    {
      n: ["yeux de coeur", "visage souriant avec des yeux en forme de coeur"],
      u: "1f60d",
      a: "0.6"
    },
    {
      n: ["frappé par les étoiles", "visage souriant avec des yeux étoilés"],
      u: "1f929",
      a: "5.0"
    },
    {
      n: ["baiser coeur", "visage jetant un baiser"],
      u: "1f618",
      a: "0.6"
    },
    {
      n: ["embrasser", "embrasser le visage"],
      u: "1f617",
      a: "1.0"
    },
    {
      n: ["détendu", "visage souriant blanc"],
      u: "263a-fe0f",
      a: "0.6"
    },
    {
      n: [
        "embrasser les yeux fermés",
        "embrasser le visage avec les yeux fermés"
      ],
      u: "1f61a",
      a: "0.6"
    },
    {
      n: [
        "embrasser des yeux souriants",
        "embrasser le visage avec des yeux souriants"
      ],
      u: "1f619",
      a: "1.0"
    },
    {
      n: ["visage souriant avec une larme"],
      u: "1f972",
      a: "13.0"
    },
    {
      n: ["miam", "visage savourant une nourriture délicieuse"],
      u: "1f60b",
      a: "0.6"
    },
    {
      n: ["langue tirée", "visage avec la langue tirée"],
      u: "1f61b",
      a: "1.0"
    },
    {
      n: [
        "langue tirée, œil clignotant",
        "visage avec la langue tirée et un œil clignotant"
      ],
      u: "1f61c",
      a: "0.6"
    },
    {
      n: ["visage loufoque", "visage souriant avec un grand et un petit œil"],
      u: "1f92a",
      a: "5.0"
    },
    {
      n: [
        "langue tirée, yeux fermés",
        "visage avec la langue tirée et les yeux bien fermés"
      ],
      u: "1f61d",
      a: "0.6"
    },
    {
      n: ["visage de bouche à argent", "argent, bouche, visage"],
      u: "1f911",
      a: "1.0"
    },
    {
      n: ["visage étreignant"],
      u: "1f917",
      a: "1.0"
    },
    {
      n: [
        "visage avec la main sur la bouche",
        "visage souriant avec des yeux souriants et une main couvrant la bouche"
      ],
      u: "1f92d",
      a: "5.0"
    },
    {
      n: ["visage avec les yeux ouverts et la main sur la bouche"],
      u: "1fae2",
      a: "14.0"
    },
    {
      n: ["visage avec un œil furtif"],
      u: "1fae3",
      a: "14.0"
    },
    {
      n: [
        "faire taire le visage",
        "visage avec doigt couvrant les lèvres fermées"
      ],
      u: "1f92b",
      a: "5.0"
    },
    {
      n: ["visage pensant"],
      u: "1f914",
      a: "1.0"
    },
    {
      n: ["saluer le visage"],
      u: "1fae1",
      a: "14.0"
    },
    {
      n: ["visage à fermeture éclair", "visage de bouche à glissière"],
      u: "1f910",
      a: "1.0"
    },
    {
      n: ["visage avec un sourcil levé", "visage avec un sourcil levé"],
      u: "1f928",
      a: "5.0"
    },
    {
      n: ["visage neutre"],
      u: "1f610",
      a: "0.7"
    },
    {
      n: ["sans expression", "visage sans expression"],
      u: "1f611",
      a: "1.0"
    },
    {
      n: ["pas de bouche", "visage sans bouche"],
      u: "1f636",
      a: "1.0"
    },
    {
      n: ["visage en pointillé"],
      u: "1fae5",
      a: "14.0"
    },
    {
      n: ["visage dans les nuages"],
      u: "1f636-200d-1f32b-fe0f",
      a: "13.1"
    },
    {
      n: ["petit sourire satisfait", "visage souriant"],
      u: "1f60f",
      a: "0.6"
    },
    {
      n: ["pas amusé", "visage peu amusé"],
      u: "1f612",
      a: "0.6"
    },
    {
      n: ["visage aux yeux qui roulent"],
      u: "1f644",
      a: "1.0"
    },
    {
      n: ["grimaçant", "visage grimaçant"],
      u: "1f62c",
      a: "1.0"
    },
    {
      n: ["visage expirant"],
      u: "1f62e-200d-1f4a8",
      a: "13.1"
    },
    {
      n: ["visage couché"],
      u: "1f925",
      a: "3.0"
    },
    {
      n: ["soulagé", "visage soulagé"],
      u: "1f60c",
      a: "0.6"
    },
    {
      n: ["pensif", "visage pensif"],
      u: "1f614",
      a: "0.6"
    },
    {
      n: ["somnolent", "visage endormi"],
      u: "1f62a",
      a: "0.6"
    },
    {
      n: ["visage baveux"],
      u: "1f924",
      a: "3.0"
    },
    {
      n: ["dormir", "visage endormi"],
      u: "1f634",
      a: "1.0"
    },
    {
      n: ["masque", "visage avec masque médical"],
      u: "1f637",
      a: "0.6"
    },
    {
      n: ["visage avec thermomètre"],
      u: "1f912",
      a: "1.0"
    },
    {
      n: ["visage avec un bandeau", "visage avec un bandeau sur la tête"],
      u: "1f915",
      a: "1.0"
    },
    {
      n: ["visage nauséeux"],
      u: "1f922",
      a: "3.0"
    },
    {
      n: ["visage vomissant", "visage avec bouche ouverte vomissant"],
      u: "1f92e",
      a: "5.0"
    },
    {
      n: ["visage qui éternue"],
      u: "1f927",
      a: "3.0"
    },
    {
      n: ["visage chaud", "visage surchauffé"],
      u: "1f975",
      a: "11.0"
    },
    {
      n: ["visage froid", "visage gelé"],
      u: "1f976",
      a: "11.0"
    },
    {
      n: ["visage étourdi", "visage aux yeux inégaux et à la bouche ondulée"],
      u: "1f974",
      a: "11.0"
    },
    {
      n: ["visage étourdi"],
      u: "1f635",
      a: "0.6"
    },
    { n: ["visage déformé"], u: "1faea", a: "17.0" },
    {
      n: ["visage aux yeux en spirale"],
      u: "1f635-200d-1f4ab",
      a: "13.1"
    },
    {
      n: ["tête qui explose", "visage choqué avec tête qui explose"],
      u: "1f92f",
      a: "5.0"
    },
    {
      n: ["visage avec chapeau de cowboy"],
      u: "1f920",
      a: "3.0"
    },
    {
      n: ["visage de fête", "visage avec corne de fête et chapeau de fête"],
      u: "1f973",
      a: "11.0"
    },
    {
      n: ["visage déguisé"],
      u: "1f978",
      a: "13.0"
    },
    {
      n: ["lunettes de soleil", "visage souriant avec des lunettes de soleil"],
      u: "1f60e",
      a: "1.0"
    },
    {
      n: ["visage de nerd"],
      u: "1f913",
      a: "1.0"
    },
    {
      n: ["visage avec monocle"],
      u: "1f9d0",
      a: "5.0"
    },
    {
      n: ["confus", "visage confus"],
      u: "1f615",
      a: "1.0"
    },
    {
      n: ["visage avec bouche diagonale"],
      u: "1fae4",
      a: "14.0"
    },
    {
      n: ["inquiet", "visage inquiet"],
      u: "1f61f",
      a: "1.0"
    },
    {
      n: ["visage légèrement renfrogné"],
      u: "1f641",
      a: "1.0"
    },
    {
      n: ["visage renfrogné", "visage blanc renfrogné"],
      u: "2639-fe0f",
      a: "0.7"
    },
    {
      n: ["bouche ouverte", "visage avec bouche ouverte"],
      u: "1f62e",
      a: "1.0"
    },
    {
      n: ["étouffé", "visage silencieux"],
      u: "1f62f",
      a: "1.0"
    },
    {
      n: ["étonné", "visage étonné"],
      u: "1f632",
      a: "0.6"
    },
    {
      n: ["rougi", "visage rougi"],
      u: "1f633",
      a: "0.6"
    },
    {
      n: ["visage suppliant", "visage aux yeux suppliants"],
      u: "1f97a",
      a: "11.0"
    },
    {
      n: ["visage retenant ses larmes"],
      u: "1f979",
      a: "14.0"
    },
    {
      n: ["renfrogné", "visage renfrogné avec la bouche ouverte"],
      u: "1f626",
      a: "1.0"
    },
    {
      n: ["angoissé", "visage angoissé"],
      u: "1f627",
      a: "1.0"
    },
    {
      n: ["craintif", "visage craintif"],
      u: "1f628",
      a: "0.6"
    },
    {
      n: ["sueurs froides", "visage avec bouche ouverte et sueur froide"],
      u: "1f630",
      a: "0.6"
    },
    {
      n: ["déçu soulagé", "visage déçu mais soulagé"],
      u: "1f625",
      a: "0.6"
    },
    {
      n: ["pleurer", "visage qui pleure"],
      u: "1f622",
      a: "0.6"
    },
    {
      n: ["sanglot", "visage qui pleure fort"],
      u: "1f62d",
      a: "0.6"
    },
    {
      n: ["crier", "visage criant de peur"],
      u: "1f631",
      a: "0.6"
    },
    {
      n: ["confus", "visage confus"],
      u: "1f616",
      a: "0.6"
    },
    {
      n: ["persévérer", "visage persévérant"],
      u: "1f623",
      a: "0.6"
    },
    {
      n: ["déçu", "visage déçu"],
      u: "1f61e",
      a: "0.6"
    },
    {
      n: ["transpirer", "visage avec des sueurs froides"],
      u: "1f613",
      a: "0.6"
    },
    {
      n: ["fatigué", "visage fatigué"],
      u: "1f629",
      a: "0.6"
    },
    {
      n: ["visage fatigué"],
      u: "1f62b",
      a: "0.6"
    },
    {
      n: ["visage bâillant"],
      u: "1f971",
      a: "12.0"
    },
    { n: ["visage avec des cernes"], u: "1fae9", a: "16.0" },
    {
      n: ["triomphe", "visage avec un air de triomphe"],
      u: "1f624",
      a: "0.6"
    },
    {
      n: ["rage", "visage boudeur"],
      u: "1f621",
      a: "0.6"
    },
    {
      n: ["en colère", "visage en colère"],
      u: "1f620",
      a: "0.6"
    },
    {
      n: [
        "visage avec des symboles sur la bouche",
        "visage sérieux avec des symboles couvrant la bouche"
      ],
      u: "1f92c",
      a: "5.0"
    },
    {
      n: ["lutin souriant", "visage souriant avec des cornes"],
      u: "1f608",
      a: "1.0"
    },
    {
      n: ["lutin"],
      u: "1f47f",
      a: "0.6"
    },
    {
      n: ["crâne"],
      u: "1f480",
      a: "0.6"
    },
    {
      n: ["crâne et os croisés"],
      u: "2620-fe0f",
      a: "1.0"
    },
    {
      n: ["caca", "merde", "mouchoir", "tas de caca"],
      u: "1f4a9",
      a: "0.6"
    },
    {
      n: ["visage de clown"],
      u: "1f921",
      a: "3.0"
    },
    {
      n: ["ogre japonais"],
      u: "1f479",
      a: "0.6"
    },
    {
      n: ["lutin japonais"],
      u: "1f47a",
      a: "0.6"
    },
    {
      n: ["fantôme"],
      u: "1f47b",
      a: "0.6"
    },
    {
      n: ["étranger", "extraterrestre"],
      u: "1f47d",
      a: "0.6"
    },
    {
      n: ["monstre extraterrestre", "envahisseur de l'espace"],
      u: "1f47e",
      a: "0.6"
    },
    {
      n: ["visage de robot"],
      u: "1f916",
      a: "1.0"
    },
    {
      n: ["chat souriant", "visage de chat souriant avec la bouche ouverte"],
      u: "1f63a",
      a: "0.6"
    },
    {
      n: ["chat souriant", "visage de chat souriant avec des yeux souriants"],
      u: "1f638",
      a: "0.6"
    },
    {
      n: ["chat de joie", "visage de chat avec des larmes de joie"],
      u: "1f639",
      a: "0.6"
    },
    {
      n: [
        "coeur yeux chat",
        "visage de chat souriant avec des yeux en forme de coeur"
      ],
      u: "1f63b",
      a: "0.6"
    },
    {
      n: ["chat souriant", "visage de chat avec un sourire ironique"],
      u: "1f63c",
      a: "0.6"
    },
    {
      n: [
        "embrasser un chat",
        "embrasser le visage d'un chat avec les yeux fermés"
      ],
      u: "1f63d",
      a: "0.6"
    },
    {
      n: ["crier un chat", "visage de chat fatigué"],
      u: "1f640",
      a: "0.6"
    },
    {
      n: ["visage de chat qui pleure"],
      u: "1f63f",
      a: "0.6"
    },
    {
      n: ["chat qui fait la moue", "tête de chat qui fait la moue"],
      u: "1f63e",
      a: "0.6"
    },
    {
      n: ["je ne vois aucun mal", "singe qui ne voit aucun mal"],
      u: "1f648",
      a: "0.6"
    },
    {
      n: ["n'entends aucun mal", "singe qui n'entend rien"],
      u: "1f649",
      a: "0.6"
    },
    {
      n: ["ne dis rien de mal", "singe qui ne parle pas de mal"],
      u: "1f64a",
      a: "0.6"
    },
    {
      n: ["baiser", "marque de baiser"],
      u: "1f48b",
      a: "0.6"
    },
    {
      n: ["lettre d'amour"],
      u: "1f48c",
      a: "0.6"
    },
    {
      n: ["Cupidon", "coeur avec flèche"],
      u: "1f498",
      a: "0.6"
    },
    {
      n: ["cadeau coeur", "coeur avec ruban"],
      u: "1f49d",
      a: "0.6"
    },
    {
      n: ["coeur pétillant"],
      u: "1f496",
      a: "0.6"
    },
    {
      n: ["pouls cardiaque", "coeur en pleine croissance"],
      u: "1f497",
      a: "0.6"
    },
    {
      n: ["pulsation", "coeur battant"],
      u: "1f493",
      a: "0.6"
    },
    {
      n: ["coeurs tournants"],
      u: "1f49e",
      a: "0.6"
    },
    {
      n: ["deux coeurs"],
      u: "1f495",
      a: "0.6"
    },
    {
      n: ["décoration coeur"],
      u: "1f49f",
      a: "0.6"
    },
    {
      n: ["exclamation du cœur", "ornement de point d'exclamation coeur lourd"],
      u: "2763-fe0f",
      a: "1.0"
    },
    {
      n: ["coeur brisé"],
      u: "1f494",
      a: "0.6"
    },
    {
      n: ["le coeur en feu"],
      u: "2764-fe0f-200d-1f525",
      a: "13.1"
    },
    {
      n: ["coeur réparateur"],
      u: "2764-fe0f-200d-1fa79",
      a: "13.1"
    },
    {
      n: ["cœur", "lourd coeur noir"],
      u: "2764-fe0f",
      a: "0.6"
    },
    {
      n: ["coeur orange"],
      u: "1f9e1",
      a: "5.0"
    },
    {
      n: ["coeur jaune"],
      u: "1f49b",
      a: "0.6"
    },
    {
      n: ["coeur vert"],
      u: "1f49a",
      a: "0.6"
    },
    {
      n: ["coeur bleu"],
      u: "1f499",
      a: "0.6"
    },
    {
      n: ["coeur violet"],
      u: "1f49c",
      a: "0.6"
    },
    {
      n: ["coeur marron"],
      u: "1f90e",
      a: "12.0"
    },
    {
      n: ["coeur noir"],
      u: "1f5a4",
      a: "3.0"
    },
    {
      n: ["coeur blanc"],
      u: "1f90d",
      a: "12.0"
    },
    { n: ["coeur rose"], u: "1fa77", a: "15.0" },
    { n: ["coeur bleu clair"], u: "1fa75", a: "15.0" },
    { n: ["coeur gris"], u: "1fa76", a: "15.0" },
    {
      n: ["100", "symbole de cent points"],
      u: "1f4af",
      a: "0.6"
    },
    {
      n: ["colère", "symbole de colère"],
      u: "1f4a2",
      a: "0.6"
    },
    {
      n: ["boom", "collision", "symbole de collision"],
      u: "1f4a5",
      a: "0.6"
    },
    { n: ["nuage de bagarre"], u: "1faef", a: "17.0" },
    {
      n: ["vertigineux", "symbole étourdi"],
      u: "1f4ab",
      a: "0.6"
    },
    {
      n: ["gouttes de sueur", "symbole de sueur éclaboussant"],
      u: "1f4a6",
      a: "0.6"
    },
    {
      n: ["tiret", "symbole de tiret"],
      u: "1f4a8",
      a: "0.6"
    },
    {
      n: ["trou"],
      u: "1f573-fe0f",
      a: "0.7"
    },
    {
      n: ["bombe"],
      u: "1f4a3",
      a: "0.6"
    },
    {
      n: ["bulle"],
      u: "1f4ac",
      a: "0.6"
    },
    {
      n: ["oeil dans la bulle", "bulle-oeil-dans-la-parole"],
      u: "1f441-fe0f-200d-1f5e8-fe0f",
      a: "2.0"
    },
    {
      n: ["bulle de gauche"],
      u: "1f5e8-fe0f",
      a: "2.0"
    },
    {
      n: ["bulle de colère droite"],
      u: "1f5ef-fe0f",
      a: "0.7"
    },
    {
      n: ["ballon de pensée"],
      u: "1f4ad",
      a: "1.0"
    },
    {
      n: ["zzz", "symbole endormi"],
      u: "1f4a4",
      a: "0.6"
    },
    {
      n: ["vague", "agitant le signe de la main"],
      u: "1f44b",
      v: [
        "1f44b-1f3fb",
        "1f44b-1f3fc",
        "1f44b-1f3fd",
        "1f44b-1f3fe",
        "1f44b-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["dos de la main levé"],
      u: "1f91a",
      v: [
        "1f91a-1f3fb",
        "1f91a-1f3fc",
        "1f91a-1f3fd",
        "1f91a-1f3fe",
        "1f91a-1f3ff"
      ],
      a: "3.0"
    },
    {
      n: ["main avec les doigts écartés", "main levée avec les doigts écartés"],
      u: "1f590-fe0f",
      v: [
        "1f590-1f3fb",
        "1f590-1f3fc",
        "1f590-1f3fd",
        "1f590-1f3fe",
        "1f590-1f3ff"
      ],
      a: "0.7"
    },
    {
      n: ["main", "main levée"],
      u: "270b",
      v: ["270b-1f3fb", "270b-1f3fc", "270b-1f3fd", "270b-1f3fe", "270b-1f3ff"],
      a: "0.6"
    },
    {
      n: [
        "main de spock",
        "main levée avec une partie entre le majeur et l'annulaire"
      ],
      u: "1f596",
      v: [
        "1f596-1f3fb",
        "1f596-1f3fc",
        "1f596-1f3fd",
        "1f596-1f3fe",
        "1f596-1f3ff"
      ],
      a: "1.0"
    },
    {
      n: ["main droite"],
      u: "1faf1",
      v: [
        "1faf1-1f3fb",
        "1faf1-1f3fc",
        "1faf1-1f3fd",
        "1faf1-1f3fe",
        "1faf1-1f3ff"
      ],
      a: "14.0"
    },
    {
      n: ["main vers la gauche"],
      u: "1faf2",
      v: [
        "1faf2-1f3fb",
        "1faf2-1f3fc",
        "1faf2-1f3fd",
        "1faf2-1f3fe",
        "1faf2-1f3ff"
      ],
      a: "14.0"
    },
    {
      n: ["main paume vers le bas"],
      u: "1faf3",
      v: [
        "1faf3-1f3fb",
        "1faf3-1f3fc",
        "1faf3-1f3fd",
        "1faf3-1f3fe",
        "1faf3-1f3ff"
      ],
      a: "14.0"
    },
    {
      n: ["paume vers le haut"],
      u: "1faf4",
      v: [
        "1faf4-1f3fb",
        "1faf4-1f3fc",
        "1faf4-1f3fd",
        "1faf4-1f3fe",
        "1faf4-1f3ff"
      ],
      a: "14.0"
    },
    {
      n: ["ok la main", "ok signe de la main"],
      u: "1f44c",
      v: [
        "1f44c-1f3fb",
        "1f44c-1f3fc",
        "1f44c-1f3fd",
        "1f44c-1f3fe",
        "1f44c-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["doigts pincés"],
      u: "1f90c",
      v: [
        "1f90c-1f3fb",
        "1f90c-1f3fc",
        "1f90c-1f3fd",
        "1f90c-1f3fe",
        "1f90c-1f3ff"
      ],
      a: "13.0"
    },
    {
      n: ["pincer la main"],
      u: "1f90f",
      v: [
        "1f90f-1f3fb",
        "1f90f-1f3fc",
        "1f90f-1f3fd",
        "1f90f-1f3fe",
        "1f90f-1f3ff"
      ],
      a: "12.0"
    },
    {
      n: ["v", "main de victoire"],
      u: "270c-fe0f",
      v: ["270c-1f3fb", "270c-1f3fc", "270c-1f3fd", "270c-1f3fe", "270c-1f3ff"],
      a: "0.6"
    },
    {
      n: ["croisons les doigts", "main avec l'index et le majeur croisés"],
      u: "1f91e",
      v: [
        "1f91e-1f3fb",
        "1f91e-1f3fc",
        "1f91e-1f3fd",
        "1f91e-1f3fe",
        "1f91e-1f3ff"
      ],
      a: "3.0"
    },
    {
      n: ["main avec l'index et le pouce croisés"],
      u: "1faf0",
      v: [
        "1faf0-1f3fb",
        "1faf0-1f3fc",
        "1faf0-1f3fd",
        "1faf0-1f3fe",
        "1faf0-1f3ff"
      ],
      a: "14.0"
    },
    {
      n: ["je t'aime signe de la main"],
      u: "1f91f",
      v: [
        "1f91f-1f3fb",
        "1f91f-1f3fc",
        "1f91f-1f3fd",
        "1f91f-1f3fe",
        "1f91f-1f3ff"
      ],
      a: "5.0"
    },
    {
      n: ["les cornes", "signe des cornes"],
      u: "1f918",
      v: [
        "1f918-1f3fb",
        "1f918-1f3fc",
        "1f918-1f3fd",
        "1f918-1f3fe",
        "1f918-1f3ff"
      ],
      a: "1.0"
    },
    {
      n: ["appelle-moi la main"],
      u: "1f919",
      v: [
        "1f919-1f3fb",
        "1f919-1f3fc",
        "1f919-1f3fd",
        "1f919-1f3fe",
        "1f919-1f3ff"
      ],
      a: "3.0"
    },
    {
      n: ["pointer à gauche", "index du revers blanc pointant vers la gauche"],
      u: "1f448",
      v: [
        "1f448-1f3fb",
        "1f448-1f3fc",
        "1f448-1f3fd",
        "1f448-1f3fe",
        "1f448-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["pointer à droite", "Index du revers blanc pointant vers la droite"],
      u: "1f449",
      v: [
        "1f449-1f3fb",
        "1f449-1f3fc",
        "1f449-1f3fd",
        "1f449-1f3fe",
        "1f449-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: [
        "pointer vers le haut 2",
        "index du revers pointé vers le haut blanc"
      ],
      u: "1f446",
      v: [
        "1f446-1f3fb",
        "1f446-1f3fc",
        "1f446-1f3fd",
        "1f446-1f3fe",
        "1f446-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["majeur", "main inversée avec le majeur étendu"],
      u: "1f595",
      v: [
        "1f595-1f3fb",
        "1f595-1f3fc",
        "1f595-1f3fd",
        "1f595-1f3fe",
        "1f595-1f3ff"
      ],
      a: "1.0"
    },
    {
      n: ["pointer vers le bas", "Index du revers pointant vers le bas blanc"],
      u: "1f447",
      v: [
        "1f447-1f3fb",
        "1f447-1f3fc",
        "1f447-1f3fd",
        "1f447-1f3fe",
        "1f447-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["pointer vers le haut", "index de pointage blanc"],
      u: "261d-fe0f",
      v: ["261d-1f3fb", "261d-1f3fc", "261d-1f3fd", "261d-1f3fe", "261d-1f3ff"],
      a: "0.6"
    },
    {
      n: ["index pointant vers le spectateur"],
      u: "1faf5",
      v: [
        "1faf5-1f3fb",
        "1faf5-1f3fc",
        "1faf5-1f3fd",
        "1faf5-1f3fe",
        "1faf5-1f3ff"
      ],
      a: "14.0"
    },
    {
      n: ["+1", "pouce levé", "signe du pouce levé"],
      u: "1f44d",
      v: [
        "1f44d-1f3fb",
        "1f44d-1f3fc",
        "1f44d-1f3fd",
        "1f44d-1f3fe",
        "1f44d-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["-1", "pouce vers le bas", "signe du pouce vers le bas"],
      u: "1f44e",
      v: [
        "1f44e-1f3fb",
        "1f44e-1f3fc",
        "1f44e-1f3fd",
        "1f44e-1f3fe",
        "1f44e-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["poing", "poing levé"],
      u: "270a",
      v: ["270a-1f3fb", "270a-1f3fc", "270a-1f3fd", "270a-1f3fe", "270a-1f3ff"],
      a: "0.6"
    },
    {
      n: ["punch", "coup de poing", "signe de la main poings"],
      u: "1f44a",
      v: [
        "1f44a-1f3fb",
        "1f44a-1f3fc",
        "1f44a-1f3fd",
        "1f44a-1f3fe",
        "1f44a-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["poing vers la gauche"],
      u: "1f91b",
      v: [
        "1f91b-1f3fb",
        "1f91b-1f3fc",
        "1f91b-1f3fd",
        "1f91b-1f3fe",
        "1f91b-1f3ff"
      ],
      a: "3.0"
    },
    {
      n: ["poing vers la droite"],
      u: "1f91c",
      v: [
        "1f91c-1f3fb",
        "1f91c-1f3fc",
        "1f91c-1f3fd",
        "1f91c-1f3fe",
        "1f91c-1f3ff"
      ],
      a: "3.0"
    },
    {
      n: ["taper", "signe applaudissant"],
      u: "1f44f",
      v: [
        "1f44f-1f3fb",
        "1f44f-1f3fc",
        "1f44f-1f3fd",
        "1f44f-1f3fe",
        "1f44f-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["mains levées", "personne levant les deux mains pour célébrer"],
      u: "1f64c",
      v: [
        "1f64c-1f3fb",
        "1f64c-1f3fc",
        "1f64c-1f3fd",
        "1f64c-1f3fe",
        "1f64c-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["mains de coeur"],
      u: "1faf6",
      v: [
        "1faf6-1f3fb",
        "1faf6-1f3fc",
        "1faf6-1f3fd",
        "1faf6-1f3fe",
        "1faf6-1f3ff"
      ],
      a: "14.0"
    },
    {
      n: ["main poussant vers la gauche"],
      u: "1faf7",
      v: [
        "1faf7-1f3fb",
        "1faf7-1f3fc",
        "1faf7-1f3fd",
        "1faf7-1f3fe",
        "1faf7-1f3ff"
      ],
      a: "15.0"
    },
    {
      n: ["main poussant vers la droite"],
      u: "1faf8",
      v: [
        "1faf8-1f3fb",
        "1faf8-1f3fc",
        "1faf8-1f3fd",
        "1faf8-1f3fe",
        "1faf8-1f3ff"
      ],
      a: "15.0"
    },
    {
      n: ["mains ouvertes", "signe des mains ouvertes"],
      u: "1f450",
      v: [
        "1f450-1f3fb",
        "1f450-1f3fc",
        "1f450-1f3fd",
        "1f450-1f3fe",
        "1f450-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["paumes vers le haut ensemble"],
      u: "1f932",
      v: [
        "1f932-1f3fb",
        "1f932-1f3fc",
        "1f932-1f3fd",
        "1f932-1f3fe",
        "1f932-1f3ff"
      ],
      a: "5.0"
    },
    {
      n: ["poignée de main"],
      u: "1f91d",
      v: [
        "1f91d-1f3fb",
        "1f91d-1f3fc",
        "1f91d-1f3fd",
        "1f91d-1f3fe",
        "1f91d-1f3ff",
        "1faf1-1f3fb-200d-1faf2-1f3fc",
        "1faf1-1f3fb-200d-1faf2-1f3fd",
        "1faf1-1f3fb-200d-1faf2-1f3fe",
        "1faf1-1f3fb-200d-1faf2-1f3ff",
        "1faf1-1f3fc-200d-1faf2-1f3fb",
        "1faf1-1f3fc-200d-1faf2-1f3fd",
        "1faf1-1f3fc-200d-1faf2-1f3fe",
        "1faf1-1f3fc-200d-1faf2-1f3ff",
        "1faf1-1f3fd-200d-1faf2-1f3fb",
        "1faf1-1f3fd-200d-1faf2-1f3fc",
        "1faf1-1f3fd-200d-1faf2-1f3fe",
        "1faf1-1f3fd-200d-1faf2-1f3ff",
        "1faf1-1f3fe-200d-1faf2-1f3fb",
        "1faf1-1f3fe-200d-1faf2-1f3fc",
        "1faf1-1f3fe-200d-1faf2-1f3fd",
        "1faf1-1f3fe-200d-1faf2-1f3ff",
        "1faf1-1f3ff-200d-1faf2-1f3fb",
        "1faf1-1f3ff-200d-1faf2-1f3fc",
        "1faf1-1f3ff-200d-1faf2-1f3fd",
        "1faf1-1f3ff-200d-1faf2-1f3fe"
      ],
      a: "3.0"
    },
    {
      n: ["prier", "personne avec les mains jointes"],
      u: "1f64f",
      v: [
        "1f64f-1f3fb",
        "1f64f-1f3fc",
        "1f64f-1f3fd",
        "1f64f-1f3fe",
        "1f64f-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["main qui écrit"],
      u: "270d-fe0f",
      v: ["270d-1f3fb", "270d-1f3fc", "270d-1f3fd", "270d-1f3fe", "270d-1f3ff"],
      a: "0.7"
    },
    {
      n: ["soin des ongles", "vernis à ongles"],
      u: "1f485",
      v: [
        "1f485-1f3fb",
        "1f485-1f3fc",
        "1f485-1f3fd",
        "1f485-1f3fe",
        "1f485-1f3ff"
      ],
      a: "0.6"
    },
    { n: ["empreinte digitale"], u: "1fac6", a: "16.0" },
    {
      n: ["selfie"],
      u: "1f933",
      v: [
        "1f933-1f3fb",
        "1f933-1f3fc",
        "1f933-1f3fd",
        "1f933-1f3fe",
        "1f933-1f3ff"
      ],
      a: "3.0"
    },
    {
      n: ["muscle", "biceps fléchis"],
      u: "1f4aa",
      v: [
        "1f4aa-1f3fb",
        "1f4aa-1f3fc",
        "1f4aa-1f3fd",
        "1f4aa-1f3fe",
        "1f4aa-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["bras mécanique"],
      u: "1f9be",
      a: "12.0"
    },
    {
      n: ["jambe mécanique"],
      u: "1f9bf",
      a: "12.0"
    },
    {
      n: ["jambe"],
      u: "1f9b5",
      v: [
        "1f9b5-1f3fb",
        "1f9b5-1f3fc",
        "1f9b5-1f3fd",
        "1f9b5-1f3fe",
        "1f9b5-1f3ff"
      ],
      a: "11.0"
    },
    {
      n: ["pied"],
      u: "1f9b6",
      v: [
        "1f9b6-1f3fb",
        "1f9b6-1f3fc",
        "1f9b6-1f3fd",
        "1f9b6-1f3fe",
        "1f9b6-1f3ff"
      ],
      a: "11.0"
    },
    {
      n: ["oreille"],
      u: "1f442",
      v: [
        "1f442-1f3fb",
        "1f442-1f3fc",
        "1f442-1f3fd",
        "1f442-1f3fe",
        "1f442-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["oreille avec appareil auditif"],
      u: "1f9bb",
      v: [
        "1f9bb-1f3fb",
        "1f9bb-1f3fc",
        "1f9bb-1f3fd",
        "1f9bb-1f3fe",
        "1f9bb-1f3ff"
      ],
      a: "12.0"
    },
    {
      n: ["nez"],
      u: "1f443",
      v: [
        "1f443-1f3fb",
        "1f443-1f3fc",
        "1f443-1f3fd",
        "1f443-1f3fe",
        "1f443-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["cerveau"],
      u: "1f9e0",
      a: "5.0"
    },
    {
      n: ["coeur anatomique"],
      u: "1fac0",
      a: "13.0"
    },
    {
      n: ["poumons"],
      u: "1fac1",
      a: "13.0"
    },
    {
      n: ["dent"],
      u: "1f9b7",
      a: "11.0"
    },
    {
      n: ["os"],
      u: "1f9b4",
      a: "11.0"
    },
    {
      n: ["yeux"],
      u: "1f440",
      a: "0.6"
    },
    {
      n: ["œil"],
      u: "1f441-fe0f",
      a: "0.7"
    },
    {
      n: ["langue"],
      u: "1f445",
      a: "0.6"
    },
    {
      n: ["lèvres", "bouche"],
      u: "1f444",
      a: "0.6"
    },
    {
      n: ["se mordre la lèvre"],
      u: "1fae6",
      a: "14.0"
    },
    {
      n: ["bébé"],
      u: "1f476",
      v: [
        "1f476-1f3fb",
        "1f476-1f3fc",
        "1f476-1f3fd",
        "1f476-1f3fe",
        "1f476-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["enfant"],
      u: "1f9d2",
      v: [
        "1f9d2-1f3fb",
        "1f9d2-1f3fc",
        "1f9d2-1f3fd",
        "1f9d2-1f3fe",
        "1f9d2-1f3ff"
      ],
      a: "5.0"
    },
    {
      n: ["garçon"],
      u: "1f466",
      v: [
        "1f466-1f3fb",
        "1f466-1f3fc",
        "1f466-1f3fd",
        "1f466-1f3fe",
        "1f466-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["fille"],
      u: "1f467",
      v: [
        "1f467-1f3fb",
        "1f467-1f3fc",
        "1f467-1f3fd",
        "1f467-1f3fe",
        "1f467-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["adulte"],
      u: "1f9d1",
      v: [
        "1f9d1-1f3fb",
        "1f9d1-1f3fc",
        "1f9d1-1f3fd",
        "1f9d1-1f3fe",
        "1f9d1-1f3ff"
      ],
      a: "5.0"
    },
    {
      n: ["personne aux cheveux blonds"],
      u: "1f471",
      v: [
        "1f471-1f3fb",
        "1f471-1f3fc",
        "1f471-1f3fd",
        "1f471-1f3fe",
        "1f471-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme"],
      u: "1f468",
      v: [
        "1f468-1f3fb",
        "1f468-1f3fc",
        "1f468-1f3fd",
        "1f468-1f3fe",
        "1f468-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["personne barbue"],
      u: "1f9d4",
      v: [
        "1f9d4-1f3fb",
        "1f9d4-1f3fc",
        "1f9d4-1f3fd",
        "1f9d4-1f3fe",
        "1f9d4-1f3ff"
      ],
      a: "5.0"
    },
    {
      n: ["homme : barbe", "homme à barbe"],
      u: "1f9d4-200d-2642-fe0f",
      v: [
        "1f9d4-1f3fb-200d-2642-fe0f",
        "1f9d4-1f3fc-200d-2642-fe0f",
        "1f9d4-1f3fd-200d-2642-fe0f",
        "1f9d4-1f3fe-200d-2642-fe0f",
        "1f9d4-1f3ff-200d-2642-fe0f"
      ],
      a: "13.1"
    },
    {
      n: ["femme : barbe", "femme à barbe"],
      u: "1f9d4-200d-2640-fe0f",
      v: [
        "1f9d4-1f3fb-200d-2640-fe0f",
        "1f9d4-1f3fc-200d-2640-fe0f",
        "1f9d4-1f3fd-200d-2640-fe0f",
        "1f9d4-1f3fe-200d-2640-fe0f",
        "1f9d4-1f3ff-200d-2640-fe0f"
      ],
      a: "13.1"
    },
    {
      n: ["homme : cheveux roux", "homme aux cheveux roux"],
      u: "1f468-200d-1f9b0",
      v: [
        "1f468-1f3fb-200d-1f9b0",
        "1f468-1f3fc-200d-1f9b0",
        "1f468-1f3fd-200d-1f9b0",
        "1f468-1f3fe-200d-1f9b0",
        "1f468-1f3ff-200d-1f9b0"
      ],
      a: "11.0"
    },
    {
      n: ["homme : cheveux bouclés", "homme aux cheveux bouclés"],
      u: "1f468-200d-1f9b1",
      v: [
        "1f468-1f3fb-200d-1f9b1",
        "1f468-1f3fc-200d-1f9b1",
        "1f468-1f3fd-200d-1f9b1",
        "1f468-1f3fe-200d-1f9b1",
        "1f468-1f3ff-200d-1f9b1"
      ],
      a: "11.0"
    },
    {
      n: ["homme : cheveux blancs", "homme aux cheveux blancs"],
      u: "1f468-200d-1f9b3",
      v: [
        "1f468-1f3fb-200d-1f9b3",
        "1f468-1f3fc-200d-1f9b3",
        "1f468-1f3fd-200d-1f9b3",
        "1f468-1f3fe-200d-1f9b3",
        "1f468-1f3ff-200d-1f9b3"
      ],
      a: "11.0"
    },
    {
      n: ["homme chauve", "homme : chauve"],
      u: "1f468-200d-1f9b2",
      v: [
        "1f468-1f3fb-200d-1f9b2",
        "1f468-1f3fc-200d-1f9b2",
        "1f468-1f3fd-200d-1f9b2",
        "1f468-1f3fe-200d-1f9b2",
        "1f468-1f3ff-200d-1f9b2"
      ],
      a: "11.0"
    },
    {
      n: ["femme"],
      u: "1f469",
      v: [
        "1f469-1f3fb",
        "1f469-1f3fc",
        "1f469-1f3fd",
        "1f469-1f3fe",
        "1f469-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["femme : cheveux roux", "femme aux cheveux rouges"],
      u: "1f469-200d-1f9b0",
      v: [
        "1f469-1f3fb-200d-1f9b0",
        "1f469-1f3fc-200d-1f9b0",
        "1f469-1f3fd-200d-1f9b0",
        "1f469-1f3fe-200d-1f9b0",
        "1f469-1f3ff-200d-1f9b0"
      ],
      a: "11.0"
    },
    {
      n: ["personne : cheveux roux", "personne aux cheveux roux"],
      u: "1f9d1-200d-1f9b0",
      v: [
        "1f9d1-1f3fb-200d-1f9b0",
        "1f9d1-1f3fc-200d-1f9b0",
        "1f9d1-1f3fd-200d-1f9b0",
        "1f9d1-1f3fe-200d-1f9b0",
        "1f9d1-1f3ff-200d-1f9b0"
      ],
      a: "12.1"
    },
    {
      n: ["femme : cheveux bouclés", "femme aux cheveux bouclés"],
      u: "1f469-200d-1f9b1",
      v: [
        "1f469-1f3fb-200d-1f9b1",
        "1f469-1f3fc-200d-1f9b1",
        "1f469-1f3fd-200d-1f9b1",
        "1f469-1f3fe-200d-1f9b1",
        "1f469-1f3ff-200d-1f9b1"
      ],
      a: "11.0"
    },
    {
      n: ["personne : cheveux bouclés", "personne aux cheveux bouclés"],
      u: "1f9d1-200d-1f9b1",
      v: [
        "1f9d1-1f3fb-200d-1f9b1",
        "1f9d1-1f3fc-200d-1f9b1",
        "1f9d1-1f3fd-200d-1f9b1",
        "1f9d1-1f3fe-200d-1f9b1",
        "1f9d1-1f3ff-200d-1f9b1"
      ],
      a: "12.1"
    },
    {
      n: ["femme : cheveux blancs", "femme aux cheveux blancs"],
      u: "1f469-200d-1f9b3",
      v: [
        "1f469-1f3fb-200d-1f9b3",
        "1f469-1f3fc-200d-1f9b3",
        "1f469-1f3fd-200d-1f9b3",
        "1f469-1f3fe-200d-1f9b3",
        "1f469-1f3ff-200d-1f9b3"
      ],
      a: "11.0"
    },
    {
      n: ["personne : cheveux blancs", "personne aux cheveux blancs"],
      u: "1f9d1-200d-1f9b3",
      v: [
        "1f9d1-1f3fb-200d-1f9b3",
        "1f9d1-1f3fc-200d-1f9b3",
        "1f9d1-1f3fd-200d-1f9b3",
        "1f9d1-1f3fe-200d-1f9b3",
        "1f9d1-1f3ff-200d-1f9b3"
      ],
      a: "12.1"
    },
    {
      n: ["femme chauve", "femme : chauve"],
      u: "1f469-200d-1f9b2",
      v: [
        "1f469-1f3fb-200d-1f9b2",
        "1f469-1f3fc-200d-1f9b2",
        "1f469-1f3fd-200d-1f9b2",
        "1f469-1f3fe-200d-1f9b2",
        "1f469-1f3ff-200d-1f9b2"
      ],
      a: "11.0"
    },
    {
      n: ["personne chauve", "personne : chauve"],
      u: "1f9d1-200d-1f9b2",
      v: [
        "1f9d1-1f3fb-200d-1f9b2",
        "1f9d1-1f3fc-200d-1f9b2",
        "1f9d1-1f3fd-200d-1f9b2",
        "1f9d1-1f3fe-200d-1f9b2",
        "1f9d1-1f3ff-200d-1f9b2"
      ],
      a: "12.1"
    },
    {
      n: ["femme : cheveux blonds", "femme-aux-cheveux-blonds"],
      u: "1f471-200d-2640-fe0f",
      v: [
        "1f471-1f3fb-200d-2640-fe0f",
        "1f471-1f3fc-200d-2640-fe0f",
        "1f471-1f3fd-200d-2640-fe0f",
        "1f471-1f3fe-200d-2640-fe0f",
        "1f471-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["homme : cheveux blonds", "homme aux cheveux blonds"],
      u: "1f471-200d-2642-fe0f",
      v: [
        "1f471-1f3fb-200d-2642-fe0f",
        "1f471-1f3fc-200d-2642-fe0f",
        "1f471-1f3fd-200d-2642-fe0f",
        "1f471-1f3fe-200d-2642-fe0f",
        "1f471-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["adulte plus âgé"],
      u: "1f9d3",
      v: [
        "1f9d3-1f3fb",
        "1f9d3-1f3fc",
        "1f9d3-1f3fd",
        "1f9d3-1f3fe",
        "1f9d3-1f3ff"
      ],
      a: "5.0"
    },
    {
      n: ["homme plus âgé"],
      u: "1f474",
      v: [
        "1f474-1f3fb",
        "1f474-1f3fc",
        "1f474-1f3fd",
        "1f474-1f3fe",
        "1f474-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["femme plus âgée"],
      u: "1f475",
      v: [
        "1f475-1f3fb",
        "1f475-1f3fc",
        "1f475-1f3fd",
        "1f475-1f3fe",
        "1f475-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["personne fronçant les sourcils"],
      u: "1f64d",
      v: [
        "1f64d-1f3fb",
        "1f64d-1f3fc",
        "1f64d-1f3fd",
        "1f64d-1f3fe",
        "1f64d-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme fronçant les sourcils", "homme fronçant les sourcils"],
      u: "1f64d-200d-2642-fe0f",
      v: [
        "1f64d-1f3fb-200d-2642-fe0f",
        "1f64d-1f3fc-200d-2642-fe0f",
        "1f64d-1f3fd-200d-2642-fe0f",
        "1f64d-1f3fe-200d-2642-fe0f",
        "1f64d-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme fronçant les sourcils", "femme fronçant les sourcils"],
      u: "1f64d-200d-2640-fe0f",
      v: [
        "1f64d-1f3fb-200d-2640-fe0f",
        "1f64d-1f3fc-200d-2640-fe0f",
        "1f64d-1f3fd-200d-2640-fe0f",
        "1f64d-1f3fe-200d-2640-fe0f",
        "1f64d-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["personne au visage boudeur"],
      u: "1f64e",
      v: [
        "1f64e-1f3fb",
        "1f64e-1f3fc",
        "1f64e-1f3fd",
        "1f64e-1f3fe",
        "1f64e-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme qui fait la moue", "homme qui fait la moue"],
      u: "1f64e-200d-2642-fe0f",
      v: [
        "1f64e-1f3fb-200d-2642-fe0f",
        "1f64e-1f3fc-200d-2642-fe0f",
        "1f64e-1f3fd-200d-2642-fe0f",
        "1f64e-1f3fe-200d-2642-fe0f",
        "1f64e-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme qui fait la moue", "femme-boudeuse"],
      u: "1f64e-200d-2640-fe0f",
      v: [
        "1f64e-1f3fb-200d-2640-fe0f",
        "1f64e-1f3fc-200d-2640-fe0f",
        "1f64e-1f3fd-200d-2640-fe0f",
        "1f64e-1f3fe-200d-2640-fe0f",
        "1f64e-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["pas bon", "visage sans bon geste"],
      u: "1f645",
      v: [
        "1f645-1f3fb",
        "1f645-1f3fc",
        "1f645-1f3fd",
        "1f645-1f3fe",
        "1f645-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme faisant signe non", "homme-gesticulant-non"],
      u: "1f645-200d-2642-fe0f",
      v: [
        "1f645-1f3fb-200d-2642-fe0f",
        "1f645-1f3fc-200d-2642-fe0f",
        "1f645-1f3fd-200d-2642-fe0f",
        "1f645-1f3fe-200d-2642-fe0f",
        "1f645-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme faisant signe non", "femme-gesticulant-non"],
      u: "1f645-200d-2640-fe0f",
      v: [
        "1f645-1f3fb-200d-2640-fe0f",
        "1f645-1f3fc-200d-2640-fe0f",
        "1f645-1f3fd-200d-2640-fe0f",
        "1f645-1f3fe-200d-2640-fe0f",
        "1f645-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["ok femme", "visage avec un geste correct"],
      u: "1f646",
      v: [
        "1f646-1f3fb",
        "1f646-1f3fc",
        "1f646-1f3fd",
        "1f646-1f3fe",
        "1f646-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme faisant des gestes ok", "homme-gesticulant-ok"],
      u: "1f646-200d-2642-fe0f",
      v: [
        "1f646-1f3fb-200d-2642-fe0f",
        "1f646-1f3fc-200d-2642-fe0f",
        "1f646-1f3fd-200d-2642-fe0f",
        "1f646-1f3fe-200d-2642-fe0f",
        "1f646-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme faisant des gestes ok", "femme-gesticulant-ok"],
      u: "1f646-200d-2640-fe0f",
      v: [
        "1f646-1f3fb-200d-2640-fe0f",
        "1f646-1f3fc-200d-2640-fe0f",
        "1f646-1f3fd-200d-2640-fe0f",
        "1f646-1f3fe-200d-2640-fe0f",
        "1f646-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["personne au bureau d'information"],
      u: "1f481",
      v: [
        "1f481-1f3fb",
        "1f481-1f3fc",
        "1f481-1f3fd",
        "1f481-1f3fe",
        "1f481-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme qui tend la main", "homme qui donne la main"],
      u: "1f481-200d-2642-fe0f",
      v: [
        "1f481-1f3fb-200d-2642-fe0f",
        "1f481-1f3fc-200d-2642-fe0f",
        "1f481-1f3fd-200d-2642-fe0f",
        "1f481-1f3fe-200d-2642-fe0f",
        "1f481-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme qui penche la main", "femme-tipping-hand"],
      u: "1f481-200d-2640-fe0f",
      v: [
        "1f481-1f3fb-200d-2640-fe0f",
        "1f481-1f3fc-200d-2640-fe0f",
        "1f481-1f3fd-200d-2640-fe0f",
        "1f481-1f3fe-200d-2640-fe0f",
        "1f481-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["lever la main", "personne heureuse levant une main"],
      u: "1f64b",
      v: [
        "1f64b-1f3fb",
        "1f64b-1f3fc",
        "1f64b-1f3fd",
        "1f64b-1f3fe",
        "1f64b-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme levant la main", "homme-levant la main"],
      u: "1f64b-200d-2642-fe0f",
      v: [
        "1f64b-1f3fb-200d-2642-fe0f",
        "1f64b-1f3fc-200d-2642-fe0f",
        "1f64b-1f3fd-200d-2642-fe0f",
        "1f64b-1f3fe-200d-2642-fe0f",
        "1f64b-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme levant la main", "femme-levant la main"],
      u: "1f64b-200d-2640-fe0f",
      v: [
        "1f64b-1f3fb-200d-2640-fe0f",
        "1f64b-1f3fc-200d-2640-fe0f",
        "1f64b-1f3fd-200d-2640-fe0f",
        "1f64b-1f3fe-200d-2640-fe0f",
        "1f64b-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["personne sourde"],
      u: "1f9cf",
      v: [
        "1f9cf-1f3fb",
        "1f9cf-1f3fc",
        "1f9cf-1f3fd",
        "1f9cf-1f3fe",
        "1f9cf-1f3ff"
      ],
      a: "12.0"
    },
    {
      n: ["homme sourd"],
      u: "1f9cf-200d-2642-fe0f",
      v: [
        "1f9cf-1f3fb-200d-2642-fe0f",
        "1f9cf-1f3fc-200d-2642-fe0f",
        "1f9cf-1f3fd-200d-2642-fe0f",
        "1f9cf-1f3fe-200d-2642-fe0f",
        "1f9cf-1f3ff-200d-2642-fe0f"
      ],
      a: "12.0"
    },
    {
      n: ["femme sourde"],
      u: "1f9cf-200d-2640-fe0f",
      v: [
        "1f9cf-1f3fb-200d-2640-fe0f",
        "1f9cf-1f3fc-200d-2640-fe0f",
        "1f9cf-1f3fd-200d-2640-fe0f",
        "1f9cf-1f3fe-200d-2640-fe0f",
        "1f9cf-1f3ff-200d-2640-fe0f"
      ],
      a: "12.0"
    },
    {
      n: ["arc", "personne qui s'incline profondément"],
      u: "1f647",
      v: [
        "1f647-1f3fb",
        "1f647-1f3fc",
        "1f647-1f3fd",
        "1f647-1f3fe",
        "1f647-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme s'inclinant", "homme qui s'incline"],
      u: "1f647-200d-2642-fe0f",
      v: [
        "1f647-1f3fb-200d-2642-fe0f",
        "1f647-1f3fc-200d-2642-fe0f",
        "1f647-1f3fd-200d-2642-fe0f",
        "1f647-1f3fe-200d-2642-fe0f",
        "1f647-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme s'inclinant", "femme qui s'incline"],
      u: "1f647-200d-2640-fe0f",
      v: [
        "1f647-1f3fb-200d-2640-fe0f",
        "1f647-1f3fc-200d-2640-fe0f",
        "1f647-1f3fd-200d-2640-fe0f",
        "1f647-1f3fe-200d-2640-fe0f",
        "1f647-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["visage, paume"],
      u: "1f926",
      v: [
        "1f926-1f3fb",
        "1f926-1f3fc",
        "1f926-1f3fd",
        "1f926-1f3fe",
        "1f926-1f3ff"
      ],
      a: "3.0"
    },
    {
      n: ["homme facepalming", "homme-facepalming"],
      u: "1f926-200d-2642-fe0f",
      v: [
        "1f926-1f3fb-200d-2642-fe0f",
        "1f926-1f3fc-200d-2642-fe0f",
        "1f926-1f3fd-200d-2642-fe0f",
        "1f926-1f3fe-200d-2642-fe0f",
        "1f926-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme, faire facepalming", "femme-facepalming"],
      u: "1f926-200d-2640-fe0f",
      v: [
        "1f926-1f3fb-200d-2640-fe0f",
        "1f926-1f3fc-200d-2640-fe0f",
        "1f926-1f3fd-200d-2640-fe0f",
        "1f926-1f3fe-200d-2640-fe0f",
        "1f926-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["hausser les épaules"],
      u: "1f937",
      v: [
        "1f937-1f3fb",
        "1f937-1f3fc",
        "1f937-1f3fd",
        "1f937-1f3fe",
        "1f937-1f3ff"
      ],
      a: "3.0"
    },
    {
      n: ["homme haussant les épaules", "homme haussant les épaules"],
      u: "1f937-200d-2642-fe0f",
      v: [
        "1f937-1f3fb-200d-2642-fe0f",
        "1f937-1f3fc-200d-2642-fe0f",
        "1f937-1f3fd-200d-2642-fe0f",
        "1f937-1f3fe-200d-2642-fe0f",
        "1f937-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme haussant les épaules", "femme haussant les épaules"],
      u: "1f937-200d-2640-fe0f",
      v: [
        "1f937-1f3fb-200d-2640-fe0f",
        "1f937-1f3fc-200d-2640-fe0f",
        "1f937-1f3fd-200d-2640-fe0f",
        "1f937-1f3fe-200d-2640-fe0f",
        "1f937-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["agent de santé"],
      u: "1f9d1-200d-2695-fe0f",
      v: [
        "1f9d1-1f3fb-200d-2695-fe0f",
        "1f9d1-1f3fc-200d-2695-fe0f",
        "1f9d1-1f3fd-200d-2695-fe0f",
        "1f9d1-1f3fe-200d-2695-fe0f",
        "1f9d1-1f3ff-200d-2695-fe0f"
      ],
      a: "12.1"
    },
    {
      n: ["médecin de sexe masculin", "homme, agent de santé"],
      u: "1f468-200d-2695-fe0f",
      v: [
        "1f468-1f3fb-200d-2695-fe0f",
        "1f468-1f3fc-200d-2695-fe0f",
        "1f468-1f3fd-200d-2695-fe0f",
        "1f468-1f3fe-200d-2695-fe0f",
        "1f468-1f3ff-200d-2695-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme-médecin", "femme agent de santé"],
      u: "1f469-200d-2695-fe0f",
      v: [
        "1f469-1f3fb-200d-2695-fe0f",
        "1f469-1f3fc-200d-2695-fe0f",
        "1f469-1f3fd-200d-2695-fe0f",
        "1f469-1f3fe-200d-2695-fe0f",
        "1f469-1f3ff-200d-2695-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["étudiant"],
      u: "1f9d1-200d-1f393",
      v: [
        "1f9d1-1f3fb-200d-1f393",
        "1f9d1-1f3fc-200d-1f393",
        "1f9d1-1f3fd-200d-1f393",
        "1f9d1-1f3fe-200d-1f393",
        "1f9d1-1f3ff-200d-1f393"
      ],
      a: "12.1"
    },
    {
      n: ["homme étudiant", "étudiant"],
      u: "1f468-200d-1f393",
      v: [
        "1f468-1f3fb-200d-1f393",
        "1f468-1f3fc-200d-1f393",
        "1f468-1f3fd-200d-1f393",
        "1f468-1f3fe-200d-1f393",
        "1f468-1f3ff-200d-1f393"
      ],
      a: "4.0"
    },
    {
      n: ["étudiante", "étudiante"],
      u: "1f469-200d-1f393",
      v: [
        "1f469-1f3fb-200d-1f393",
        "1f469-1f3fc-200d-1f393",
        "1f469-1f3fd-200d-1f393",
        "1f469-1f3fe-200d-1f393",
        "1f469-1f3ff-200d-1f393"
      ],
      a: "4.0"
    },
    {
      n: ["professeur"],
      u: "1f9d1-200d-1f3eb",
      v: [
        "1f9d1-1f3fb-200d-1f3eb",
        "1f9d1-1f3fc-200d-1f3eb",
        "1f9d1-1f3fd-200d-1f3eb",
        "1f9d1-1f3fe-200d-1f3eb",
        "1f9d1-1f3ff-200d-1f3eb"
      ],
      a: "12.1"
    },
    {
      n: ["homme enseignant", "enseignant"],
      u: "1f468-200d-1f3eb",
      v: [
        "1f468-1f3fb-200d-1f3eb",
        "1f468-1f3fc-200d-1f3eb",
        "1f468-1f3fd-200d-1f3eb",
        "1f468-1f3fe-200d-1f3eb",
        "1f468-1f3ff-200d-1f3eb"
      ],
      a: "4.0"
    },
    {
      n: ["femme enseignante", "enseignante"],
      u: "1f469-200d-1f3eb",
      v: [
        "1f469-1f3fb-200d-1f3eb",
        "1f469-1f3fc-200d-1f3eb",
        "1f469-1f3fd-200d-1f3eb",
        "1f469-1f3fe-200d-1f3eb",
        "1f469-1f3ff-200d-1f3eb"
      ],
      a: "4.0"
    },
    {
      n: ["juge"],
      u: "1f9d1-200d-2696-fe0f",
      v: [
        "1f9d1-1f3fb-200d-2696-fe0f",
        "1f9d1-1f3fc-200d-2696-fe0f",
        "1f9d1-1f3fd-200d-2696-fe0f",
        "1f9d1-1f3fe-200d-2696-fe0f",
        "1f9d1-1f3ff-200d-2696-fe0f"
      ],
      a: "12.1"
    },
    {
      n: ["homme juge", "juge-homme"],
      u: "1f468-200d-2696-fe0f",
      v: [
        "1f468-1f3fb-200d-2696-fe0f",
        "1f468-1f3fc-200d-2696-fe0f",
        "1f468-1f3fd-200d-2696-fe0f",
        "1f468-1f3fe-200d-2696-fe0f",
        "1f468-1f3ff-200d-2696-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme juge", "femme-juge"],
      u: "1f469-200d-2696-fe0f",
      v: [
        "1f469-1f3fb-200d-2696-fe0f",
        "1f469-1f3fc-200d-2696-fe0f",
        "1f469-1f3fd-200d-2696-fe0f",
        "1f469-1f3fe-200d-2696-fe0f",
        "1f469-1f3ff-200d-2696-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["fermier"],
      u: "1f9d1-200d-1f33e",
      v: [
        "1f9d1-1f3fb-200d-1f33e",
        "1f9d1-1f3fc-200d-1f33e",
        "1f9d1-1f3fd-200d-1f33e",
        "1f9d1-1f3fe-200d-1f33e",
        "1f9d1-1f3ff-200d-1f33e"
      ],
      a: "12.1"
    },
    {
      n: ["homme agriculteur", "agriculteur"],
      u: "1f468-200d-1f33e",
      v: [
        "1f468-1f3fb-200d-1f33e",
        "1f468-1f3fc-200d-1f33e",
        "1f468-1f3fd-200d-1f33e",
        "1f468-1f3fe-200d-1f33e",
        "1f468-1f3ff-200d-1f33e"
      ],
      a: "4.0"
    },
    {
      n: ["agricultrice", "agricultrice"],
      u: "1f469-200d-1f33e",
      v: [
        "1f469-1f3fb-200d-1f33e",
        "1f469-1f3fc-200d-1f33e",
        "1f469-1f3fd-200d-1f33e",
        "1f469-1f3fe-200d-1f33e",
        "1f469-1f3ff-200d-1f33e"
      ],
      a: "4.0"
    },
    {
      n: ["cuisiner"],
      u: "1f9d1-200d-1f373",
      v: [
        "1f9d1-1f3fb-200d-1f373",
        "1f9d1-1f3fc-200d-1f373",
        "1f9d1-1f3fd-200d-1f373",
        "1f9d1-1f3fe-200d-1f373",
        "1f9d1-1f3ff-200d-1f373"
      ],
      a: "12.1"
    },
    {
      n: ["homme cuisinier", "mâle-cuisinier"],
      u: "1f468-200d-1f373",
      v: [
        "1f468-1f3fb-200d-1f373",
        "1f468-1f3fc-200d-1f373",
        "1f468-1f3fd-200d-1f373",
        "1f468-1f3fe-200d-1f373",
        "1f468-1f3ff-200d-1f373"
      ],
      a: "4.0"
    },
    {
      n: ["femme cuisinière", "femme-cuisinière"],
      u: "1f469-200d-1f373",
      v: [
        "1f469-1f3fb-200d-1f373",
        "1f469-1f3fc-200d-1f373",
        "1f469-1f3fd-200d-1f373",
        "1f469-1f3fe-200d-1f373",
        "1f469-1f3ff-200d-1f373"
      ],
      a: "4.0"
    },
    {
      n: ["mécanicien"],
      u: "1f9d1-200d-1f527",
      v: [
        "1f9d1-1f3fb-200d-1f527",
        "1f9d1-1f3fc-200d-1f527",
        "1f9d1-1f3fd-200d-1f527",
        "1f9d1-1f3fe-200d-1f527",
        "1f9d1-1f3ff-200d-1f527"
      ],
      a: "12.1"
    },
    {
      n: ["homme mécanicien", "mécanicien masculin"],
      u: "1f468-200d-1f527",
      v: [
        "1f468-1f3fb-200d-1f527",
        "1f468-1f3fc-200d-1f527",
        "1f468-1f3fd-200d-1f527",
        "1f468-1f3fe-200d-1f527",
        "1f468-1f3ff-200d-1f527"
      ],
      a: "4.0"
    },
    {
      n: ["femme mécanicien", "femme-mécanicienne"],
      u: "1f469-200d-1f527",
      v: [
        "1f469-1f3fb-200d-1f527",
        "1f469-1f3fc-200d-1f527",
        "1f469-1f3fd-200d-1f527",
        "1f469-1f3fe-200d-1f527",
        "1f469-1f3ff-200d-1f527"
      ],
      a: "4.0"
    },
    {
      n: ["ouvrier d'usine"],
      u: "1f9d1-200d-1f3ed",
      v: [
        "1f9d1-1f3fb-200d-1f3ed",
        "1f9d1-1f3fc-200d-1f3ed",
        "1f9d1-1f3fd-200d-1f3ed",
        "1f9d1-1f3fe-200d-1f3ed",
        "1f9d1-1f3ff-200d-1f3ed"
      ],
      a: "12.1"
    },
    {
      n: ["ouvrier d'usine", "ouvrier d'usine"],
      u: "1f468-200d-1f3ed",
      v: [
        "1f468-1f3fb-200d-1f3ed",
        "1f468-1f3fc-200d-1f3ed",
        "1f468-1f3fd-200d-1f3ed",
        "1f468-1f3fe-200d-1f3ed",
        "1f468-1f3ff-200d-1f3ed"
      ],
      a: "4.0"
    },
    {
      n: ["ouvrière d'usine", "ouvrière d'usine"],
      u: "1f469-200d-1f3ed",
      v: [
        "1f469-1f3fb-200d-1f3ed",
        "1f469-1f3fc-200d-1f3ed",
        "1f469-1f3fd-200d-1f3ed",
        "1f469-1f3fe-200d-1f3ed",
        "1f469-1f3ff-200d-1f3ed"
      ],
      a: "4.0"
    },
    {
      n: ["employé de bureau"],
      u: "1f9d1-200d-1f4bc",
      v: [
        "1f9d1-1f3fb-200d-1f4bc",
        "1f9d1-1f3fc-200d-1f4bc",
        "1f9d1-1f3fd-200d-1f4bc",
        "1f9d1-1f3fe-200d-1f4bc",
        "1f9d1-1f3ff-200d-1f4bc"
      ],
      a: "12.1"
    },
    {
      n: ["homme, employé bureau", "employé de bureau"],
      u: "1f468-200d-1f4bc",
      v: [
        "1f468-1f3fb-200d-1f4bc",
        "1f468-1f3fc-200d-1f4bc",
        "1f468-1f3fd-200d-1f4bc",
        "1f468-1f3fe-200d-1f4bc",
        "1f468-1f3ff-200d-1f4bc"
      ],
      a: "4.0"
    },
    {
      n: ["femme employée de bureau", "employée de bureau"],
      u: "1f469-200d-1f4bc",
      v: [
        "1f469-1f3fb-200d-1f4bc",
        "1f469-1f3fc-200d-1f4bc",
        "1f469-1f3fd-200d-1f4bc",
        "1f469-1f3fe-200d-1f4bc",
        "1f469-1f3ff-200d-1f4bc"
      ],
      a: "4.0"
    },
    {
      n: ["scientifique"],
      u: "1f9d1-200d-1f52c",
      v: [
        "1f9d1-1f3fb-200d-1f52c",
        "1f9d1-1f3fc-200d-1f52c",
        "1f9d1-1f3fd-200d-1f52c",
        "1f9d1-1f3fe-200d-1f52c",
        "1f9d1-1f3ff-200d-1f52c"
      ],
      a: "12.1"
    },
    {
      n: ["homme scientifique", "homme-scientifique"],
      u: "1f468-200d-1f52c",
      v: [
        "1f468-1f3fb-200d-1f52c",
        "1f468-1f3fc-200d-1f52c",
        "1f468-1f3fd-200d-1f52c",
        "1f468-1f3fe-200d-1f52c",
        "1f468-1f3ff-200d-1f52c"
      ],
      a: "4.0"
    },
    {
      n: ["femme scientifique", "femme-scientifique"],
      u: "1f469-200d-1f52c",
      v: [
        "1f469-1f3fb-200d-1f52c",
        "1f469-1f3fc-200d-1f52c",
        "1f469-1f3fd-200d-1f52c",
        "1f469-1f3fe-200d-1f52c",
        "1f469-1f3ff-200d-1f52c"
      ],
      a: "4.0"
    },
    {
      n: ["technologue"],
      u: "1f9d1-200d-1f4bb",
      v: [
        "1f9d1-1f3fb-200d-1f4bb",
        "1f9d1-1f3fc-200d-1f4bb",
        "1f9d1-1f3fd-200d-1f4bb",
        "1f9d1-1f3fe-200d-1f4bb",
        "1f9d1-1f3ff-200d-1f4bb"
      ],
      a: "12.1"
    },
    {
      n: ["homme technologue", "technologue masculin"],
      u: "1f468-200d-1f4bb",
      v: [
        "1f468-1f3fb-200d-1f4bb",
        "1f468-1f3fc-200d-1f4bb",
        "1f468-1f3fd-200d-1f4bb",
        "1f468-1f3fe-200d-1f4bb",
        "1f468-1f3ff-200d-1f4bb"
      ],
      a: "4.0"
    },
    {
      n: ["femme technologue", "femme-technologue"],
      u: "1f469-200d-1f4bb",
      v: [
        "1f469-1f3fb-200d-1f4bb",
        "1f469-1f3fc-200d-1f4bb",
        "1f469-1f3fd-200d-1f4bb",
        "1f469-1f3fe-200d-1f4bb",
        "1f469-1f3ff-200d-1f4bb"
      ],
      a: "4.0"
    },
    {
      n: ["chanteur"],
      u: "1f9d1-200d-1f3a4",
      v: [
        "1f9d1-1f3fb-200d-1f3a4",
        "1f9d1-1f3fc-200d-1f3a4",
        "1f9d1-1f3fd-200d-1f3a4",
        "1f9d1-1f3fe-200d-1f3a4",
        "1f9d1-1f3ff-200d-1f3a4"
      ],
      a: "12.1"
    },
    {
      n: ["homme chanteur", "chanteur"],
      u: "1f468-200d-1f3a4",
      v: [
        "1f468-1f3fb-200d-1f3a4",
        "1f468-1f3fc-200d-1f3a4",
        "1f468-1f3fd-200d-1f3a4",
        "1f468-1f3fe-200d-1f3a4",
        "1f468-1f3ff-200d-1f3a4"
      ],
      a: "4.0"
    },
    {
      n: ["chanteuse", "chanteuse"],
      u: "1f469-200d-1f3a4",
      v: [
        "1f469-1f3fb-200d-1f3a4",
        "1f469-1f3fc-200d-1f3a4",
        "1f469-1f3fd-200d-1f3a4",
        "1f469-1f3fe-200d-1f3a4",
        "1f469-1f3ff-200d-1f3a4"
      ],
      a: "4.0"
    },
    {
      n: ["artiste"],
      u: "1f9d1-200d-1f3a8",
      v: [
        "1f9d1-1f3fb-200d-1f3a8",
        "1f9d1-1f3fc-200d-1f3a8",
        "1f9d1-1f3fd-200d-1f3a8",
        "1f9d1-1f3fe-200d-1f3a8",
        "1f9d1-1f3ff-200d-1f3a8"
      ],
      a: "12.1"
    },
    {
      n: ["homme artiste", "artiste-homme"],
      u: "1f468-200d-1f3a8",
      v: [
        "1f468-1f3fb-200d-1f3a8",
        "1f468-1f3fc-200d-1f3a8",
        "1f468-1f3fd-200d-1f3a8",
        "1f468-1f3fe-200d-1f3a8",
        "1f468-1f3ff-200d-1f3a8"
      ],
      a: "4.0"
    },
    {
      n: ["femme artiste", "artiste féminine"],
      u: "1f469-200d-1f3a8",
      v: [
        "1f469-1f3fb-200d-1f3a8",
        "1f469-1f3fc-200d-1f3a8",
        "1f469-1f3fd-200d-1f3a8",
        "1f469-1f3fe-200d-1f3a8",
        "1f469-1f3ff-200d-1f3a8"
      ],
      a: "4.0"
    },
    {
      n: ["pilote"],
      u: "1f9d1-200d-2708-fe0f",
      v: [
        "1f9d1-1f3fb-200d-2708-fe0f",
        "1f9d1-1f3fc-200d-2708-fe0f",
        "1f9d1-1f3fd-200d-2708-fe0f",
        "1f9d1-1f3fe-200d-2708-fe0f",
        "1f9d1-1f3ff-200d-2708-fe0f"
      ],
      a: "12.1"
    },
    {
      n: ["homme pilote", "pilote masculin"],
      u: "1f468-200d-2708-fe0f",
      v: [
        "1f468-1f3fb-200d-2708-fe0f",
        "1f468-1f3fc-200d-2708-fe0f",
        "1f468-1f3fd-200d-2708-fe0f",
        "1f468-1f3fe-200d-2708-fe0f",
        "1f468-1f3ff-200d-2708-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme pilote", "femme-pilote"],
      u: "1f469-200d-2708-fe0f",
      v: [
        "1f469-1f3fb-200d-2708-fe0f",
        "1f469-1f3fc-200d-2708-fe0f",
        "1f469-1f3fd-200d-2708-fe0f",
        "1f469-1f3fe-200d-2708-fe0f",
        "1f469-1f3ff-200d-2708-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["astronaute"],
      u: "1f9d1-200d-1f680",
      v: [
        "1f9d1-1f3fb-200d-1f680",
        "1f9d1-1f3fc-200d-1f680",
        "1f9d1-1f3fd-200d-1f680",
        "1f9d1-1f3fe-200d-1f680",
        "1f9d1-1f3ff-200d-1f680"
      ],
      a: "12.1"
    },
    {
      n: ["homme astronaute", "astronaute masculin"],
      u: "1f468-200d-1f680",
      v: [
        "1f468-1f3fb-200d-1f680",
        "1f468-1f3fc-200d-1f680",
        "1f468-1f3fd-200d-1f680",
        "1f468-1f3fe-200d-1f680",
        "1f468-1f3ff-200d-1f680"
      ],
      a: "4.0"
    },
    {
      n: ["femme astronaute", "femme-astronaute"],
      u: "1f469-200d-1f680",
      v: [
        "1f469-1f3fb-200d-1f680",
        "1f469-1f3fc-200d-1f680",
        "1f469-1f3fd-200d-1f680",
        "1f469-1f3fe-200d-1f680",
        "1f469-1f3ff-200d-1f680"
      ],
      a: "4.0"
    },
    {
      n: ["pompier"],
      u: "1f9d1-200d-1f692",
      v: [
        "1f9d1-1f3fb-200d-1f692",
        "1f9d1-1f3fc-200d-1f692",
        "1f9d1-1f3fd-200d-1f692",
        "1f9d1-1f3fe-200d-1f692",
        "1f9d1-1f3ff-200d-1f692"
      ],
      a: "12.1"
    },
    {
      n: ["homme pompier", "pompier-homme"],
      u: "1f468-200d-1f692",
      v: [
        "1f468-1f3fb-200d-1f692",
        "1f468-1f3fc-200d-1f692",
        "1f468-1f3fd-200d-1f692",
        "1f468-1f3fe-200d-1f692",
        "1f468-1f3ff-200d-1f692"
      ],
      a: "4.0"
    },
    {
      n: ["femme pompier", "femme-pompier"],
      u: "1f469-200d-1f692",
      v: [
        "1f469-1f3fb-200d-1f692",
        "1f469-1f3fc-200d-1f692",
        "1f469-1f3fd-200d-1f692",
        "1f469-1f3fe-200d-1f692",
        "1f469-1f3ff-200d-1f692"
      ],
      a: "4.0"
    },
    {
      n: ["flic", "policier"],
      u: "1f46e",
      v: [
        "1f46e-1f3fb",
        "1f46e-1f3fc",
        "1f46e-1f3fd",
        "1f46e-1f3fe",
        "1f46e-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme policier", "homme-policier"],
      u: "1f46e-200d-2642-fe0f",
      v: [
        "1f46e-1f3fb-200d-2642-fe0f",
        "1f46e-1f3fc-200d-2642-fe0f",
        "1f46e-1f3fd-200d-2642-fe0f",
        "1f46e-1f3fe-200d-2642-fe0f",
        "1f46e-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme policier", "femme-policier"],
      u: "1f46e-200d-2640-fe0f",
      v: [
        "1f46e-1f3fb-200d-2640-fe0f",
        "1f46e-1f3fc-200d-2640-fe0f",
        "1f46e-1f3fd-200d-2640-fe0f",
        "1f46e-1f3fe-200d-2640-fe0f",
        "1f46e-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["détective", "détective ou espion"],
      u: "1f575-fe0f",
      v: [
        "1f575-1f3fb",
        "1f575-1f3fc",
        "1f575-1f3fd",
        "1f575-1f3fe",
        "1f575-1f3ff"
      ],
      a: "0.7"
    },
    {
      n: ["homme détective", "détective masculin"],
      u: "1f575-fe0f-200d-2642-fe0f",
      v: [
        "1f575-1f3fb-200d-2642-fe0f",
        "1f575-1f3fc-200d-2642-fe0f",
        "1f575-1f3fd-200d-2642-fe0f",
        "1f575-1f3fe-200d-2642-fe0f",
        "1f575-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme détective", "femme-détective"],
      u: "1f575-fe0f-200d-2640-fe0f",
      v: [
        "1f575-1f3fb-200d-2640-fe0f",
        "1f575-1f3fc-200d-2640-fe0f",
        "1f575-1f3fd-200d-2640-fe0f",
        "1f575-1f3fe-200d-2640-fe0f",
        "1f575-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["garde"],
      u: "1f482",
      v: [
        "1f482-1f3fb",
        "1f482-1f3fc",
        "1f482-1f3fd",
        "1f482-1f3fe",
        "1f482-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["garde homme", "garde-homme"],
      u: "1f482-200d-2642-fe0f",
      v: [
        "1f482-1f3fb-200d-2642-fe0f",
        "1f482-1f3fc-200d-2642-fe0f",
        "1f482-1f3fd-200d-2642-fe0f",
        "1f482-1f3fe-200d-2642-fe0f",
        "1f482-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme garde", "garde-femme"],
      u: "1f482-200d-2640-fe0f",
      v: [
        "1f482-1f3fb-200d-2640-fe0f",
        "1f482-1f3fc-200d-2640-fe0f",
        "1f482-1f3fd-200d-2640-fe0f",
        "1f482-1f3fe-200d-2640-fe0f",
        "1f482-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["ninja"],
      u: "1f977",
      v: [
        "1f977-1f3fb",
        "1f977-1f3fc",
        "1f977-1f3fd",
        "1f977-1f3fe",
        "1f977-1f3ff"
      ],
      a: "13.0"
    },
    {
      n: ["ouvrier du batiment"],
      u: "1f477",
      v: [
        "1f477-1f3fb",
        "1f477-1f3fc",
        "1f477-1f3fd",
        "1f477-1f3fe",
        "1f477-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme ouvrier du bâtiment", "ouvrier du bâtiment"],
      u: "1f477-200d-2642-fe0f",
      v: [
        "1f477-1f3fb-200d-2642-fe0f",
        "1f477-1f3fc-200d-2642-fe0f",
        "1f477-1f3fd-200d-2642-fe0f",
        "1f477-1f3fe-200d-2642-fe0f",
        "1f477-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme, ouvrier du bâtiment", "ouvrière-du-construction"],
      u: "1f477-200d-2640-fe0f",
      v: [
        "1f477-1f3fb-200d-2640-fe0f",
        "1f477-1f3fc-200d-2640-fe0f",
        "1f477-1f3fd-200d-2640-fe0f",
        "1f477-1f3fe-200d-2640-fe0f",
        "1f477-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["personne avec une couronne"],
      u: "1fac5",
      v: [
        "1fac5-1f3fb",
        "1fac5-1f3fc",
        "1fac5-1f3fd",
        "1fac5-1f3fe",
        "1fac5-1f3ff"
      ],
      a: "14.0"
    },
    {
      n: ["prince"],
      u: "1f934",
      v: [
        "1f934-1f3fb",
        "1f934-1f3fc",
        "1f934-1f3fd",
        "1f934-1f3fe",
        "1f934-1f3ff"
      ],
      a: "3.0"
    },
    {
      n: ["princesse"],
      u: "1f478",
      v: [
        "1f478-1f3fb",
        "1f478-1f3fc",
        "1f478-1f3fd",
        "1f478-1f3fe",
        "1f478-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme au turban"],
      u: "1f473",
      v: [
        "1f473-1f3fb",
        "1f473-1f3fc",
        "1f473-1f3fd",
        "1f473-1f3fe",
        "1f473-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme portant un turban", "homme-portant-un-turban"],
      u: "1f473-200d-2642-fe0f",
      v: [
        "1f473-1f3fb-200d-2642-fe0f",
        "1f473-1f3fc-200d-2642-fe0f",
        "1f473-1f3fd-200d-2642-fe0f",
        "1f473-1f3fe-200d-2642-fe0f",
        "1f473-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme portant un turban", "femme-portant-un-turban"],
      u: "1f473-200d-2640-fe0f",
      v: [
        "1f473-1f3fb-200d-2640-fe0f",
        "1f473-1f3fc-200d-2640-fe0f",
        "1f473-1f3fd-200d-2640-fe0f",
        "1f473-1f3fe-200d-2640-fe0f",
        "1f473-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["homme avec gua pi mao"],
      u: "1f472",
      v: [
        "1f472-1f3fb",
        "1f472-1f3fc",
        "1f472-1f3fd",
        "1f472-1f3fe",
        "1f472-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["personne avec un foulard"],
      u: "1f9d5",
      v: [
        "1f9d5-1f3fb",
        "1f9d5-1f3fc",
        "1f9d5-1f3fd",
        "1f9d5-1f3fe",
        "1f9d5-1f3ff"
      ],
      a: "5.0"
    },
    {
      n: ["homme en smoking", "personne en smoking"],
      u: "1f935",
      v: [
        "1f935-1f3fb",
        "1f935-1f3fc",
        "1f935-1f3fd",
        "1f935-1f3fe",
        "1f935-1f3ff"
      ],
      a: "3.0"
    },
    {
      n: ["homme en smoking"],
      u: "1f935-200d-2642-fe0f",
      v: [
        "1f935-1f3fb-200d-2642-fe0f",
        "1f935-1f3fc-200d-2642-fe0f",
        "1f935-1f3fd-200d-2642-fe0f",
        "1f935-1f3fe-200d-2642-fe0f",
        "1f935-1f3ff-200d-2642-fe0f"
      ],
      a: "13.0"
    },
    {
      n: ["femme en smoking"],
      u: "1f935-200d-2640-fe0f",
      v: [
        "1f935-1f3fb-200d-2640-fe0f",
        "1f935-1f3fc-200d-2640-fe0f",
        "1f935-1f3fd-200d-2640-fe0f",
        "1f935-1f3fe-200d-2640-fe0f",
        "1f935-1f3ff-200d-2640-fe0f"
      ],
      a: "13.0"
    },
    {
      n: ["mariée avec voile"],
      u: "1f470",
      v: [
        "1f470-1f3fb",
        "1f470-1f3fc",
        "1f470-1f3fd",
        "1f470-1f3fe",
        "1f470-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme avec voile"],
      u: "1f470-200d-2642-fe0f",
      v: [
        "1f470-1f3fb-200d-2642-fe0f",
        "1f470-1f3fc-200d-2642-fe0f",
        "1f470-1f3fd-200d-2642-fe0f",
        "1f470-1f3fe-200d-2642-fe0f",
        "1f470-1f3ff-200d-2642-fe0f"
      ],
      a: "13.0"
    },
    {
      n: ["femme avec voile"],
      u: "1f470-200d-2640-fe0f",
      v: [
        "1f470-1f3fb-200d-2640-fe0f",
        "1f470-1f3fc-200d-2640-fe0f",
        "1f470-1f3fd-200d-2640-fe0f",
        "1f470-1f3fe-200d-2640-fe0f",
        "1f470-1f3ff-200d-2640-fe0f"
      ],
      a: "13.0"
    },
    {
      n: ["femme enceinte"],
      u: "1f930",
      v: [
        "1f930-1f3fb",
        "1f930-1f3fc",
        "1f930-1f3fd",
        "1f930-1f3fe",
        "1f930-1f3ff"
      ],
      a: "3.0"
    },
    {
      n: ["homme enceinte"],
      u: "1fac3",
      v: [
        "1fac3-1f3fb",
        "1fac3-1f3fc",
        "1fac3-1f3fd",
        "1fac3-1f3fe",
        "1fac3-1f3ff"
      ],
      a: "14.0"
    },
    {
      n: ["personne enceinte"],
      u: "1fac4",
      v: [
        "1fac4-1f3fb",
        "1fac4-1f3fc",
        "1fac4-1f3fd",
        "1fac4-1f3fe",
        "1fac4-1f3ff"
      ],
      a: "14.0"
    },
    {
      n: ["allaitement maternel"],
      u: "1f931",
      v: [
        "1f931-1f3fb",
        "1f931-1f3fc",
        "1f931-1f3fd",
        "1f931-1f3fe",
        "1f931-1f3ff"
      ],
      a: "5.0"
    },
    {
      n: ["femme nourrissant bébé"],
      u: "1f469-200d-1f37c",
      v: [
        "1f469-1f3fb-200d-1f37c",
        "1f469-1f3fc-200d-1f37c",
        "1f469-1f3fd-200d-1f37c",
        "1f469-1f3fe-200d-1f37c",
        "1f469-1f3ff-200d-1f37c"
      ],
      a: "13.0"
    },
    {
      n: ["homme nourrissant bébé"],
      u: "1f468-200d-1f37c",
      v: [
        "1f468-1f3fb-200d-1f37c",
        "1f468-1f3fc-200d-1f37c",
        "1f468-1f3fd-200d-1f37c",
        "1f468-1f3fe-200d-1f37c",
        "1f468-1f3ff-200d-1f37c"
      ],
      a: "13.0"
    },
    {
      n: ["personne qui nourrit bébé"],
      u: "1f9d1-200d-1f37c",
      v: [
        "1f9d1-1f3fb-200d-1f37c",
        "1f9d1-1f3fc-200d-1f37c",
        "1f9d1-1f3fd-200d-1f37c",
        "1f9d1-1f3fe-200d-1f37c",
        "1f9d1-1f3ff-200d-1f37c"
      ],
      a: "13.0"
    },
    {
      n: ["ange", "bébé ange"],
      u: "1f47c",
      v: [
        "1f47c-1f3fb",
        "1f47c-1f3fc",
        "1f47c-1f3fd",
        "1f47c-1f3fe",
        "1f47c-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["père Noël", "père Noël"],
      u: "1f385",
      v: [
        "1f385-1f3fb",
        "1f385-1f3fc",
        "1f385-1f3fd",
        "1f385-1f3fe",
        "1f385-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["Mme Noël", "mère Noël"],
      u: "1f936",
      v: [
        "1f936-1f3fb",
        "1f936-1f3fc",
        "1f936-1f3fd",
        "1f936-1f3fe",
        "1f936-1f3ff"
      ],
      a: "3.0"
    },
    {
      n: ["Noël Noël"],
      u: "1f9d1-200d-1f384",
      v: [
        "1f9d1-1f3fb-200d-1f384",
        "1f9d1-1f3fc-200d-1f384",
        "1f9d1-1f3fd-200d-1f384",
        "1f9d1-1f3fe-200d-1f384",
        "1f9d1-1f3ff-200d-1f384"
      ],
      a: "13.0"
    },
    {
      n: ["super-héros"],
      u: "1f9b8",
      v: [
        "1f9b8-1f3fb",
        "1f9b8-1f3fc",
        "1f9b8-1f3fd",
        "1f9b8-1f3fe",
        "1f9b8-1f3ff"
      ],
      a: "11.0"
    },
    {
      n: ["homme super-héros", "super-héros masculin"],
      u: "1f9b8-200d-2642-fe0f",
      v: [
        "1f9b8-1f3fb-200d-2642-fe0f",
        "1f9b8-1f3fc-200d-2642-fe0f",
        "1f9b8-1f3fd-200d-2642-fe0f",
        "1f9b8-1f3fe-200d-2642-fe0f",
        "1f9b8-1f3ff-200d-2642-fe0f"
      ],
      a: "11.0"
    },
    {
      n: ["femme super-héros", "super-héros féminin"],
      u: "1f9b8-200d-2640-fe0f",
      v: [
        "1f9b8-1f3fb-200d-2640-fe0f",
        "1f9b8-1f3fc-200d-2640-fe0f",
        "1f9b8-1f3fd-200d-2640-fe0f",
        "1f9b8-1f3fe-200d-2640-fe0f",
        "1f9b8-1f3ff-200d-2640-fe0f"
      ],
      a: "11.0"
    },
    {
      n: ["super-vilain"],
      u: "1f9b9",
      v: [
        "1f9b9-1f3fb",
        "1f9b9-1f3fc",
        "1f9b9-1f3fd",
        "1f9b9-1f3fe",
        "1f9b9-1f3ff"
      ],
      a: "11.0"
    },
    {
      n: ["homme super-vilain", "super-vilain masculin"],
      u: "1f9b9-200d-2642-fe0f",
      v: [
        "1f9b9-1f3fb-200d-2642-fe0f",
        "1f9b9-1f3fc-200d-2642-fe0f",
        "1f9b9-1f3fd-200d-2642-fe0f",
        "1f9b9-1f3fe-200d-2642-fe0f",
        "1f9b9-1f3ff-200d-2642-fe0f"
      ],
      a: "11.0"
    },
    {
      n: ["femme super-vilain", "super-vilain féminin"],
      u: "1f9b9-200d-2640-fe0f",
      v: [
        "1f9b9-1f3fb-200d-2640-fe0f",
        "1f9b9-1f3fc-200d-2640-fe0f",
        "1f9b9-1f3fd-200d-2640-fe0f",
        "1f9b9-1f3fe-200d-2640-fe0f",
        "1f9b9-1f3ff-200d-2640-fe0f"
      ],
      a: "11.0"
    },
    {
      n: ["magicien"],
      u: "1f9d9",
      v: [
        "1f9d9-1f3fb",
        "1f9d9-1f3fc",
        "1f9d9-1f3fd",
        "1f9d9-1f3fe",
        "1f9d9-1f3ff"
      ],
      a: "5.0"
    },
    {
      n: ["homme mage", "mage masculin"],
      u: "1f9d9-200d-2642-fe0f",
      v: [
        "1f9d9-1f3fb-200d-2642-fe0f",
        "1f9d9-1f3fc-200d-2642-fe0f",
        "1f9d9-1f3fd-200d-2642-fe0f",
        "1f9d9-1f3fe-200d-2642-fe0f",
        "1f9d9-1f3ff-200d-2642-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["femme mage", "mage féminine"],
      u: "1f9d9-200d-2640-fe0f",
      v: [
        "1f9d9-1f3fb-200d-2640-fe0f",
        "1f9d9-1f3fc-200d-2640-fe0f",
        "1f9d9-1f3fd-200d-2640-fe0f",
        "1f9d9-1f3fe-200d-2640-fe0f",
        "1f9d9-1f3ff-200d-2640-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["fée"],
      u: "1f9da",
      v: [
        "1f9da-1f3fb",
        "1f9da-1f3fc",
        "1f9da-1f3fd",
        "1f9da-1f3fe",
        "1f9da-1f3ff"
      ],
      a: "5.0"
    },
    {
      n: ["homme fée", "fée mâle"],
      u: "1f9da-200d-2642-fe0f",
      v: [
        "1f9da-1f3fb-200d-2642-fe0f",
        "1f9da-1f3fc-200d-2642-fe0f",
        "1f9da-1f3fd-200d-2642-fe0f",
        "1f9da-1f3fe-200d-2642-fe0f",
        "1f9da-1f3ff-200d-2642-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["femme fée", "fée féminine"],
      u: "1f9da-200d-2640-fe0f",
      v: [
        "1f9da-1f3fb-200d-2640-fe0f",
        "1f9da-1f3fc-200d-2640-fe0f",
        "1f9da-1f3fd-200d-2640-fe0f",
        "1f9da-1f3fe-200d-2640-fe0f",
        "1f9da-1f3ff-200d-2640-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["vampire"],
      u: "1f9db",
      v: [
        "1f9db-1f3fb",
        "1f9db-1f3fc",
        "1f9db-1f3fd",
        "1f9db-1f3fe",
        "1f9db-1f3ff"
      ],
      a: "5.0"
    },
    {
      n: ["homme, vampire", "vampire mâle"],
      u: "1f9db-200d-2642-fe0f",
      v: [
        "1f9db-1f3fb-200d-2642-fe0f",
        "1f9db-1f3fc-200d-2642-fe0f",
        "1f9db-1f3fd-200d-2642-fe0f",
        "1f9db-1f3fe-200d-2642-fe0f",
        "1f9db-1f3ff-200d-2642-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["femme vampire", "femme vampire"],
      u: "1f9db-200d-2640-fe0f",
      v: [
        "1f9db-1f3fb-200d-2640-fe0f",
        "1f9db-1f3fc-200d-2640-fe0f",
        "1f9db-1f3fd-200d-2640-fe0f",
        "1f9db-1f3fe-200d-2640-fe0f",
        "1f9db-1f3ff-200d-2640-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["triton"],
      u: "1f9dc",
      v: [
        "1f9dc-1f3fb",
        "1f9dc-1f3fc",
        "1f9dc-1f3fd",
        "1f9dc-1f3fe",
        "1f9dc-1f3ff"
      ],
      a: "5.0"
    },
    {
      n: ["triton"],
      u: "1f9dc-200d-2642-fe0f",
      v: [
        "1f9dc-1f3fb-200d-2642-fe0f",
        "1f9dc-1f3fc-200d-2642-fe0f",
        "1f9dc-1f3fd-200d-2642-fe0f",
        "1f9dc-1f3fe-200d-2642-fe0f",
        "1f9dc-1f3ff-200d-2642-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["sirène"],
      u: "1f9dc-200d-2640-fe0f",
      v: [
        "1f9dc-1f3fb-200d-2640-fe0f",
        "1f9dc-1f3fc-200d-2640-fe0f",
        "1f9dc-1f3fd-200d-2640-fe0f",
        "1f9dc-1f3fe-200d-2640-fe0f",
        "1f9dc-1f3ff-200d-2640-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["elfe"],
      u: "1f9dd",
      v: [
        "1f9dd-1f3fb",
        "1f9dd-1f3fc",
        "1f9dd-1f3fd",
        "1f9dd-1f3fe",
        "1f9dd-1f3ff"
      ],
      a: "5.0"
    },
    {
      n: ["homme elfe", "elfe mâle"],
      u: "1f9dd-200d-2642-fe0f",
      v: [
        "1f9dd-1f3fb-200d-2642-fe0f",
        "1f9dd-1f3fc-200d-2642-fe0f",
        "1f9dd-1f3fd-200d-2642-fe0f",
        "1f9dd-1f3fe-200d-2642-fe0f",
        "1f9dd-1f3ff-200d-2642-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["femme elfe", "elfe femelle"],
      u: "1f9dd-200d-2640-fe0f",
      v: [
        "1f9dd-1f3fb-200d-2640-fe0f",
        "1f9dd-1f3fc-200d-2640-fe0f",
        "1f9dd-1f3fd-200d-2640-fe0f",
        "1f9dd-1f3fe-200d-2640-fe0f",
        "1f9dd-1f3ff-200d-2640-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["génie"],
      u: "1f9de",
      a: "5.0"
    },
    {
      n: ["homme génie", "génie masculin"],
      u: "1f9de-200d-2642-fe0f",
      a: "5.0"
    },
    {
      n: ["femme génie", "génie féminin"],
      u: "1f9de-200d-2640-fe0f",
      a: "5.0"
    },
    {
      n: ["zombi"],
      u: "1f9df",
      a: "5.0"
    },
    {
      n: ["homme zombie", "zombie mâle"],
      u: "1f9df-200d-2642-fe0f",
      a: "5.0"
    },
    {
      n: ["femme zombie", "femme zombie"],
      u: "1f9df-200d-2640-fe0f",
      a: "5.0"
    },
    {
      n: ["troll"],
      u: "1f9cc",
      a: "14.0"
    },
    { n: ["créature poilue"], u: "1fac8", a: "17.0" },
    {
      n: ["massage", "massage du visage"],
      u: "1f486",
      v: [
        "1f486-1f3fb",
        "1f486-1f3fc",
        "1f486-1f3fd",
        "1f486-1f3fe",
        "1f486-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme se faisant masser", "homme-obtenant-massage"],
      u: "1f486-200d-2642-fe0f",
      v: [
        "1f486-1f3fb-200d-2642-fe0f",
        "1f486-1f3fc-200d-2642-fe0f",
        "1f486-1f3fd-200d-2642-fe0f",
        "1f486-1f3fe-200d-2642-fe0f",
        "1f486-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme se faisant masser", "femme-recevant-massage"],
      u: "1f486-200d-2640-fe0f",
      v: [
        "1f486-1f3fb-200d-2640-fe0f",
        "1f486-1f3fc-200d-2640-fe0f",
        "1f486-1f3fd-200d-2640-fe0f",
        "1f486-1f3fe-200d-2640-fe0f",
        "1f486-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["coupe de cheveux"],
      u: "1f487",
      v: [
        "1f487-1f3fb",
        "1f487-1f3fc",
        "1f487-1f3fd",
        "1f487-1f3fe",
        "1f487-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: [
        "homme se faisant couper les cheveux",
        "homme-se faire couper les cheveux"
      ],
      u: "1f487-200d-2642-fe0f",
      v: [
        "1f487-1f3fb-200d-2642-fe0f",
        "1f487-1f3fc-200d-2642-fe0f",
        "1f487-1f3fd-200d-2642-fe0f",
        "1f487-1f3fe-200d-2642-fe0f",
        "1f487-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: [
        "femme se faisant couper les cheveux",
        "femme-se faire couper les cheveux"
      ],
      u: "1f487-200d-2640-fe0f",
      v: [
        "1f487-1f3fb-200d-2640-fe0f",
        "1f487-1f3fc-200d-2640-fe0f",
        "1f487-1f3fd-200d-2640-fe0f",
        "1f487-1f3fe-200d-2640-fe0f",
        "1f487-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["marche", "piéton"],
      u: "1f6b6",
      v: [
        "1f6b6-1f3fb",
        "1f6b6-1f3fc",
        "1f6b6-1f3fd",
        "1f6b6-1f3fe",
        "1f6b6-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme qui marche", "homme qui marche"],
      u: "1f6b6-200d-2642-fe0f",
      v: [
        "1f6b6-1f3fb-200d-2642-fe0f",
        "1f6b6-1f3fc-200d-2642-fe0f",
        "1f6b6-1f3fd-200d-2642-fe0f",
        "1f6b6-1f3fe-200d-2642-fe0f",
        "1f6b6-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme qui marche", "femme qui marche"],
      u: "1f6b6-200d-2640-fe0f",
      v: [
        "1f6b6-1f3fb-200d-2640-fe0f",
        "1f6b6-1f3fc-200d-2640-fe0f",
        "1f6b6-1f3fd-200d-2640-fe0f",
        "1f6b6-1f3fe-200d-2640-fe0f",
        "1f6b6-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["personne debout"],
      u: "1f9cd",
      v: [
        "1f9cd-1f3fb",
        "1f9cd-1f3fc",
        "1f9cd-1f3fd",
        "1f9cd-1f3fe",
        "1f9cd-1f3ff"
      ],
      a: "12.0"
    },
    {
      n: ["homme debout"],
      u: "1f9cd-200d-2642-fe0f",
      v: [
        "1f9cd-1f3fb-200d-2642-fe0f",
        "1f9cd-1f3fc-200d-2642-fe0f",
        "1f9cd-1f3fd-200d-2642-fe0f",
        "1f9cd-1f3fe-200d-2642-fe0f",
        "1f9cd-1f3ff-200d-2642-fe0f"
      ],
      a: "12.0"
    },
    {
      n: ["femme debout"],
      u: "1f9cd-200d-2640-fe0f",
      v: [
        "1f9cd-1f3fb-200d-2640-fe0f",
        "1f9cd-1f3fc-200d-2640-fe0f",
        "1f9cd-1f3fd-200d-2640-fe0f",
        "1f9cd-1f3fe-200d-2640-fe0f",
        "1f9cd-1f3ff-200d-2640-fe0f"
      ],
      a: "12.0"
    },
    {
      n: ["personne agenouillée"],
      u: "1f9ce",
      v: [
        "1f9ce-1f3fb",
        "1f9ce-1f3fc",
        "1f9ce-1f3fd",
        "1f9ce-1f3fe",
        "1f9ce-1f3ff"
      ],
      a: "12.0"
    },
    {
      n: ["homme agenouillé"],
      u: "1f9ce-200d-2642-fe0f",
      v: [
        "1f9ce-1f3fb-200d-2642-fe0f",
        "1f9ce-1f3fc-200d-2642-fe0f",
        "1f9ce-1f3fd-200d-2642-fe0f",
        "1f9ce-1f3fe-200d-2642-fe0f",
        "1f9ce-1f3ff-200d-2642-fe0f"
      ],
      a: "12.0"
    },
    {
      n: ["femme agenouillée"],
      u: "1f9ce-200d-2640-fe0f",
      v: [
        "1f9ce-1f3fb-200d-2640-fe0f",
        "1f9ce-1f3fc-200d-2640-fe0f",
        "1f9ce-1f3fd-200d-2640-fe0f",
        "1f9ce-1f3fe-200d-2640-fe0f",
        "1f9ce-1f3ff-200d-2640-fe0f"
      ],
      a: "12.0"
    },
    {
      n: [
        "personne avec une canne blanche",
        "personne avec une canne de sondage"
      ],
      u: "1f9d1-200d-1f9af",
      v: [
        "1f9d1-1f3fb-200d-1f9af",
        "1f9d1-1f3fc-200d-1f9af",
        "1f9d1-1f3fd-200d-1f9af",
        "1f9d1-1f3fe-200d-1f9af",
        "1f9d1-1f3ff-200d-1f9af"
      ],
      a: "12.1"
    },
    {
      n: ["homme avec une canne blanche", "homme avec canne de sondage"],
      u: "1f468-200d-1f9af",
      v: [
        "1f468-1f3fb-200d-1f9af",
        "1f468-1f3fc-200d-1f9af",
        "1f468-1f3fd-200d-1f9af",
        "1f468-1f3fe-200d-1f9af",
        "1f468-1f3ff-200d-1f9af"
      ],
      a: "12.0"
    },
    {
      n: ["femme avec canne blanche", "femme avec canne de sondage"],
      u: "1f469-200d-1f9af",
      v: [
        "1f469-1f3fb-200d-1f9af",
        "1f469-1f3fc-200d-1f9af",
        "1f469-1f3fd-200d-1f9af",
        "1f469-1f3fe-200d-1f9af",
        "1f469-1f3ff-200d-1f9af"
      ],
      a: "12.0"
    },
    {
      n: ["personne en fauteuil roulant motorisé"],
      u: "1f9d1-200d-1f9bc",
      v: [
        "1f9d1-1f3fb-200d-1f9bc",
        "1f9d1-1f3fc-200d-1f9bc",
        "1f9d1-1f3fd-200d-1f9bc",
        "1f9d1-1f3fe-200d-1f9bc",
        "1f9d1-1f3ff-200d-1f9bc"
      ],
      a: "12.1"
    },
    {
      n: ["homme en fauteuil roulant motorisé"],
      u: "1f468-200d-1f9bc",
      v: [
        "1f468-1f3fb-200d-1f9bc",
        "1f468-1f3fc-200d-1f9bc",
        "1f468-1f3fd-200d-1f9bc",
        "1f468-1f3fe-200d-1f9bc",
        "1f468-1f3ff-200d-1f9bc"
      ],
      a: "12.0"
    },
    {
      n: ["femme en fauteuil roulant motorisé"],
      u: "1f469-200d-1f9bc",
      v: [
        "1f469-1f3fb-200d-1f9bc",
        "1f469-1f3fc-200d-1f9bc",
        "1f469-1f3fd-200d-1f9bc",
        "1f469-1f3fe-200d-1f9bc",
        "1f469-1f3ff-200d-1f9bc"
      ],
      a: "12.0"
    },
    {
      n: ["personne en fauteuil roulant manuel"],
      u: "1f9d1-200d-1f9bd",
      v: [
        "1f9d1-1f3fb-200d-1f9bd",
        "1f9d1-1f3fc-200d-1f9bd",
        "1f9d1-1f3fd-200d-1f9bd",
        "1f9d1-1f3fe-200d-1f9bd",
        "1f9d1-1f3ff-200d-1f9bd"
      ],
      a: "12.1"
    },
    {
      n: ["homme en fauteuil roulant manuel"],
      u: "1f468-200d-1f9bd",
      v: [
        "1f468-1f3fb-200d-1f9bd",
        "1f468-1f3fc-200d-1f9bd",
        "1f468-1f3fd-200d-1f9bd",
        "1f468-1f3fe-200d-1f9bd",
        "1f468-1f3ff-200d-1f9bd"
      ],
      a: "12.0"
    },
    {
      n: ["femme en fauteuil roulant manuel"],
      u: "1f469-200d-1f9bd",
      v: [
        "1f469-1f3fb-200d-1f9bd",
        "1f469-1f3fc-200d-1f9bd",
        "1f469-1f3fd-200d-1f9bd",
        "1f469-1f3fe-200d-1f9bd",
        "1f469-1f3ff-200d-1f9bd"
      ],
      a: "12.0"
    },
    {
      n: ["coureur", "en cours d'exécution"],
      u: "1f3c3",
      v: [
        "1f3c3-1f3fb",
        "1f3c3-1f3fc",
        "1f3c3-1f3fd",
        "1f3c3-1f3fe",
        "1f3c3-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme qui court", "homme qui court"],
      u: "1f3c3-200d-2642-fe0f",
      v: [
        "1f3c3-1f3fb-200d-2642-fe0f",
        "1f3c3-1f3fc-200d-2642-fe0f",
        "1f3c3-1f3fd-200d-2642-fe0f",
        "1f3c3-1f3fe-200d-2642-fe0f",
        "1f3c3-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme qui court", "femme qui court"],
      u: "1f3c3-200d-2640-fe0f",
      v: [
        "1f3c3-1f3fb-200d-2640-fe0f",
        "1f3c3-1f3fc-200d-2640-fe0f",
        "1f3c3-1f3fd-200d-2640-fe0f",
        "1f3c3-1f3fe-200d-2640-fe0f",
        "1f3c3-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["danseur"],
      u: "1f483",
      v: [
        "1f483-1f3fb",
        "1f483-1f3fc",
        "1f483-1f3fd",
        "1f483-1f3fe",
        "1f483-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme qui danse"],
      u: "1f57a",
      v: [
        "1f57a-1f3fb",
        "1f57a-1f3fc",
        "1f57a-1f3fd",
        "1f57a-1f3fe",
        "1f57a-1f3ff"
      ],
      a: "3.0"
    },
    {
      n: ["danseur de ballet", "danseuse de ballet"],
      u: "1f9d1-200d-1fa70",
      v: [
        "1f9d1-1f3fb-200d-1fa70",
        "1f9d1-1f3fc-200d-1fa70",
        "1f9d1-1f3fd-200d-1fa70",
        "1f9d1-1f3fe-200d-1fa70",
        "1f9d1-1f3ff-200d-1fa70"
      ],
      a: "17.0"
    },
    {
      n: [
        "personne en costume en lévitation",
        "homme en costume d'affaires en lévitation"
      ],
      u: "1f574-fe0f",
      v: [
        "1f574-1f3fb",
        "1f574-1f3fc",
        "1f574-1f3fd",
        "1f574-1f3fe",
        "1f574-1f3ff"
      ],
      a: "0.7"
    },
    {
      n: ["danseurs", "femme avec des oreilles de lapin"],
      u: "1f46f",
      a: "0.6"
    },
    {
      n: [
        "hommes avec des oreilles de lapin",
        "hommes-avec-oreilles-de-lapin-faire la fête",
        "homme-aux-oreilles-de-lapin-faire la fête"
      ],
      u: "1f46f-200d-2642-fe0f",
      a: "4.0"
    },
    {
      n: [
        "femmes avec des oreilles de lapin",
        "femmes-avec-oreilles-de-lapin-faire la fête",
        "femme-aux-oreilles-de-lapin-faire la fête"
      ],
      u: "1f46f-200d-2640-fe0f",
      a: "4.0"
    },
    {
      n: ["personne dans un hammam"],
      u: "1f9d6",
      v: [
        "1f9d6-1f3fb",
        "1f9d6-1f3fc",
        "1f9d6-1f3fd",
        "1f9d6-1f3fe",
        "1f9d6-1f3ff"
      ],
      a: "5.0"
    },
    {
      n: ["homme dans une pièce hammamée"],
      u: "1f9d6-200d-2642-fe0f",
      v: [
        "1f9d6-1f3fb-200d-2642-fe0f",
        "1f9d6-1f3fc-200d-2642-fe0f",
        "1f9d6-1f3fd-200d-2642-fe0f",
        "1f9d6-1f3fe-200d-2642-fe0f",
        "1f9d6-1f3ff-200d-2642-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["femme dans un hammam"],
      u: "1f9d6-200d-2640-fe0f",
      v: [
        "1f9d6-1f3fb-200d-2640-fe0f",
        "1f9d6-1f3fc-200d-2640-fe0f",
        "1f9d6-1f3fd-200d-2640-fe0f",
        "1f9d6-1f3fe-200d-2640-fe0f",
        "1f9d6-1f3ff-200d-2640-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["personne qui grimpe"],
      u: "1f9d7",
      v: [
        "1f9d7-1f3fb",
        "1f9d7-1f3fc",
        "1f9d7-1f3fd",
        "1f9d7-1f3fe",
        "1f9d7-1f3ff"
      ],
      a: "5.0"
    },
    {
      n: ["homme qui grimpe"],
      u: "1f9d7-200d-2642-fe0f",
      v: [
        "1f9d7-1f3fb-200d-2642-fe0f",
        "1f9d7-1f3fc-200d-2642-fe0f",
        "1f9d7-1f3fd-200d-2642-fe0f",
        "1f9d7-1f3fe-200d-2642-fe0f",
        "1f9d7-1f3ff-200d-2642-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["femme escalade"],
      u: "1f9d7-200d-2640-fe0f",
      v: [
        "1f9d7-1f3fb-200d-2640-fe0f",
        "1f9d7-1f3fc-200d-2640-fe0f",
        "1f9d7-1f3fd-200d-2640-fe0f",
        "1f9d7-1f3fe-200d-2640-fe0f",
        "1f9d7-1f3ff-200d-2640-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["escrimeur"],
      u: "1f93a",
      a: "3.0"
    },
    {
      n: ["course de chevaux"],
      u: "1f3c7",
      v: [
        "1f3c7-1f3fb",
        "1f3c7-1f3fc",
        "1f3c7-1f3fd",
        "1f3c7-1f3fe",
        "1f3c7-1f3ff"
      ],
      a: "1.0"
    },
    {
      n: ["skieur"],
      u: "26f7-fe0f",
      a: "0.7"
    },
    {
      n: ["snowboarder"],
      u: "1f3c2",
      v: [
        "1f3c2-1f3fb",
        "1f3c2-1f3fc",
        "1f3c2-1f3fd",
        "1f3c2-1f3fe",
        "1f3c2-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["golfeur", "personne jouant au golf"],
      u: "1f3cc-fe0f",
      v: [
        "1f3cc-1f3fb",
        "1f3cc-1f3fc",
        "1f3cc-1f3fd",
        "1f3cc-1f3fe",
        "1f3cc-1f3ff"
      ],
      a: "0.7"
    },
    {
      n: ["homme jouant au golf", "homme-golfeur"],
      u: "1f3cc-fe0f-200d-2642-fe0f",
      v: [
        "1f3cc-1f3fb-200d-2642-fe0f",
        "1f3cc-1f3fc-200d-2642-fe0f",
        "1f3cc-1f3fd-200d-2642-fe0f",
        "1f3cc-1f3fe-200d-2642-fe0f",
        "1f3cc-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme jouant au golf", "femme-golfant"],
      u: "1f3cc-fe0f-200d-2640-fe0f",
      v: [
        "1f3cc-1f3fb-200d-2640-fe0f",
        "1f3cc-1f3fc-200d-2640-fe0f",
        "1f3cc-1f3fd-200d-2640-fe0f",
        "1f3cc-1f3fe-200d-2640-fe0f",
        "1f3cc-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["surfeur"],
      u: "1f3c4",
      v: [
        "1f3c4-1f3fb",
        "1f3c4-1f3fc",
        "1f3c4-1f3fd",
        "1f3c4-1f3fe",
        "1f3c4-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme surfant", "homme-surf"],
      u: "1f3c4-200d-2642-fe0f",
      v: [
        "1f3c4-1f3fb-200d-2642-fe0f",
        "1f3c4-1f3fc-200d-2642-fe0f",
        "1f3c4-1f3fd-200d-2642-fe0f",
        "1f3c4-1f3fe-200d-2642-fe0f",
        "1f3c4-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme surfant", "femme-surf"],
      u: "1f3c4-200d-2640-fe0f",
      v: [
        "1f3c4-1f3fb-200d-2640-fe0f",
        "1f3c4-1f3fc-200d-2640-fe0f",
        "1f3c4-1f3fd-200d-2640-fe0f",
        "1f3c4-1f3fe-200d-2640-fe0f",
        "1f3c4-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["chaloupe"],
      u: "1f6a3",
      v: [
        "1f6a3-1f3fb",
        "1f6a3-1f3fc",
        "1f6a3-1f3fd",
        "1f6a3-1f3fe",
        "1f6a3-1f3ff"
      ],
      a: "1.0"
    },
    {
      n: ["homme, bateau à rames", "homme-aviron-bateau"],
      u: "1f6a3-200d-2642-fe0f",
      v: [
        "1f6a3-1f3fb-200d-2642-fe0f",
        "1f6a3-1f3fc-200d-2642-fe0f",
        "1f6a3-1f3fd-200d-2642-fe0f",
        "1f6a3-1f3fe-200d-2642-fe0f",
        "1f6a3-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme, bateau à rames", "femme-aviron-bateau"],
      u: "1f6a3-200d-2640-fe0f",
      v: [
        "1f6a3-1f3fb-200d-2640-fe0f",
        "1f6a3-1f3fc-200d-2640-fe0f",
        "1f6a3-1f3fd-200d-2640-fe0f",
        "1f6a3-1f3fe-200d-2640-fe0f",
        "1f6a3-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["nageur"],
      u: "1f3ca",
      v: [
        "1f3ca-1f3fb",
        "1f3ca-1f3fc",
        "1f3ca-1f3fd",
        "1f3ca-1f3fe",
        "1f3ca-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["homme nageant", "homme-nageur"],
      u: "1f3ca-200d-2642-fe0f",
      v: [
        "1f3ca-1f3fb-200d-2642-fe0f",
        "1f3ca-1f3fc-200d-2642-fe0f",
        "1f3ca-1f3fd-200d-2642-fe0f",
        "1f3ca-1f3fe-200d-2642-fe0f",
        "1f3ca-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme nageant", "femme-nageuse"],
      u: "1f3ca-200d-2640-fe0f",
      v: [
        "1f3ca-1f3fb-200d-2640-fe0f",
        "1f3ca-1f3fc-200d-2640-fe0f",
        "1f3ca-1f3fd-200d-2640-fe0f",
        "1f3ca-1f3fe-200d-2640-fe0f",
        "1f3ca-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["personne avec un ballon", "personne qui fait rebondir une balle"],
      u: "26f9-fe0f",
      v: ["26f9-1f3fb", "26f9-1f3fc", "26f9-1f3fd", "26f9-1f3fe", "26f9-1f3ff"],
      a: "0.7"
    },
    {
      n: ["homme, balle rebondissante", "homme-balle-rebondissante"],
      u: "26f9-fe0f-200d-2642-fe0f",
      v: [
        "26f9-1f3fb-200d-2642-fe0f",
        "26f9-1f3fc-200d-2642-fe0f",
        "26f9-1f3fd-200d-2642-fe0f",
        "26f9-1f3fe-200d-2642-fe0f",
        "26f9-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme, balle rebondissante", "femme-ballon-rebondissant"],
      u: "26f9-fe0f-200d-2640-fe0f",
      v: [
        "26f9-1f3fb-200d-2640-fe0f",
        "26f9-1f3fc-200d-2640-fe0f",
        "26f9-1f3fd-200d-2640-fe0f",
        "26f9-1f3fe-200d-2640-fe0f",
        "26f9-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["haltérophile", "personne qui soulève des poids"],
      u: "1f3cb-fe0f",
      v: [
        "1f3cb-1f3fb",
        "1f3cb-1f3fc",
        "1f3cb-1f3fd",
        "1f3cb-1f3fe",
        "1f3cb-1f3ff"
      ],
      a: "0.7"
    },
    {
      n: ["homme soulevant des poids", "homme-levage-de-poids"],
      u: "1f3cb-fe0f-200d-2642-fe0f",
      v: [
        "1f3cb-1f3fb-200d-2642-fe0f",
        "1f3cb-1f3fc-200d-2642-fe0f",
        "1f3cb-1f3fd-200d-2642-fe0f",
        "1f3cb-1f3fe-200d-2642-fe0f",
        "1f3cb-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme soulevant des poids", "femme-lever-des-poids"],
      u: "1f3cb-fe0f-200d-2640-fe0f",
      v: [
        "1f3cb-1f3fb-200d-2640-fe0f",
        "1f3cb-1f3fc-200d-2640-fe0f",
        "1f3cb-1f3fd-200d-2640-fe0f",
        "1f3cb-1f3fe-200d-2640-fe0f",
        "1f3cb-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["cycliste"],
      u: "1f6b4",
      v: [
        "1f6b4-1f3fb",
        "1f6b4-1f3fc",
        "1f6b4-1f3fd",
        "1f6b4-1f3fe",
        "1f6b4-1f3ff"
      ],
      a: "1.0"
    },
    {
      n: ["homme faisant du vélo", "homme-vélo"],
      u: "1f6b4-200d-2642-fe0f",
      v: [
        "1f6b4-1f3fb-200d-2642-fe0f",
        "1f6b4-1f3fc-200d-2642-fe0f",
        "1f6b4-1f3fd-200d-2642-fe0f",
        "1f6b4-1f3fe-200d-2642-fe0f",
        "1f6b4-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme faisant du vélo", "femme-vélo"],
      u: "1f6b4-200d-2640-fe0f",
      v: [
        "1f6b4-1f3fb-200d-2640-fe0f",
        "1f6b4-1f3fc-200d-2640-fe0f",
        "1f6b4-1f3fd-200d-2640-fe0f",
        "1f6b4-1f3fe-200d-2640-fe0f",
        "1f6b4-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["cycliste de montagne"],
      u: "1f6b5",
      v: [
        "1f6b5-1f3fb",
        "1f6b5-1f3fc",
        "1f6b5-1f3fd",
        "1f6b5-1f3fe",
        "1f6b5-1f3ff"
      ],
      a: "1.0"
    },
    {
      n: ["homme faisant du vélo de montagne", "homme-vtt"],
      u: "1f6b5-200d-2642-fe0f",
      v: [
        "1f6b5-1f3fb-200d-2642-fe0f",
        "1f6b5-1f3fc-200d-2642-fe0f",
        "1f6b5-1f3fd-200d-2642-fe0f",
        "1f6b5-1f3fe-200d-2642-fe0f",
        "1f6b5-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme faisant du vélo de montagne", "femme-vtt"],
      u: "1f6b5-200d-2640-fe0f",
      v: [
        "1f6b5-1f3fb-200d-2640-fe0f",
        "1f6b5-1f3fc-200d-2640-fe0f",
        "1f6b5-1f3fd-200d-2640-fe0f",
        "1f6b5-1f3fe-200d-2640-fe0f",
        "1f6b5-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["personne faisant la roue"],
      u: "1f938",
      v: [
        "1f938-1f3fb",
        "1f938-1f3fc",
        "1f938-1f3fd",
        "1f938-1f3fe",
        "1f938-1f3ff"
      ],
      a: "3.0"
    },
    {
      n: ["homme faisant la roue", "homme qui fait la roue"],
      u: "1f938-200d-2642-fe0f",
      v: [
        "1f938-1f3fb-200d-2642-fe0f",
        "1f938-1f3fc-200d-2642-fe0f",
        "1f938-1f3fd-200d-2642-fe0f",
        "1f938-1f3fe-200d-2642-fe0f",
        "1f938-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme faisant la roue", "femme qui fait la roue"],
      u: "1f938-200d-2640-fe0f",
      v: [
        "1f938-1f3fb-200d-2640-fe0f",
        "1f938-1f3fc-200d-2640-fe0f",
        "1f938-1f3fd-200d-2640-fe0f",
        "1f938-1f3fe-200d-2640-fe0f",
        "1f938-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["lutteurs"],
      u: "1f93c",
      a: "3.0"
    },
    {
      n: ["hommes luttant", "homme-lutte"],
      u: "1f93c-200d-2642-fe0f",
      a: "4.0"
    },
    {
      n: ["lutte féminine", "lutte féminine"],
      u: "1f93c-200d-2640-fe0f",
      a: "4.0"
    },
    {
      n: ["water polo"],
      u: "1f93d",
      v: [
        "1f93d-1f3fb",
        "1f93d-1f3fc",
        "1f93d-1f3fd",
        "1f93d-1f3fe",
        "1f93d-1f3ff"
      ],
      a: "3.0"
    },
    {
      n: ["homme jouant au water-polo", "homme-jouant-au-water-polo"],
      u: "1f93d-200d-2642-fe0f",
      v: [
        "1f93d-1f3fb-200d-2642-fe0f",
        "1f93d-1f3fc-200d-2642-fe0f",
        "1f93d-1f3fd-200d-2642-fe0f",
        "1f93d-1f3fe-200d-2642-fe0f",
        "1f93d-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme jouant au water-polo", "femme-jouant-au-water-polo"],
      u: "1f93d-200d-2640-fe0f",
      v: [
        "1f93d-1f3fb-200d-2640-fe0f",
        "1f93d-1f3fc-200d-2640-fe0f",
        "1f93d-1f3fd-200d-2640-fe0f",
        "1f93d-1f3fe-200d-2640-fe0f",
        "1f93d-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["handball"],
      u: "1f93e",
      v: [
        "1f93e-1f3fb",
        "1f93e-1f3fc",
        "1f93e-1f3fd",
        "1f93e-1f3fe",
        "1f93e-1f3ff"
      ],
      a: "3.0"
    },
    {
      n: ["homme jouant au handball", "homme-jouant-au-handball"],
      u: "1f93e-200d-2642-fe0f",
      v: [
        "1f93e-1f3fb-200d-2642-fe0f",
        "1f93e-1f3fc-200d-2642-fe0f",
        "1f93e-1f3fd-200d-2642-fe0f",
        "1f93e-1f3fe-200d-2642-fe0f",
        "1f93e-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme jouant au handball", "femme-jouant-au-handball"],
      u: "1f93e-200d-2640-fe0f",
      v: [
        "1f93e-1f3fb-200d-2640-fe0f",
        "1f93e-1f3fc-200d-2640-fe0f",
        "1f93e-1f3fd-200d-2640-fe0f",
        "1f93e-1f3fe-200d-2640-fe0f",
        "1f93e-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["jonglerie"],
      u: "1f939",
      v: [
        "1f939-1f3fb",
        "1f939-1f3fc",
        "1f939-1f3fd",
        "1f939-1f3fe",
        "1f939-1f3ff"
      ],
      a: "3.0"
    },
    {
      n: ["homme jonglant", "homme-jonglant"],
      u: "1f939-200d-2642-fe0f",
      v: [
        "1f939-1f3fb-200d-2642-fe0f",
        "1f939-1f3fc-200d-2642-fe0f",
        "1f939-1f3fd-200d-2642-fe0f",
        "1f939-1f3fe-200d-2642-fe0f",
        "1f939-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["femme jonglant", "femme-jonglant"],
      u: "1f939-200d-2640-fe0f",
      v: [
        "1f939-1f3fb-200d-2640-fe0f",
        "1f939-1f3fc-200d-2640-fe0f",
        "1f939-1f3fd-200d-2640-fe0f",
        "1f939-1f3fe-200d-2640-fe0f",
        "1f939-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["personne en position du lotus"],
      u: "1f9d8",
      v: [
        "1f9d8-1f3fb",
        "1f9d8-1f3fc",
        "1f9d8-1f3fd",
        "1f9d8-1f3fe",
        "1f9d8-1f3ff"
      ],
      a: "5.0"
    },
    {
      n: ["homme en position du lotus"],
      u: "1f9d8-200d-2642-fe0f",
      v: [
        "1f9d8-1f3fb-200d-2642-fe0f",
        "1f9d8-1f3fc-200d-2642-fe0f",
        "1f9d8-1f3fd-200d-2642-fe0f",
        "1f9d8-1f3fe-200d-2642-fe0f",
        "1f9d8-1f3ff-200d-2642-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["femme en position du lotus"],
      u: "1f9d8-200d-2640-fe0f",
      v: [
        "1f9d8-1f3fb-200d-2640-fe0f",
        "1f9d8-1f3fc-200d-2640-fe0f",
        "1f9d8-1f3fd-200d-2640-fe0f",
        "1f9d8-1f3fe-200d-2640-fe0f",
        "1f9d8-1f3ff-200d-2640-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["bain"],
      u: "1f6c0",
      v: [
        "1f6c0-1f3fb",
        "1f6c0-1f3fc",
        "1f6c0-1f3fd",
        "1f6c0-1f3fe",
        "1f6c0-1f3ff"
      ],
      a: "0.6"
    },
    {
      n: ["logement pour dormir"],
      u: "1f6cc",
      v: [
        "1f6cc-1f3fb",
        "1f6cc-1f3fc",
        "1f6cc-1f3fd",
        "1f6cc-1f3fe",
        "1f6cc-1f3ff"
      ],
      a: "1.0"
    },
    {
      n: ["gens se tenant la main"],
      u: "1f9d1-200d-1f91d-200d-1f9d1",
      v: [
        "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
        "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc",
        "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd",
        "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe",
        "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff",
        "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb",
        "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
        "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd",
        "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe",
        "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff",
        "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb",
        "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc",
        "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
        "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe",
        "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff",
        "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb",
        "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc",
        "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd",
        "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
        "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff",
        "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb",
        "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc",
        "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd",
        "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe",
        "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff"
      ],
      a: "12.0"
    },
    {
      n: ["femmes se tenant la main", "deux femmes se tenant la main"],
      u: "1f46d",
      v: [
        "1f46d-1f3fb",
        "1f46d-1f3fc",
        "1f46d-1f3fd",
        "1f46d-1f3fe",
        "1f46d-1f3ff",
        "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc",
        "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd",
        "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe",
        "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff",
        "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb",
        "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd",
        "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe",
        "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff",
        "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb",
        "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc",
        "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe",
        "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff",
        "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb",
        "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc",
        "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd",
        "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff",
        "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb",
        "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc",
        "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd",
        "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe"
      ],
      a: "1.0"
    },
    {
      n: [
        "couple",
        "homme et femme se tenant la main",
        "femme et homme se tenant la main"
      ],
      u: "1f46b",
      v: [
        "1f46b-1f3fb",
        "1f46b-1f3fc",
        "1f46b-1f3fd",
        "1f46b-1f3fe",
        "1f46b-1f3ff",
        "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc",
        "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd",
        "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe",
        "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff",
        "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb",
        "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd",
        "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe",
        "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff",
        "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb",
        "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc",
        "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe",
        "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff",
        "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb",
        "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc",
        "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd",
        "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff",
        "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb",
        "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc",
        "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd",
        "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe"
      ],
      a: "0.6"
    },
    {
      n: ["hommes se tenant la main", "deux hommes se tenant la main"],
      u: "1f46c",
      v: [
        "1f46c-1f3fb",
        "1f46c-1f3fc",
        "1f46c-1f3fd",
        "1f46c-1f3fe",
        "1f46c-1f3ff",
        "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc",
        "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd",
        "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe",
        "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff",
        "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb",
        "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd",
        "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe",
        "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff",
        "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb",
        "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc",
        "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe",
        "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff",
        "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb",
        "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc",
        "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd",
        "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff",
        "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb",
        "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc",
        "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd",
        "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe"
      ],
      a: "1.0"
    },
    {
      n: ["baiser", "baiser de couple"],
      u: "1f48f",
      v: [
        "1f48f-1f3fb",
        "1f48f-1f3fc",
        "1f48f-1f3fd",
        "1f48f-1f3fe",
        "1f48f-1f3ff",
        "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
        "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
        "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
        "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
        "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
        "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
        "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
        "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
        "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
        "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
        "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
        "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
        "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
        "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
        "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
        "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
        "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
        "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
        "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
        "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe"
      ],
      a: "0.6"
    },
    {
      n: ["femme-baiser-homme", "baiser : femme, homme"],
      u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
      v: [
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
      ],
      a: "2.0"
    },
    {
      n: ["homme-baiser-homme", "bisou : mec, mec"],
      u: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
      v: [
        "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
      ],
      a: "2.0"
    },
    {
      n: ["femme-baiser-femme", "baiser : femme, femme"],
      u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
      v: [
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff"
      ],
      a: "2.0"
    },
    {
      n: ["couple avec coeur"],
      u: "1f491",
      v: [
        "1f491-1f3fb",
        "1f491-1f3fc",
        "1f491-1f3fd",
        "1f491-1f3fe",
        "1f491-1f3ff",
        "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc",
        "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd",
        "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe",
        "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff",
        "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb",
        "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd",
        "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe",
        "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff",
        "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb",
        "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc",
        "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe",
        "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff",
        "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb",
        "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc",
        "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd",
        "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff",
        "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb",
        "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc",
        "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd",
        "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe"
      ],
      a: "0.6"
    },
    {
      n: ["femme-coeur-homme", "couple avec coeur : femme, homme"],
      u: "1f469-200d-2764-fe0f-200d-1f468",
      v: [
        "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
      ],
      a: "2.0"
    },
    {
      n: ["homme-cœur-homme", "couple avec coeur : homme, homme"],
      u: "1f468-200d-2764-fe0f-200d-1f468",
      v: [
        "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
      ],
      a: "2.0"
    },
    {
      n: ["femme-coeur-femme", "couple avec coeur : femme, femme"],
      u: "1f469-200d-2764-fe0f-200d-1f469",
      v: [
        "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff"
      ],
      a: "2.0"
    },
    {
      n: ["famille"],
      u: "1f46a",
      a: "0.6"
    },
    {
      n: ["homme-femme-garçon", "famille : homme, femme, garçon"],
      u: "1f468-200d-1f469-200d-1f466",
      a: "2.0"
    },
    {
      n: ["homme-femme-fille", "famille : homme, femme, fille"],
      u: "1f468-200d-1f469-200d-1f467",
      a: "2.0"
    },
    {
      n: ["homme-femme-fille-garçon", "famille : homme, femme, fille, garçon"],
      u: "1f468-200d-1f469-200d-1f467-200d-1f466",
      a: "2.0"
    },
    {
      n: [
        "homme-femme-garçon-garçon",
        "famille : homme, femme, garçon, garçon"
      ],
      u: "1f468-200d-1f469-200d-1f466-200d-1f466",
      a: "2.0"
    },
    {
      n: ["homme-femme-fille-fille", "famille : homme, femme, fille, fille"],
      u: "1f468-200d-1f469-200d-1f467-200d-1f467",
      a: "2.0"
    },
    {
      n: ["homme-homme-garçon", "famille : homme, homme, garçon"],
      u: "1f468-200d-1f468-200d-1f466",
      a: "2.0"
    },
    {
      n: ["homme-homme-fille", "famille : homme, homme, fille"],
      u: "1f468-200d-1f468-200d-1f467",
      a: "2.0"
    },
    {
      n: ["homme-homme-fille-garçon", "famille : homme, homme, fille, garçon"],
      u: "1f468-200d-1f468-200d-1f467-200d-1f466",
      a: "2.0"
    },
    {
      n: [
        "homme-homme-garçon-garçon",
        "famille : homme, homme, garçon, garçon"
      ],
      u: "1f468-200d-1f468-200d-1f466-200d-1f466",
      a: "2.0"
    },
    {
      n: ["homme-homme-fille-fille", "famille : homme, homme, fille, fille"],
      u: "1f468-200d-1f468-200d-1f467-200d-1f467",
      a: "2.0"
    },
    {
      n: ["femme-femme-garçon", "famille : femme, femme, garçon"],
      u: "1f469-200d-1f469-200d-1f466",
      a: "2.0"
    },
    {
      n: ["femme-femme-fille", "famille : femme, femme, fille"],
      u: "1f469-200d-1f469-200d-1f467",
      a: "2.0"
    },
    {
      n: ["femme-femme-fille-garçon", "famille : femme, femme, fille, garçon"],
      u: "1f469-200d-1f469-200d-1f467-200d-1f466",
      a: "2.0"
    },
    {
      n: [
        "femme-femme-garçon-garçon",
        "famille : femme, femme, garçon, garçon"
      ],
      u: "1f469-200d-1f469-200d-1f466-200d-1f466",
      a: "2.0"
    },
    {
      n: ["femme-femme-fille-fille", "famille : femme, femme, fille, fille"],
      u: "1f469-200d-1f469-200d-1f467-200d-1f467",
      a: "2.0"
    },
    {
      n: ["homme-garçon", "famille : homme, garçon"],
      u: "1f468-200d-1f466",
      a: "4.0"
    },
    {
      n: ["homme-garçon-garçon", "famille : homme, garçon, garçon"],
      u: "1f468-200d-1f466-200d-1f466",
      a: "4.0"
    },
    {
      n: ["homme-fille", "famille : homme, fille"],
      u: "1f468-200d-1f467",
      a: "4.0"
    },
    {
      n: ["homme-fille-garçon", "famille : homme, fille, garçon"],
      u: "1f468-200d-1f467-200d-1f466",
      a: "4.0"
    },
    {
      n: ["homme-fille-fille", "famille : homme, fille, fille"],
      u: "1f468-200d-1f467-200d-1f467",
      a: "4.0"
    },
    {
      n: ["femme-garçon", "famille : femme, garçon"],
      u: "1f469-200d-1f466",
      a: "4.0"
    },
    {
      n: ["femme-garçon-garçon", "famille : femme, garçon, garçon"],
      u: "1f469-200d-1f466-200d-1f466",
      a: "4.0"
    },
    {
      n: ["femme-fille", "famille : femme, fille"],
      u: "1f469-200d-1f467",
      a: "4.0"
    },
    {
      n: ["femme-fille-garçon", "famille : femme, fille, garçon"],
      u: "1f469-200d-1f467-200d-1f466",
      a: "4.0"
    },
    {
      n: ["femme-fille-fille", "famille : femme, fille, fille"],
      u: "1f469-200d-1f467-200d-1f467",
      a: "4.0"
    },
    {
      n: ["tête parlante", "tête parlante, dans, silhouette"],
      u: "1f5e3-fe0f",
      a: "0.7"
    },
    {
      n: ["buste en silhouette"],
      u: "1f464",
      a: "0.6"
    },
    {
      n: ["bustes en silhouette"],
      u: "1f465",
      a: "1.0"
    },
    {
      n: ["les gens s'embrassent"],
      u: "1fac2",
      a: "13.0"
    },
    {
      n: ["empreintes"],
      u: "1f463",
      a: "0.6"
    }
  ],
  animals_nature: [
    {
      n: ["visage de singe"],
      u: "1f435",
      a: "0.6"
    },
    {
      n: ["singe"],
      u: "1f412",
      a: "0.6"
    },
    {
      n: ["gorille"],
      u: "1f98d",
      a: "3.0"
    },
    {
      n: ["orang-outan"],
      u: "1f9a7",
      a: "12.0"
    },
    {
      n: ["chien", "visage de chien"],
      u: "1f436",
      a: "0.6"
    },
    {
      n: ["chien", "chien2"],
      u: "1f415",
      a: "0.7"
    },
    {
      n: ["chien-guide"],
      u: "1f9ae",
      a: "12.0"
    },
    {
      n: ["chien d'assistance"],
      u: "1f415-200d-1f9ba",
      a: "12.0"
    },
    {
      n: ["caniche"],
      u: "1f429",
      a: "0.6"
    },
    {
      n: ["loup", "visage de loup"],
      u: "1f43a",
      a: "0.6"
    },
    {
      n: ["visage de renard"],
      u: "1f98a",
      a: "3.0"
    },
    {
      n: ["raton laveur"],
      u: "1f99d",
      a: "11.0"
    },
    {
      n: ["chat", "visage de chat"],
      u: "1f431",
      a: "0.6"
    },
    {
      n: ["chat", "chat2"],
      u: "1f408",
      a: "0.7"
    },
    {
      n: ["chat noir"],
      u: "1f408-200d-2b1b",
      a: "13.0"
    },
    {
      n: ["visage de lion"],
      u: "1f981",
      a: "1.0"
    },
    {
      n: ["tigre", "visage de tigre"],
      u: "1f42f",
      a: "0.6"
    },
    {
      n: ["tigre", "tigre2"],
      u: "1f405",
      a: "1.0"
    },
    {
      n: ["léopard"],
      u: "1f406",
      a: "1.0"
    },
    {
      n: ["cheval", "visage de cheval"],
      u: "1f434",
      a: "0.6"
    },
    {
      n: ["cheval", "cheval de course"],
      u: "1f40e",
      a: "0.6"
    },
    {
      n: ["visage de licorne"],
      u: "1f984",
      a: "1.0"
    },
    {
      n: ["visage de zèbre"],
      u: "1f993",
      a: "5.0"
    },
    {
      n: ["cerf"],
      u: "1f98c",
      a: "3.0"
    },
    {
      n: ["bison"],
      u: "1f9ac",
      a: "13.0"
    },
    {
      n: ["vache", "visage de vache"],
      u: "1f42e",
      a: "0.6"
    },
    {
      n: ["bœuf"],
      u: "1f402",
      a: "1.0"
    },
    {
      n: ["buffle d'eau"],
      u: "1f403",
      a: "1.0"
    },
    {
      n: ["vache", "vache2"],
      u: "1f404",
      a: "1.0"
    },
    {
      n: ["cochon", "visage de cochon"],
      u: "1f437",
      a: "0.6"
    },
    {
      n: ["cochon", "cochon2"],
      u: "1f416",
      a: "1.0"
    },
    {
      n: ["verrat"],
      u: "1f417",
      a: "0.6"
    },
    {
      n: ["nez de cochon"],
      u: "1f43d",
      a: "0.6"
    },
    {
      n: ["bélier"],
      u: "1f40f",
      a: "1.0"
    },
    {
      n: ["mouton"],
      u: "1f411",
      a: "0.6"
    },
    {
      n: ["chèvre"],
      u: "1f410",
      a: "1.0"
    },
    {
      n: ["dromadaire"],
      u: "1f42a",
      a: "1.0"
    },
    {
      n: ["chameau", "chameau de Bactriane"],
      u: "1f42b",
      a: "0.6"
    },
    {
      n: ["lama"],
      u: "1f999",
      a: "11.0"
    },
    {
      n: ["visage de girafe"],
      u: "1f992",
      a: "5.0"
    },
    {
      n: ["éléphant"],
      u: "1f418",
      a: "0.6"
    },
    {
      n: ["mammouth"],
      u: "1f9a3",
      a: "13.0"
    },
    {
      n: ["rhinocéros"],
      u: "1f98f",
      a: "3.0"
    },
    {
      n: ["hippopotame"],
      u: "1f99b",
      a: "11.0"
    },
    {
      n: ["souris", "visage de souris"],
      u: "1f42d",
      a: "0.6"
    },
    {
      n: ["souris", "souris2"],
      u: "1f401",
      a: "1.0"
    },
    {
      n: ["rat"],
      u: "1f400",
      a: "1.0"
    },
    {
      n: ["hamster", "visage de hamster"],
      u: "1f439",
      a: "0.6"
    },
    {
      n: ["lapin", "visage de lapin"],
      u: "1f430",
      a: "0.6"
    },
    {
      n: ["lapin", "lapin2"],
      u: "1f407",
      a: "1.0"
    },
    {
      n: ["tamia"],
      u: "1f43f-fe0f",
      a: "0.7"
    },
    {
      n: ["castor"],
      u: "1f9ab",
      a: "13.0"
    },
    {
      n: ["hérisson"],
      u: "1f994",
      a: "5.0"
    },
    {
      n: ["batte"],
      u: "1f987",
      a: "3.0"
    },
    {
      n: ["ours", "visage d'ours"],
      u: "1f43b",
      a: "0.6"
    },
    {
      n: ["ours blanc"],
      u: "1f43b-200d-2744-fe0f",
      a: "13.0"
    },
    {
      n: ["koala"],
      u: "1f428",
      a: "0.6"
    },
    {
      n: ["visage de panda"],
      u: "1f43c",
      a: "0.6"
    },
    {
      n: ["paresseux"],
      u: "1f9a5",
      a: "12.0"
    },
    {
      n: ["loutre"],
      u: "1f9a6",
      a: "12.0"
    },
    {
      n: ["mouffette"],
      u: "1f9a8",
      a: "12.0"
    },
    {
      n: ["kangourou"],
      u: "1f998",
      a: "11.0"
    },
    {
      n: ["blaireau"],
      u: "1f9a1",
      a: "11.0"
    },
    { n: ["orignal"], u: "1face", a: "15.0" },
    { n: ["âne"], u: "1facf", a: "15.0" },
    {
      n: ["pieds", "empreintes de pattes"],
      u: "1f43e",
      a: "0.6"
    },
    {
      n: ["dinde"],
      u: "1f983",
      a: "1.0"
    },
    {
      n: ["poulet"],
      u: "1f414",
      a: "0.6"
    },
    {
      n: ["coq"],
      u: "1f413",
      a: "1.0"
    },
    {
      n: ["poussin en train d'éclore"],
      u: "1f423",
      a: "0.6"
    },
    {
      n: ["bébé poussin"],
      u: "1f424",
      a: "0.6"
    },
    {
      n: ["poussin éclos", "poussin de face"],
      u: "1f425",
      a: "0.6"
    },
    {
      n: ["oiseau"],
      u: "1f426",
      a: "0.6"
    },
    {
      n: ["manchot"],
      u: "1f427",
      a: "0.6"
    },
    {
      n: ["colombe", "colombe de la paix"],
      u: "1f54a-fe0f",
      a: "0.7"
    },
    {
      n: ["aigle"],
      u: "1f985",
      a: "3.0"
    },
    {
      n: ["canard"],
      u: "1f986",
      a: "3.0"
    },
    {
      n: ["cygne"],
      u: "1f9a2",
      a: "11.0"
    },
    {
      n: ["hibou"],
      u: "1f989",
      a: "3.0"
    },
    {
      n: ["dodo"],
      u: "1f9a4",
      a: "13.0"
    },
    {
      n: ["plume"],
      u: "1fab6",
      a: "13.0"
    },
    {
      n: ["flamant"],
      u: "1f9a9",
      a: "12.0"
    },
    {
      n: ["paon"],
      u: "1f99a",
      a: "11.0"
    },
    {
      n: ["perroquet"],
      u: "1f99c",
      a: "11.0"
    },
    { n: ["aile"], u: "1fabd", a: "15.0" },
    { n: ["oiseau noir"], u: "1f426-200d-2b1b", a: "15.0" },
    { n: ["oie"], u: "1fabf", a: "15.0" },
    { n: ["phénix"], u: "1f426-200d-1f525", a: "15.1" },
    {
      n: ["grenouille", "visage de grenouille"],
      u: "1f438",
      a: "0.6"
    },
    {
      n: ["crocodile"],
      u: "1f40a",
      a: "1.0"
    },
    {
      n: ["tortue"],
      u: "1f422",
      a: "0.6"
    },
    {
      n: ["lézard"],
      u: "1f98e",
      a: "3.0"
    },
    {
      n: ["serpent"],
      u: "1f40d",
      a: "0.6"
    },
    {
      n: ["visage de dragon"],
      u: "1f432",
      a: "0.6"
    },
    {
      n: ["dragon"],
      u: "1f409",
      a: "1.0"
    },
    {
      n: ["sauropode"],
      u: "1f995",
      a: "5.0"
    },
    {
      n: ["t-rex"],
      u: "1f996",
      a: "5.0"
    },
    {
      n: ["baleine", "baleine jaillissante"],
      u: "1f433",
      a: "0.6"
    },
    {
      n: ["baleine", "baleine2"],
      u: "1f40b",
      a: "1.0"
    },
    {
      n: ["dauphin", "flipper"],
      u: "1f42c",
      a: "0.6"
    },
    { n: ["orque"], u: "1facd", a: "17.0" },
    {
      n: ["joint"],
      u: "1f9ad",
      a: "13.0"
    },
    {
      n: ["poisson"],
      u: "1f41f",
      a: "0.6"
    },
    {
      n: ["poisson tropical"],
      u: "1f420",
      a: "0.6"
    },
    {
      n: ["poisson-globe"],
      u: "1f421",
      a: "0.6"
    },
    {
      n: ["requin"],
      u: "1f988",
      a: "3.0"
    },
    {
      n: ["pieuvre"],
      u: "1f419",
      a: "0.6"
    },
    {
      n: ["coquille", "coque en spirale"],
      u: "1f41a",
      a: "0.6"
    },
    {
      n: ["corail"],
      u: "1fab8",
      a: "14.0"
    },
    {
      n: ["escargot"],
      u: "1f40c",
      a: "0.6"
    },
    {
      n: ["papillon"],
      u: "1f98b",
      a: "3.0"
    },
    {
      n: ["bogue"],
      u: "1f41b",
      a: "0.6"
    },
    {
      n: ["fourmi"],
      u: "1f41c",
      a: "0.6"
    },
    {
      n: ["abeille", "abeille"],
      u: "1f41d",
      a: "0.6"
    },
    {
      n: ["scarabée"],
      u: "1fab2",
      a: "13.0"
    },
    {
      n: ["coccinelle", "coccinelle"],
      u: "1f41e",
      a: "0.6"
    },
    {
      n: ["cricket"],
      u: "1f997",
      a: "5.0"
    },
    {
      n: ["cafard"],
      u: "1fab3",
      a: "13.0"
    },
    {
      n: ["araignée"],
      u: "1f577-fe0f",
      a: "0.7"
    },
    {
      n: ["toile d'araignée"],
      u: "1f578-fe0f",
      a: "0.7"
    },
    {
      n: ["Scorpion"],
      u: "1f982",
      a: "1.0"
    },
    {
      n: ["moustique"],
      u: "1f99f",
      a: "11.0"
    },
    {
      n: ["voler"],
      u: "1fab0",
      a: "13.0"
    },
    {
      n: ["ver"],
      u: "1fab1",
      a: "13.0"
    },
    {
      n: ["microbe"],
      u: "1f9a0",
      a: "11.0"
    },
    {
      n: ["bouquet"],
      u: "1f490",
      a: "0.6"
    },
    {
      n: ["fleur de cerisier"],
      u: "1f338",
      a: "0.6"
    },
    {
      n: ["fleur blanche"],
      u: "1f4ae",
      a: "0.6"
    },
    {
      n: ["lotus"],
      u: "1fab7",
      a: "14.0"
    },
    {
      n: ["rosette"],
      u: "1f3f5-fe0f",
      a: "0.7"
    },
    {
      n: ["rose"],
      u: "1f339",
      a: "0.6"
    },
    {
      n: ["fleur fanée"],
      u: "1f940",
      a: "3.0"
    },
    {
      n: ["hibiscus"],
      u: "1f33a",
      a: "0.6"
    },
    {
      n: ["tournesol"],
      u: "1f33b",
      a: "0.6"
    },
    {
      n: ["fleurir"],
      u: "1f33c",
      a: "0.6"
    },
    {
      n: ["tulipe"],
      u: "1f337",
      a: "0.6"
    },
    {
      n: ["semis"],
      u: "1f331",
      a: "0.6"
    },
    {
      n: ["plante en pot"],
      u: "1fab4",
      a: "13.0"
    },
    {
      n: ["arbre à feuilles persistantes"],
      u: "1f332",
      a: "1.0"
    },
    {
      n: ["arbre à feuilles caduques"],
      u: "1f333",
      a: "1.0"
    },
    { n: ["arbre sans feuilles"], u: "1fabe", a: "16.0" },
    {
      n: ["palmier"],
      u: "1f334",
      a: "0.6"
    },
    {
      n: ["cactus"],
      u: "1f335",
      a: "0.6"
    },
    {
      n: ["épi de riz"],
      u: "1f33e",
      a: "0.6"
    },
    {
      n: ["herbe"],
      u: "1f33f",
      a: "0.6"
    },
    {
      n: ["trèfle"],
      u: "2618-fe0f",
      a: "1.0"
    },
    {
      n: ["trèfle à quatre feuilles"],
      u: "1f340",
      a: "0.6"
    },
    {
      n: ["feuille d'érable"],
      u: "1f341",
      a: "0.6"
    },
    {
      n: ["feuille tombée"],
      u: "1f342",
      a: "0.6"
    },
    {
      n: ["feuilles", "feuille flottant au vent"],
      u: "1f343",
      a: "0.6"
    },
    {
      n: ["nid vide"],
      u: "1fab9",
      a: "14.0"
    },
    {
      n: ["nid avec des oeufs"],
      u: "1faba",
      a: "14.0"
    }
  ],
  food_drink: [
    {
      n: ["raisins"],
      u: "1f347",
      a: "0.6"
    },
    {
      n: ["melon"],
      u: "1f348",
      a: "0.6"
    },
    {
      n: ["pastèque"],
      u: "1f349",
      a: "0.6"
    },
    {
      n: ["Tangerine"],
      u: "1f34a",
      a: "0.6"
    },
    {
      n: ["citron"],
      u: "1f34b",
      a: "1.0"
    },
    { n: ["citron vert"], u: "1f34b-200d-1f7e9", a: "15.1" },
    {
      n: ["banane"],
      u: "1f34c",
      a: "0.6"
    },
    {
      n: ["ananas"],
      u: "1f34d",
      a: "0.6"
    },
    {
      n: ["mangue"],
      u: "1f96d",
      a: "11.0"
    },
    {
      n: ["pomme", "pomme rouge"],
      u: "1f34e",
      a: "0.6"
    },
    {
      n: ["pomme verte"],
      u: "1f34f",
      a: "0.6"
    },
    {
      n: ["poire"],
      u: "1f350",
      a: "1.0"
    },
    {
      n: ["pêche"],
      u: "1f351",
      a: "0.6"
    },
    {
      n: ["cerises"],
      u: "1f352",
      a: "0.6"
    },
    {
      n: ["fraise"],
      u: "1f353",
      a: "0.6"
    },
    {
      n: ["bleuets"],
      u: "1fad0",
      a: "13.0"
    },
    {
      n: ["kiwi"],
      u: "1f95d",
      a: "3.0"
    },
    {
      n: ["tomate"],
      u: "1f345",
      a: "0.6"
    },
    {
      n: ["olive"],
      u: "1fad2",
      a: "13.0"
    },
    {
      n: ["noix de coco"],
      u: "1f965",
      a: "5.0"
    },
    {
      n: ["avocat"],
      u: "1f951",
      a: "3.0"
    },
    {
      n: ["aubergine", "aubergine"],
      u: "1f346",
      a: "0.6"
    },
    {
      n: ["pomme de terre"],
      u: "1f954",
      a: "3.0"
    },
    {
      n: ["carotte"],
      u: "1f955",
      a: "3.0"
    },
    { n: ["légume racine"], u: "1fadc", a: "16.0" },
    {
      n: ["maïs", "épi de maïs"],
      u: "1f33d",
      a: "0.6"
    },
    {
      n: ["piment"],
      u: "1f336-fe0f",
      a: "0.7"
    },
    {
      n: ["poivron"],
      u: "1fad1",
      a: "13.0"
    },
    {
      n: ["concombre"],
      u: "1f952",
      a: "3.0"
    },
    {
      n: ["vert feuillu"],
      u: "1f96c",
      a: "11.0"
    },
    {
      n: ["brocoli"],
      u: "1f966",
      a: "5.0"
    },
    {
      n: ["ail"],
      u: "1f9c4",
      a: "12.0"
    },
    {
      n: ["oignon"],
      u: "1f9c5",
      a: "12.0"
    },
    {
      n: ["champignon"],
      u: "1f344",
      a: "0.6"
    },
    { n: ["champignon brun"], u: "1f344-200d-1f7eb", a: "15.1" },
    {
      n: ["cacahuètes"],
      u: "1f95c",
      a: "3.0"
    },
    {
      n: ["haricots"],
      u: "1fad8",
      a: "14.0"
    },
    {
      n: ["châtaigne"],
      u: "1f330",
      a: "0.6"
    },
    {
      n: ["pain"],
      u: "1f35e",
      a: "0.6"
    },
    {
      n: ["croissant"],
      u: "1f950",
      a: "3.0"
    },
    {
      n: ["pain baguette"],
      u: "1f956",
      a: "3.0"
    },
    {
      n: ["pain plat"],
      u: "1fad3",
      a: "13.0"
    },
    {
      n: ["bretzel"],
      u: "1f968",
      a: "5.0"
    },
    {
      n: ["bagel"],
      u: "1f96f",
      a: "11.0"
    },
    {
      n: ["crêpes"],
      u: "1f95e",
      a: "3.0"
    },
    {
      n: ["gaufre"],
      u: "1f9c7",
      a: "12.0"
    },
    {
      n: ["coin de fromage"],
      u: "1f9c0",
      a: "1.0"
    },
    {
      n: ["viande sur os"],
      u: "1f356",
      a: "0.6"
    },
    {
      n: ["cuisse de volaille"],
      u: "1f357",
      a: "0.6"
    },
    {
      n: ["morceau de viande"],
      u: "1f969",
      a: "5.0"
    },
    {
      n: ["lard"],
      u: "1f953",
      a: "3.0"
    },
    {
      n: ["hamburger"],
      u: "1f354",
      a: "0.6"
    },
    {
      n: ["frites", "frites"],
      u: "1f35f",
      a: "0.6"
    },
    {
      n: ["pizza", "tranche de pizza"],
      u: "1f355",
      a: "0.6"
    },
    {
      n: ["hot-dog", "hot-dog"],
      u: "1f32d",
      a: "1.0"
    },
    {
      n: ["sandwich"],
      u: "1f96a",
      a: "5.0"
    },
    {
      n: ["taco"],
      u: "1f32e",
      a: "1.0"
    },
    {
      n: ["burrito"],
      u: "1f32f",
      a: "1.0"
    },
    {
      n: ["tamale"],
      u: "1fad4",
      a: "13.0"
    },
    {
      n: ["pain plat farci"],
      u: "1f959",
      a: "3.0"
    },
    {
      n: ["falafel"],
      u: "1f9c6",
      a: "12.0"
    },
    {
      n: ["œuf"],
      u: "1f95a",
      a: "3.0"
    },
    {
      n: ["cuisson", "oeuf au plat"],
      u: "1f373",
      a: "0.6"
    },
    {
      n: ["plat peu profond de nourriture"],
      u: "1f958",
      a: "3.0"
    },
    {
      n: ["ragoût", "pot de nourriture"],
      u: "1f372",
      a: "0.6"
    },
    {
      n: ["fondue"],
      u: "1fad5",
      a: "13.0"
    },
    {
      n: ["bol avec cuillère"],
      u: "1f963",
      a: "5.0"
    },
    {
      n: ["salade verte"],
      u: "1f957",
      a: "3.0"
    },
    {
      n: ["Popcorn"],
      u: "1f37f",
      a: "1.0"
    },
    {
      n: ["beurre"],
      u: "1f9c8",
      a: "12.0"
    },
    {
      n: ["sel", "salière"],
      u: "1f9c2",
      a: "11.0"
    },
    {
      n: ["nourriture en boîte"],
      u: "1f96b",
      a: "5.0"
    },
    {
      n: ["bento", "boîte à bento"],
      u: "1f371",
      a: "0.6"
    },
    {
      n: ["craquelin de riz"],
      u: "1f358",
      a: "0.6"
    },
    {
      n: ["boule de riz"],
      u: "1f359",
      a: "0.6"
    },
    {
      n: ["riz", "riz cuit"],
      u: "1f35a",
      a: "0.6"
    },
    {
      n: ["curry", "curry et riz"],
      u: "1f35b",
      a: "0.6"
    },
    {
      n: ["ramen", "bol fumant"],
      u: "1f35c",
      a: "0.6"
    },
    {
      n: ["spaghetti"],
      u: "1f35d",
      a: "0.6"
    },
    {
      n: ["patate douce", "patate douce rôtie"],
      u: "1f360",
      a: "0.6"
    },
    {
      n: ["oden"],
      u: "1f362",
      a: "0.6"
    },
    {
      n: ["sushis"],
      u: "1f363",
      a: "0.6"
    },
    {
      n: ["crevettes frites"],
      u: "1f364",
      a: "0.6"
    },
    {
      n: ["galette de poisson", "gâteau de poisson avec motif tourbillon"],
      u: "1f365",
      a: "0.6"
    },
    {
      n: ["gâteau de lune"],
      u: "1f96e",
      a: "11.0"
    },
    {
      n: ["dango"],
      u: "1f361",
      a: "0.6"
    },
    {
      n: ["boulette"],
      u: "1f95f",
      a: "5.0"
    },
    {
      n: ["biscuit chinois"],
      u: "1f960",
      a: "5.0"
    },
    {
      n: ["boîte à emporter"],
      u: "1f961",
      a: "5.0"
    },
    {
      n: ["crabe"],
      u: "1f980",
      a: "1.0"
    },
    {
      n: ["homard"],
      u: "1f99e",
      a: "11.0"
    },
    {
      n: ["crevette"],
      u: "1f990",
      a: "3.0"
    },
    {
      n: ["calmar"],
      u: "1f991",
      a: "3.0"
    },
    {
      n: ["huître"],
      u: "1f9aa",
      a: "12.0"
    },
    {
      n: ["glace", "glace molle"],
      u: "1f366",
      a: "0.6"
    },
    {
      n: ["glace pilée"],
      u: "1f367",
      a: "0.6"
    },
    {
      n: ["glace"],
      u: "1f368",
      a: "0.6"
    },
    {
      n: ["Donut"],
      u: "1f369",
      a: "0.6"
    },
    {
      n: ["biscuit"],
      u: "1f36a",
      a: "0.6"
    },
    {
      n: ["anniversaire", "gâteau d'anniversaire"],
      u: "1f382",
      a: "0.6"
    },
    {
      n: ["gâteau", "gâteau sablé"],
      u: "1f370",
      a: "0.6"
    },
    {
      n: ["petit gâteau"],
      u: "1f9c1",
      a: "11.0"
    },
    {
      n: ["tarte"],
      u: "1f967",
      a: "5.0"
    },
    {
      n: ["barre de chocolat"],
      u: "1f36b",
      a: "0.6"
    },
    {
      n: ["bonbons"],
      u: "1f36c",
      a: "0.6"
    },
    {
      n: ["sucette"],
      u: "1f36d",
      a: "0.6"
    },
    {
      n: ["crème"],
      u: "1f36e",
      a: "0.6"
    },
    {
      n: ["pot de miel"],
      u: "1f36f",
      a: "0.6"
    },
    {
      n: ["biberon"],
      u: "1f37c",
      a: "1.0"
    },
    {
      n: ["verre de lait"],
      u: "1f95b",
      a: "3.0"
    },
    {
      n: ["café", "boisson chaude"],
      u: "2615",
      a: "0.6"
    },
    {
      n: ["théière"],
      u: "1fad6",
      a: "13.0"
    },
    {
      n: ["thé", "tasse à thé sans anse"],
      u: "1f375",
      a: "0.6"
    },
    {
      n: ["saké", "bouteille et tasse de saké"],
      u: "1f376",
      a: "0.6"
    },
    {
      n: ["Champagne", "bouteille avec bouchon qui éclate"],
      u: "1f37e",
      a: "1.0"
    },
    {
      n: ["verre à vin"],
      u: "1f377",
      a: "0.6"
    },
    {
      n: ["cocktail", "verre à cocktail"],
      u: "1f378",
      a: "0.6"
    },
    {
      n: ["boisson tropicale"],
      u: "1f379",
      a: "0.6"
    },
    {
      n: ["bière", "chope à bière"],
      u: "1f37a",
      a: "0.6"
    },
    {
      n: ["bières", "chopes à bière tintées"],
      u: "1f37b",
      a: "0.6"
    },
    {
      n: ["tinter les verres"],
      u: "1f942",
      a: "3.0"
    },
    {
      n: ["verre à gobelet"],
      u: "1f943",
      a: "3.0"
    },
    {
      n: ["verser du liquide"],
      u: "1fad7",
      a: "14.0"
    },
    {
      n: ["tasse avec de la paille"],
      u: "1f964",
      a: "5.0"
    },
    {
      n: ["thé à bulles"],
      u: "1f9cb",
      a: "13.0"
    },
    {
      n: ["boîte à boissons"],
      u: "1f9c3",
      a: "12.0"
    },
    {
      n: ["boisson de compagnon"],
      u: "1f9c9",
      a: "12.0"
    },
    {
      n: ["glaçon"],
      u: "1f9ca",
      a: "12.0"
    },
    {
      n: ["baguettes"],
      u: "1f962",
      a: "5.0"
    },
    {
      n: ["couteau fourchette plaque", "fourchette et couteau avec assiette"],
      u: "1f37d-fe0f",
      a: "0.7"
    },
    {
      n: ["fourchette et couteau"],
      u: "1f374",
      a: "0.6"
    },
    {
      n: ["cuillère"],
      u: "1f944",
      a: "3.0"
    },
    {
      n: ["hocho", "couteau"],
      u: "1f52a",
      a: "0.6"
    },
    {
      n: ["pot"],
      u: "1fad9",
      a: "14.0"
    },
    {
      n: ["amphore"],
      u: "1f3fa",
      a: "1.0"
    }
  ],
  travel_places: [
    {
      n: ["terre afrique", "globe terrestre Europe-Afrique"],
      u: "1f30d",
      a: "0.7"
    },
    {
      n: ["Terre Amériques", "globe terrestre Amériques"],
      u: "1f30e",
      a: "0.7"
    },
    {
      n: ["terre asie", "globe terrestre Asie-Australie"],
      u: "1f30f",
      a: "0.6"
    },
    {
      n: ["globe avec méridiens"],
      u: "1f310",
      a: "1.0"
    },
    {
      n: ["carte du monde"],
      u: "1f5fa-fe0f",
      a: "0.7"
    },
    {
      n: ["Japon", "silhouette du japon"],
      u: "1f5fe",
      a: "0.6"
    },
    {
      n: ["boussole"],
      u: "1f9ed",
      a: "11.0"
    },
    {
      n: ["montagne enneigée", "montagne enneigée"],
      u: "1f3d4-fe0f",
      a: "0.7"
    },
    {
      n: ["montagne"],
      u: "26f0-fe0f",
      a: "0.7"
    },
    {
      n: ["volcan"],
      u: "1f30b",
      a: "0.6"
    },
    { n: ["glissement de terrain"], u: "1f6d8", a: "17.0" },
    {
      n: ["Mont Fuji"],
      u: "1f5fb",
      a: "0.6"
    },
    {
      n: ["camping"],
      u: "1f3d5-fe0f",
      a: "0.7"
    },
    {
      n: ["plage avec parasol"],
      u: "1f3d6-fe0f",
      a: "0.7"
    },
    {
      n: ["désert"],
      u: "1f3dc-fe0f",
      a: "0.7"
    },
    {
      n: ["île déserte"],
      u: "1f3dd-fe0f",
      a: "0.7"
    },
    {
      n: ["parc national"],
      u: "1f3de-fe0f",
      a: "0.7"
    },
    {
      n: ["stade"],
      u: "1f3df-fe0f",
      a: "0.7"
    },
    {
      n: ["bâtiment classique"],
      u: "1f3db-fe0f",
      a: "0.7"
    },
    {
      n: ["construction de bâtiments"],
      u: "1f3d7-fe0f",
      a: "0.7"
    },
    {
      n: ["brique", "briques"],
      u: "1f9f1",
      a: "11.0"
    },
    {
      n: ["rocher"],
      u: "1faa8",
      a: "13.0"
    },
    {
      n: ["bois"],
      u: "1fab5",
      a: "13.0"
    },
    {
      n: ["cabane"],
      u: "1f6d6",
      a: "13.0"
    },
    {
      n: ["maisons", "bâtiments de maison"],
      u: "1f3d8-fe0f",
      a: "0.7"
    },
    {
      n: ["maison abandonnée", "construction d'une maison abandonnée"],
      u: "1f3da-fe0f",
      a: "0.7"
    },
    {
      n: ["maison", "construction de maisons"],
      u: "1f3e0",
      a: "0.6"
    },
    {
      n: ["maison avec jardin"],
      u: "1f3e1",
      a: "0.6"
    },
    {
      n: ["bureau", "immeuble de bureaux"],
      u: "1f3e2",
      a: "0.6"
    },
    {
      n: ["bureau de poste", "bureau de poste japonais"],
      u: "1f3e3",
      a: "0.6"
    },
    {
      n: ["bureau de poste européen"],
      u: "1f3e4",
      a: "1.0"
    },
    {
      n: ["hôpital"],
      u: "1f3e5",
      a: "0.6"
    },
    {
      n: ["banque"],
      u: "1f3e6",
      a: "0.6"
    },
    {
      n: ["hôtel"],
      u: "1f3e8",
      a: "0.6"
    },
    {
      n: ["hôtel d'amour"],
      u: "1f3e9",
      a: "0.6"
    },
    {
      n: ["dépanneur"],
      u: "1f3ea",
      a: "0.6"
    },
    {
      n: ["école"],
      u: "1f3eb",
      a: "0.6"
    },
    {
      n: ["grand magasin"],
      u: "1f3ec",
      a: "0.6"
    },
    {
      n: ["usine"],
      u: "1f3ed",
      a: "0.6"
    },
    {
      n: ["château japonais"],
      u: "1f3ef",
      a: "0.6"
    },
    {
      n: ["château européen"],
      u: "1f3f0",
      a: "0.6"
    },
    {
      n: ["mariage"],
      u: "1f492",
      a: "0.6"
    },
    {
      n: ["tour de tokyo"],
      u: "1f5fc",
      a: "0.6"
    },
    {
      n: ["statue de la liberté"],
      u: "1f5fd",
      a: "0.6"
    },
    {
      n: ["église"],
      u: "26ea",
      a: "0.6"
    },
    {
      n: ["mosquée"],
      u: "1f54c",
      a: "1.0"
    },
    {
      n: ["temple hindou"],
      u: "1f6d5",
      a: "12.0"
    },
    {
      n: ["synagogue"],
      u: "1f54d",
      a: "1.0"
    },
    {
      n: ["sanctuaire shinto"],
      u: "26e9-fe0f",
      a: "0.7"
    },
    {
      n: ["Kaaba"],
      u: "1f54b",
      a: "1.0"
    },
    {
      n: ["fontaine"],
      u: "26f2",
      a: "0.6"
    },
    {
      n: ["tente"],
      u: "26fa",
      a: "0.6"
    },
    {
      n: ["brumeux"],
      u: "1f301",
      a: "0.6"
    },
    {
      n: ["nuit avec des étoiles"],
      u: "1f303",
      a: "0.6"
    },
    {
      n: ["paysage urbain"],
      u: "1f3d9-fe0f",
      a: "0.7"
    },
    {
      n: ["lever de soleil sur les montagnes"],
      u: "1f304",
      a: "0.6"
    },
    {
      n: ["lever du soleil"],
      u: "1f305",
      a: "0.6"
    },
    {
      n: ["coucher de soleil sur la ville", "paysage urbain au crépuscule"],
      u: "1f306",
      a: "0.6"
    },
    {
      n: ["lever du soleil de la ville", "coucher de soleil sur les bâtiments"],
      u: "1f307",
      a: "0.6"
    },
    {
      n: ["pont la nuit"],
      u: "1f309",
      a: "0.6"
    },
    {
      n: ["sources chaudes", "sources chaudes"],
      u: "2668-fe0f",
      a: "0.6"
    },
    {
      n: ["cheval de carrousel"],
      u: "1f3a0",
      a: "0.6"
    },
    {
      n: ["toboggan pour aire de jeux"],
      u: "1f6dd",
      a: "14.0"
    },
    {
      n: ["grande roue"],
      u: "1f3a1",
      a: "0.6"
    },
    {
      n: ["montagnes russes"],
      u: "1f3a2",
      a: "0.6"
    },
    {
      n: ["coiffeur", "poteau de barbier"],
      u: "1f488",
      a: "0.6"
    },
    {
      n: ["chapiteau de cirque"],
      u: "1f3aa",
      a: "0.6"
    },
    {
      n: ["locomotive à vapeur"],
      u: "1f682",
      a: "1.0"
    },
    {
      n: ["wagon de chemin de fer"],
      u: "1f683",
      a: "0.6"
    },
    {
      n: ["train à grande vitesse", "côté train à grande vitesse"],
      u: "1f684",
      a: "0.6"
    },
    {
      n: [
        "avant du train à grande vitesse",
        "train à grande vitesse avec nez de balle"
      ],
      u: "1f685",
      a: "0.6"
    },
    {
      n: ["former", "train2"],
      u: "1f686",
      a: "1.0"
    },
    {
      n: ["métro"],
      u: "1f687",
      a: "0.6"
    },
    {
      n: ["métro léger"],
      u: "1f688",
      a: "1.0"
    },
    {
      n: ["gare"],
      u: "1f689",
      a: "0.6"
    },
    {
      n: ["tram"],
      u: "1f68a",
      a: "1.0"
    },
    {
      n: ["monorail"],
      u: "1f69d",
      a: "1.0"
    },
    {
      n: ["chemin de fer de montagne"],
      u: "1f69e",
      a: "1.0"
    },
    {
      n: ["former", "voiture de tramway"],
      u: "1f68b",
      a: "1.0"
    },
    {
      n: ["bus"],
      u: "1f68c",
      a: "0.6"
    },
    {
      n: ["bus venant en sens inverse"],
      u: "1f68d",
      a: "0.7"
    },
    {
      n: ["trolleybus"],
      u: "1f68e",
      a: "1.0"
    },
    {
      n: ["minibus"],
      u: "1f690",
      a: "1.0"
    },
    {
      n: ["ambulance"],
      u: "1f691",
      a: "0.6"
    },
    {
      n: ["camion de pompiers"],
      u: "1f692",
      a: "0.6"
    },
    {
      n: ["voiture de police"],
      u: "1f693",
      a: "0.6"
    },
    {
      n: ["voiture de police venant en sens inverse"],
      u: "1f694",
      a: "0.7"
    },
    {
      n: ["Taxi"],
      u: "1f695",
      a: "0.6"
    },
    {
      n: ["taxi venant en sens inverse"],
      u: "1f696",
      a: "1.0"
    },
    {
      n: ["voiture", "voiture rouge", "automobile"],
      u: "1f697",
      a: "0.6"
    },
    {
      n: ["automobile venant en sens inverse"],
      u: "1f698",
      a: "0.7"
    },
    {
      n: ["voiture bleue", "véhicule récréatif"],
      u: "1f699",
      a: "0.6"
    },
    {
      n: ["camionnette"],
      u: "1f6fb",
      a: "13.0"
    },
    {
      n: ["camion", "camion de livraison"],
      u: "1f69a",
      a: "0.6"
    },
    {
      n: ["camion articulé"],
      u: "1f69b",
      a: "1.0"
    },
    {
      n: ["tracteur"],
      u: "1f69c",
      a: "1.0"
    },
    {
      n: ["voiture de course"],
      u: "1f3ce-fe0f",
      a: "0.7"
    },
    {
      n: ["moto", "moto de course"],
      u: "1f3cd-fe0f",
      a: "0.7"
    },
    {
      n: ["scooter"],
      u: "1f6f5",
      a: "3.0"
    },
    {
      n: ["fauteuil roulant manuel"],
      u: "1f9bd",
      a: "12.0"
    },
    {
      n: ["fauteuil roulant motorisé"],
      u: "1f9bc",
      a: "12.0"
    },
    {
      n: ["pousse-pousse automatique"],
      u: "1f6fa",
      a: "12.0"
    },
    {
      n: ["vélo", "vélo"],
      u: "1f6b2",
      a: "0.6"
    },
    {
      n: ["scooter"],
      u: "1f6f4",
      a: "3.0"
    },
    {
      n: ["skateboard"],
      u: "1f6f9",
      a: "11.0"
    },
    {
      n: ["patin à roulettes"],
      u: "1f6fc",
      a: "13.0"
    },
    {
      n: ["arrêt de bus", "arrêt de bus"],
      u: "1f68f",
      a: "0.6"
    },
    {
      n: ["autoroute"],
      u: "1f6e3-fe0f",
      a: "0.7"
    },
    {
      n: ["voie ferrée"],
      u: "1f6e4-fe0f",
      a: "0.7"
    },
    {
      n: ["baril d'huile"],
      u: "1f6e2-fe0f",
      a: "0.7"
    },
    {
      n: ["pompe à essence", "pompe à carburant"],
      u: "26fd",
      a: "0.6"
    },
    {
      n: ["roue"],
      u: "1f6de",
      a: "14.0"
    },
    {
      n: ["gyrophare", "gyrophare de voitures de police"],
      u: "1f6a8",
      a: "0.6"
    },
    {
      n: ["feu de circulation", "feu de circulation horizontal"],
      u: "1f6a5",
      a: "0.6"
    },
    {
      n: ["feu de circulation vertical"],
      u: "1f6a6",
      a: "1.0"
    },
    {
      n: ["signe octogonal"],
      u: "1f6d1",
      a: "3.0"
    },
    {
      n: ["construction", "signe de construction"],
      u: "1f6a7",
      a: "0.6"
    },
    {
      n: ["ancre"],
      u: "2693",
      a: "0.6"
    },
    {
      n: ["bouée annulaire"],
      u: "1f6df",
      a: "14.0"
    },
    {
      n: ["bateau", "voilier"],
      u: "26f5",
      a: "0.6"
    },
    {
      n: ["canoë"],
      u: "1f6f6",
      a: "3.0"
    },
    {
      n: ["vedette"],
      u: "1f6a4",
      a: "0.6"
    },
    {
      n: ["navire à passagers"],
      u: "1f6f3-fe0f",
      a: "0.7"
    },
    {
      n: ["traversier"],
      u: "26f4-fe0f",
      a: "0.7"
    },
    {
      n: ["bateau à moteur"],
      u: "1f6e5-fe0f",
      a: "0.7"
    },
    {
      n: ["bateau"],
      u: "1f6a2",
      a: "0.6"
    },
    {
      n: ["avion"],
      u: "2708-fe0f",
      a: "0.6"
    },
    {
      n: ["petit avion"],
      u: "1f6e9-fe0f",
      a: "0.7"
    },
    {
      n: ["départ de l'avion"],
      u: "1f6eb",
      a: "1.0"
    },
    {
      n: ["avion arrivant"],
      u: "1f6ec",
      a: "1.0"
    },
    {
      n: ["parachute"],
      u: "1fa82",
      a: "12.0"
    },
    {
      n: ["siège"],
      u: "1f4ba",
      a: "0.6"
    },
    {
      n: ["hélicoptère"],
      u: "1f681",
      a: "1.0"
    },
    {
      n: ["chemin de fer suspendu"],
      u: "1f69f",
      a: "1.0"
    },
    {
      n: ["téléphérique de montagne"],
      u: "1f6a0",
      a: "1.0"
    },
    {
      n: ["tramway aérien"],
      u: "1f6a1",
      a: "1.0"
    },
    {
      n: ["satellite"],
      u: "1f6f0-fe0f",
      a: "0.7"
    },
    {
      n: ["fusée"],
      u: "1f680",
      a: "0.6"
    },
    {
      n: ["soucoupe volante"],
      u: "1f6f8",
      a: "5.0"
    },
    {
      n: ["cloche de chasseur"],
      u: "1f6ce-fe0f",
      a: "0.7"
    },
    {
      n: ["bagage"],
      u: "1f9f3",
      a: "11.0"
    },
    {
      n: ["sablier"],
      u: "231b",
      a: "0.6"
    },
    {
      n: ["sablier qui coule du sable", "sablier avec du sable qui coule"],
      u: "23f3",
      a: "0.6"
    },
    {
      n: ["montre"],
      u: "231a",
      a: "0.6"
    },
    {
      n: ["réveil"],
      u: "23f0",
      a: "0.6"
    },
    {
      n: ["chronomètre"],
      u: "23f1-fe0f",
      a: "1.0"
    },
    {
      n: ["horloge minuterie"],
      u: "23f2-fe0f",
      a: "1.0"
    },
    {
      n: ["horloge de cheminée"],
      u: "1f570-fe0f",
      a: "0.7"
    },
    {
      n: ["horloge12", "cadran de l'horloge midi"],
      u: "1f55b",
      a: "0.6"
    },
    {
      n: ["horloge1230", "cadran d'horloge midi trente"],
      u: "1f567",
      a: "0.7"
    },
    {
      n: ["horloge1", "cadran d'horloge une heure"],
      u: "1f550",
      a: "0.6"
    },
    {
      n: ["horloge130", "cadran d'horloge une heure trente"],
      u: "1f55c",
      a: "0.7"
    },
    {
      n: ["horloge2", "cadran de l'horloge deux heures"],
      u: "1f551",
      a: "0.6"
    },
    {
      n: ["horloge230", "cadran d'horloge deux heures trente"],
      u: "1f55d",
      a: "0.7"
    },
    {
      n: ["horloge3", "cadran de l'horloge trois heures"],
      u: "1f552",
      a: "0.6"
    },
    {
      n: ["horloge330", "cadran d'horloge trois heures trente"],
      u: "1f55e",
      a: "0.7"
    },
    {
      n: ["horloge4", "cadran de l'horloge quatre heures"],
      u: "1f553",
      a: "0.6"
    },
    {
      n: ["horloge430", "cadran d'horloge quatre heures trente"],
      u: "1f55f",
      a: "0.7"
    },
    {
      n: ["horloge5", "cadran de l'horloge cinq heures"],
      u: "1f554",
      a: "0.6"
    },
    {
      n: ["horloge530", "cadran d'horloge cinq heures trente"],
      u: "1f560",
      a: "0.7"
    },
    {
      n: ["horloge6", "cadran de l'horloge six heures"],
      u: "1f555",
      a: "0.6"
    },
    {
      n: ["horloge630", "cadran d'horloge six heures trente"],
      u: "1f561",
      a: "0.7"
    },
    {
      n: ["horloge7", "cadran de l'horloge sept heures"],
      u: "1f556",
      a: "0.6"
    },
    {
      n: ["horloge730", "cadran d'horloge sept heures trente"],
      u: "1f562",
      a: "0.7"
    },
    {
      n: ["horloge8", "cadran de l'horloge huit heures"],
      u: "1f557",
      a: "0.6"
    },
    {
      n: ["horloge830", "cadran d'horloge huit heures trente"],
      u: "1f563",
      a: "0.7"
    },
    {
      n: ["horloge9", "cadran de l'horloge neuf heures"],
      u: "1f558",
      a: "0.6"
    },
    {
      n: ["horloge930", "cadran d'horloge neuf heures trente"],
      u: "1f564",
      a: "0.7"
    },
    {
      n: ["horloge10", "cadran de l'horloge dix heures"],
      u: "1f559",
      a: "0.6"
    },
    {
      n: ["horloge1030", "cadran d'horloge dix heures trente"],
      u: "1f565",
      a: "0.7"
    },
    {
      n: ["horloge11", "cadran de l'horloge onze heures"],
      u: "1f55a",
      a: "0.6"
    },
    {
      n: ["horloge1130", "cadran de l'horloge onze heures trente"],
      u: "1f566",
      a: "0.7"
    },
    {
      n: ["nouvelle lune", "symbole de la nouvelle lune"],
      u: "1f311",
      a: "0.6"
    },
    {
      n: [
        "croissant de lune croissant",
        "symbole du croissant de lune croissant"
      ],
      u: "1f312",
      a: "1.0"
    },
    {
      n: ["premier quartier de lune", "symbole du premier quartier de lune"],
      u: "1f313",
      a: "0.6"
    },
    {
      n: [
        "lune",
        "lune gibbeuse croissante",
        "symbole de la lune gibbeuse croissante"
      ],
      u: "1f314",
      a: "0.6"
    },
    {
      n: ["pleine lune", "symbole de la pleine lune"],
      u: "1f315",
      a: "0.6"
    },
    {
      n: [
        "lune gibbeuse décroissante",
        "symbole de la lune gibbeuse décroissante"
      ],
      u: "1f316",
      a: "1.0"
    },
    {
      n: ["dernier quartier de lune", "symbole du dernier quartier de lune"],
      u: "1f317",
      a: "1.0"
    },
    {
      n: [
        "croissant de lune décroissant",
        "symbole du croissant de lune décroissant"
      ],
      u: "1f318",
      a: "1.0"
    },
    {
      n: ["croissant de lune"],
      u: "1f319",
      a: "0.6"
    },
    {
      n: ["nouvelle lune avec visage"],
      u: "1f31a",
      a: "1.0"
    },
    {
      n: ["premier quartier de lune avec visage"],
      u: "1f31b",
      a: "0.6"
    },
    {
      n: ["dernier quartier de lune avec visage"],
      u: "1f31c",
      a: "0.7"
    },
    {
      n: ["thermomètre"],
      u: "1f321-fe0f",
      a: "0.7"
    },
    {
      n: ["ensoleillé", "soleil noir avec des rayons"],
      u: "2600-fe0f",
      a: "0.6"
    },
    {
      n: ["pleine lune avec visage"],
      u: "1f31d",
      a: "1.0"
    },
    {
      n: ["soleil avec visage"],
      u: "1f31e",
      a: "1.0"
    },
    {
      n: ["planète aux anneaux"],
      u: "1fa90",
      a: "12.0"
    },
    {
      n: ["étoile", "étoile moyenne blanche"],
      u: "2b50",
      a: "0.6"
    },
    {
      n: ["étoile2", "étoile brillante"],
      u: "1f31f",
      a: "0.6"
    },
    {
      n: ["étoiles", "étoile filante"],
      u: "1f320",
      a: "0.6"
    },
    {
      n: ["Voie lactée"],
      u: "1f30c",
      a: "0.6"
    },
    {
      n: ["nuage"],
      u: "2601-fe0f",
      a: "0.6"
    },
    {
      n: ["partiellement ensoleillé", "soleil derrière un nuage"],
      u: "26c5",
      a: "0.6"
    },
    {
      n: ["nuage d'orage et pluie", "nuage avec éclairs et pluie"],
      u: "26c8-fe0f",
      a: "0.7"
    },
    {
      n: [
        "généralement ensoleillé",
        "soleil petit nuage",
        "soleil derrière un petit nuage"
      ],
      u: "1f324-fe0f",
      a: "0.7"
    },
    {
      n: [
        "à peine ensoleillé",
        "soleil derrière un nuage",
        "soleil derrière un gros nuage"
      ],
      u: "1f325-fe0f",
      a: "0.7"
    },
    {
      n: [
        "pluie partiellement ensoleillée",
        "soleil derrière un nuage de pluie"
      ],
      u: "1f326-fe0f",
      a: "0.7"
    },
    {
      n: ["nuage de pluie", "nuage avec pluie"],
      u: "1f327-fe0f",
      a: "0.7"
    },
    {
      n: ["nuage de neige", "nuage avec de la neige"],
      u: "1f328-fe0f",
      a: "0.7"
    },
    {
      n: ["foudre", "nuage d'éclair", "nuage avec des éclairs"],
      u: "1f329-fe0f",
      a: "0.7"
    },
    {
      n: ["tornade", "nuage de tornade"],
      u: "1f32a-fe0f",
      a: "0.7"
    },
    {
      n: ["brouillard"],
      u: "1f32b-fe0f",
      a: "0.7"
    },
    {
      n: ["face au vent", "visage soufflé par le vent"],
      u: "1f32c-fe0f",
      a: "0.7"
    },
    {
      n: ["cyclone"],
      u: "1f300",
      a: "0.6"
    },
    {
      n: ["arc-en-ciel"],
      u: "1f308",
      a: "0.6"
    },
    {
      n: ["parapluie fermé"],
      u: "1f302",
      a: "0.6"
    },
    {
      n: ["parapluie"],
      u: "2602-fe0f",
      a: "0.7"
    },
    {
      n: ["parapluie avec des gouttes de pluie"],
      u: "2614",
      a: "0.6"
    },
    {
      n: ["parapluie au sol"],
      u: "26f1-fe0f",
      a: "0.7"
    },
    {
      n: ["zapper", "signe de haute tension"],
      u: "26a1",
      a: "0.6"
    },
    {
      n: ["flocon de neige"],
      u: "2744-fe0f",
      a: "0.6"
    },
    {
      n: ["bonhomme de neige"],
      u: "2603-fe0f",
      a: "0.7"
    },
    {
      n: ["bonhomme de neige sans neige"],
      u: "26c4",
      a: "0.6"
    },
    {
      n: ["comète"],
      u: "2604-fe0f",
      a: "1.0"
    },
    {
      n: ["feu"],
      u: "1f525",
      a: "0.6"
    },
    {
      n: ["gouttelette"],
      u: "1f4a7",
      a: "0.6"
    },
    {
      n: ["océan", "vague d'eau"],
      u: "1f30a",
      a: "0.6"
    }
  ],
  activities: [
    {
      n: ["citrouille-lanterne", "citrouille d'Halloween"],
      u: "1f383",
      a: "0.6"
    },
    {
      n: ["arbre de Noël"],
      u: "1f384",
      a: "0.6"
    },
    {
      n: ["feux d'artifice"],
      u: "1f386",
      a: "0.6"
    },
    {
      n: ["cierge magique", "feu d'artifice"],
      u: "1f387",
      a: "0.6"
    },
    {
      n: ["pétard"],
      u: "1f9e8",
      a: "11.0"
    },
    {
      n: ["scintille"],
      u: "2728",
      a: "0.6"
    },
    {
      n: ["ballon"],
      u: "1f388",
      a: "0.6"
    },
    {
      n: ["tada", "fête popper"],
      u: "1f389",
      a: "0.6"
    },
    {
      n: ["boule de confettis"],
      u: "1f38a",
      a: "0.6"
    },
    {
      n: ["arbre tanabata"],
      u: "1f38b",
      a: "0.6"
    },
    {
      n: ["bambou", "décoration en pin"],
      u: "1f38d",
      a: "0.6"
    },
    {
      n: ["poupées", "poupées japonaises"],
      u: "1f38e",
      a: "0.6"
    },
    {
      n: ["drapeaux", "streamer de carpe"],
      u: "1f38f",
      a: "0.6"
    },
    {
      n: ["carillon éolien"],
      u: "1f390",
      a: "0.6"
    },
    {
      n: ["scène de riz", "cérémonie d'observation de la lune"],
      u: "1f391",
      a: "0.6"
    },
    {
      n: ["enveloppe rouge", "enveloppe cadeau rouge"],
      u: "1f9e7",
      a: "11.0"
    },
    {
      n: ["ruban"],
      u: "1f380",
      a: "0.6"
    },
    {
      n: ["cadeau", "cadeau emballé"],
      u: "1f381",
      a: "0.6"
    },
    {
      n: ["ruban de rappel"],
      u: "1f397-fe0f",
      a: "0.7"
    },
    {
      n: ["billets d'entrée"],
      u: "1f39f-fe0f",
      a: "0.7"
    },
    {
      n: ["billet"],
      u: "1f3ab",
      a: "0.6"
    },
    {
      n: ["médaille", "médaille militaire"],
      u: "1f396-fe0f",
      a: "0.7"
    },
    {
      n: ["trophée"],
      u: "1f3c6",
      a: "0.6"
    },
    {
      n: ["médaille sportive"],
      u: "1f3c5",
      a: "1.0"
    },
    {
      n: ["médaille de la première place"],
      u: "1f947",
      a: "3.0"
    },
    {
      n: ["médaille de la deuxième place"],
      u: "1f948",
      a: "3.0"
    },
    {
      n: ["médaille de la troisième place"],
      u: "1f949",
      a: "3.0"
    },
    {
      n: ["football", "ballon de football"],
      u: "26bd",
      a: "0.6"
    },
    {
      n: ["base-ball"],
      u: "26be",
      a: "0.6"
    },
    {
      n: ["balle molle"],
      u: "1f94e",
      a: "11.0"
    },
    {
      n: ["basket-ball", "basket et cerceau"],
      u: "1f3c0",
      a: "0.6"
    },
    {
      n: ["volley-ball"],
      u: "1f3d0",
      a: "1.0"
    },
    {
      n: ["football", "football américain"],
      u: "1f3c8",
      a: "0.6"
    },
    {
      n: ["rugby-football"],
      u: "1f3c9",
      a: "1.0"
    },
    {
      n: ["tennis", "raquette et balle de tennis"],
      u: "1f3be",
      a: "0.6"
    },
    {
      n: ["disque volant"],
      u: "1f94f",
      a: "11.0"
    },
    {
      n: ["bowling"],
      u: "1f3b3",
      a: "0.6"
    },
    {
      n: ["batte et balle de cricket"],
      u: "1f3cf",
      a: "1.0"
    },
    {
      n: ["bâton et balle de hockey sur gazon"],
      u: "1f3d1",
      a: "1.0"
    },
    {
      n: ["bâton et rondelle de hockey sur glace"],
      u: "1f3d2",
      a: "1.0"
    },
    {
      n: ["lacrosse", "bâton et balle de crosse"],
      u: "1f94d",
      a: "11.0"
    },
    {
      n: ["raquette et balle de tennis de table"],
      u: "1f3d3",
      a: "1.0"
    },
    {
      n: ["raquette de badminton et volant"],
      u: "1f3f8",
      a: "1.0"
    },
    {
      n: ["gant de boxe"],
      u: "1f94a",
      a: "3.0"
    },
    {
      n: ["uniforme d'arts martiaux"],
      u: "1f94b",
      a: "3.0"
    },
    {
      n: ["filet de but"],
      u: "1f945",
      a: "3.0"
    },
    {
      n: ["golf", "drapeau dans le trou"],
      u: "26f3",
      a: "0.6"
    },
    {
      n: ["patin à glace"],
      u: "26f8-fe0f",
      a: "0.7"
    },
    {
      n: ["canne à pêche et poisson"],
      u: "1f3a3",
      a: "0.6"
    },
    {
      n: ["masque de plongée"],
      u: "1f93f",
      a: "12.0"
    },
    {
      n: ["chemise de course avec ceinture"],
      u: "1f3bd",
      a: "0.6"
    },
    {
      n: ["ski", "ski et chaussure de ski"],
      u: "1f3bf",
      a: "0.6"
    },
    {
      n: ["traîneau"],
      u: "1f6f7",
      a: "5.0"
    },
    {
      n: ["pierre à friser"],
      u: "1f94c",
      a: "5.0"
    },
    {
      n: ["dard", "coup direct"],
      u: "1f3af",
      a: "0.6"
    },
    {
      n: ["yo-yo"],
      u: "1fa80",
      a: "12.0"
    },
    {
      n: ["cerf-volant"],
      u: "1fa81",
      a: "12.0"
    },
    {
      n: ["8balles", "billard"],
      u: "1f3b1",
      a: "0.6"
    },
    {
      n: ["boule de cristal"],
      u: "1f52e",
      a: "0.6"
    },
    {
      n: ["baguette magique"],
      u: "1fa84",
      a: "13.0"
    },
    {
      n: ["amulette de Nazar"],
      u: "1f9ff",
      a: "11.0"
    },
    {
      n: ["Hamsa"],
      u: "1faac",
      a: "14.0"
    },
    {
      n: ["jeu vidéo"],
      u: "1f3ae",
      a: "0.6"
    },
    {
      n: ["manette de jeu"],
      u: "1f579-fe0f",
      a: "0.7"
    },
    {
      n: ["machine à sous"],
      u: "1f3b0",
      a: "0.6"
    },
    {
      n: ["jeu mourir"],
      u: "1f3b2",
      a: "0.6"
    },
    {
      n: ["puzzle", "pièce de puzzle"],
      u: "1f9e9",
      a: "11.0"
    },
    {
      n: ["ours en peluche"],
      u: "1f9f8",
      a: "11.0"
    },
    {
      n: ["pinata"],
      u: "1fa85",
      a: "13.0"
    },
    {
      n: ["boule à facettes"],
      u: "1faa9",
      a: "14.0"
    },
    {
      n: ["poupées gigognes"],
      u: "1fa86",
      a: "13.0"
    },
    {
      n: ["piques", "costume de pique noir"],
      u: "2660-fe0f",
      a: "0.6"
    },
    {
      n: ["cœurs", "costume coeur noir"],
      u: "2665-fe0f",
      a: "0.6"
    },
    {
      n: ["diamants", "costume de diamant noir"],
      u: "2666-fe0f",
      a: "0.6"
    },
    {
      n: ["clubs", "costume de club noir"],
      u: "2663-fe0f",
      a: "0.6"
    },
    {
      n: ["pion d'échecs"],
      u: "265f-fe0f",
      a: "11.0"
    },
    {
      n: ["farceur noir", "carte à jouer joker noir"],
      u: "1f0cf",
      a: "0.6"
    },
    {
      n: ["mahjong", "tuile de mahjong dragon rouge"],
      u: "1f004",
      a: "0.6"
    },
    {
      n: ["cartes à jouer fleurs"],
      u: "1f3b4",
      a: "0.6"
    },
    {
      n: ["arts du spectacle"],
      u: "1f3ad",
      a: "0.6"
    },
    {
      n: ["photo encadrée", "cadre avec photo"],
      u: "1f5bc-fe0f",
      a: "0.7"
    },
    {
      n: ["art", "palette d'artiste"],
      u: "1f3a8",
      a: "0.6"
    },
    { n: ["éclaboussure"], u: "1fadf", a: "16.0" },
    {
      n: ["fil", "bobine de fil"],
      u: "1f9f5",
      a: "11.0"
    },
    {
      n: ["aiguille à coudre"],
      u: "1faa1",
      a: "13.0"
    },
    {
      n: ["fil", "pelote de laine"],
      u: "1f9f6",
      a: "11.0"
    },
    {
      n: ["noeud"],
      u: "1faa2",
      a: "13.0"
    }
  ],
  objects: [
    {
      n: ["lunettes"],
      u: "1f453",
      a: "0.6"
    },
    {
      n: ["lunettes de soleil", "lunettes de soleil sombres"],
      u: "1f576-fe0f",
      a: "0.7"
    },
    {
      n: ["des lunettes"],
      u: "1f97d",
      a: "11.0"
    },
    {
      n: ["blouse de laboratoire"],
      u: "1f97c",
      a: "11.0"
    },
    {
      n: ["gilet de sécurité"],
      u: "1f9ba",
      a: "12.0"
    },
    {
      n: ["cravate"],
      u: "1f454",
      a: "0.6"
    },
    {
      n: ["chemise", "T-shirt", "T-shirt"],
      u: "1f455",
      a: "0.6"
    },
    {
      n: ["jeans"],
      u: "1f456",
      a: "0.6"
    },
    {
      n: ["foulard"],
      u: "1f9e3",
      a: "5.0"
    },
    {
      n: ["gants"],
      u: "1f9e4",
      a: "5.0"
    },
    {
      n: ["manteau"],
      u: "1f9e5",
      a: "5.0"
    },
    {
      n: ["chaussettes"],
      u: "1f9e6",
      a: "5.0"
    },
    {
      n: ["robe"],
      u: "1f457",
      a: "0.6"
    },
    {
      n: ["kimono"],
      u: "1f458",
      a: "0.6"
    },
    {
      n: ["sari"],
      u: "1f97b",
      a: "12.0"
    },
    {
      n: ["maillot de bain une pièce"],
      u: "1fa71",
      a: "12.0"
    },
    {
      n: ["slips"],
      u: "1fa72",
      a: "12.0"
    },
    {
      n: ["shorts"],
      u: "1fa73",
      a: "12.0"
    },
    {
      n: ["bikini"],
      u: "1f459",
      a: "0.6"
    },
    {
      n: ["vêtements pour femmes"],
      u: "1f45a",
      a: "0.6"
    },
    {
      n: ["bourse"],
      u: "1f45b",
      a: "0.6"
    },
    {
      n: ["sac à main"],
      u: "1f45c",
      a: "0.6"
    },
    {
      n: ["poche"],
      u: "1f45d",
      a: "0.6"
    },
    {
      n: ["sacs à provisions"],
      u: "1f6cd-fe0f",
      a: "0.7"
    },
    {
      n: ["cartable"],
      u: "1f392",
      a: "0.6"
    },
    {
      n: ["sandale tong"],
      u: "1fa74",
      a: "13.0"
    },
    {
      n: ["chaussure", "chaussure homme"],
      u: "1f45e",
      a: "0.6"
    },
    {
      n: ["chaussure de sport"],
      u: "1f45f",
      a: "0.6"
    },
    {
      n: ["botte de randonnée"],
      u: "1f97e",
      a: "11.0"
    },
    {
      n: ["chaussure plate", "chaussure plate femme"],
      u: "1f97f",
      a: "11.0"
    },
    {
      n: ["talon haut", "chaussure à talons hauts"],
      u: "1f460",
      a: "0.6"
    },
    {
      n: ["sandale", "sandale femme"],
      u: "1f461",
      a: "0.6"
    },
    {
      n: ["chaussures de ballet"],
      u: "1fa70",
      a: "12.0"
    },
    {
      n: ["botte", "bottes femme"],
      u: "1f462",
      a: "0.6"
    },
    {
      n: ["couronne"],
      u: "1f451",
      a: "0.6"
    },
    {
      n: ["chapeau de femme"],
      u: "1f452",
      a: "0.6"
    },
    {
      n: ["chapeau haut de forme", "chapeau haut de forme"],
      u: "1f3a9",
      a: "0.6"
    },
    {
      n: ["planche de mortier", "casquette de graduation"],
      u: "1f393",
      a: "0.6"
    },
    {
      n: ["plafond facturé"],
      u: "1f9e2",
      a: "5.0"
    },
    {
      n: ["casque militaire"],
      u: "1fa96",
      a: "13.0"
    },
    {
      n: ["casque de secouriste", "casque avec croix blanche"],
      u: "26d1-fe0f",
      a: "0.7"
    },
    {
      n: ["chapelet"],
      u: "1f4ff",
      a: "1.0"
    },
    {
      n: ["rouge à lèvres"],
      u: "1f484",
      a: "0.6"
    },
    {
      n: ["anneau"],
      u: "1f48d",
      a: "0.6"
    },
    {
      n: ["gemme", "pierre précieuse"],
      u: "1f48e",
      a: "0.6"
    },
    { n: ["coffre au trésor"], u: "1fa8e", a: "17.0" },
    {
      n: ["muet", "haut-parleur avec course d'annulation"],
      u: "1f507",
      a: "1.0"
    },
    {
      n: ["conférencier"],
      u: "1f508",
      a: "0.7"
    },
    {
      n: ["son", "haut-parleur avec une onde sonore"],
      u: "1f509",
      a: "1.0"
    },
    {
      n: ["son fort", "haut-parleur avec trois ondes sonores"],
      u: "1f50a",
      a: "0.6"
    },
    {
      n: ["haut-parleur", "haut-parleur de sonorisation"],
      u: "1f4e2",
      a: "0.6"
    },
    {
      n: ["méga", "applaudissements, mégaphone"],
      u: "1f4e3",
      a: "0.6"
    },
    {
      n: ["klaxon postal"],
      u: "1f4ef",
      a: "1.0"
    },
    {
      n: ["cloche"],
      u: "1f514",
      a: "0.6"
    },
    {
      n: ["pas de cloche", "cloche avec coup d'annulation"],
      u: "1f515",
      a: "1.0"
    },
    {
      n: ["partition musicale"],
      u: "1f3bc",
      a: "0.6"
    },
    {
      n: ["note de musique"],
      u: "1f3b5",
      a: "0.6"
    },
    {
      n: ["remarques", "plusieurs notes de musique"],
      u: "1f3b6",
      a: "0.6"
    },
    {
      n: ["micro de studio"],
      u: "1f399-fe0f",
      a: "0.7"
    },
    {
      n: ["curseur de niveau"],
      u: "1f39a-fe0f",
      a: "0.7"
    },
    {
      n: ["boutons de commande"],
      u: "1f39b-fe0f",
      a: "0.7"
    },
    {
      n: ["microphone"],
      u: "1f3a4",
      a: "0.6"
    },
    {
      n: ["casque", "écouteurs"],
      u: "1f3a7",
      a: "0.6"
    },
    {
      n: ["radio"],
      u: "1f4fb",
      a: "0.6"
    },
    {
      n: ["saxophone"],
      u: "1f3b7",
      a: "0.6"
    },
    {
      n: ["accordéon"],
      u: "1fa97",
      a: "13.0"
    },
    {
      n: ["guitare"],
      u: "1f3b8",
      a: "0.6"
    },
    {
      n: ["clavier musical"],
      u: "1f3b9",
      a: "0.6"
    },
    {
      n: ["trompette"],
      u: "1f3ba",
      a: "0.6"
    },
    { n: ["trombone"], u: "1fa8a", a: "17.0" },
    {
      n: ["violon"],
      u: "1f3bb",
      a: "0.6"
    },
    {
      n: ["banjo"],
      u: "1fa95",
      a: "12.0"
    },
    { n: ["harpe"], u: "1fa89", a: "16.0" },
    {
      n: ["tambour avec des baguettes"],
      u: "1f941",
      a: "3.0"
    },
    {
      n: ["tambour long"],
      u: "1fa98",
      a: "13.0"
    },
    {
      n: ["iPhone", "téléphone mobile"],
      u: "1f4f1",
      a: "0.6"
    },
    {
      n: ["appel", "téléphone portable avec flèche vers la droite à gauche"],
      u: "1f4f2",
      a: "0.6"
    },
    {
      n: ["téléphone", "téléphone", "téléphone noir"],
      u: "260e-fe0f",
      a: "0.6"
    },
    {
      n: ["récepteur téléphonique"],
      u: "1f4de",
      a: "0.6"
    },
    {
      n: ["téléavertisseur"],
      u: "1f4df",
      a: "0.6"
    },
    {
      n: ["fax", "télécopieur"],
      u: "1f4e0",
      a: "0.6"
    },
    {
      n: ["batterie"],
      u: "1f50b",
      a: "0.6"
    },
    {
      n: ["batterie faible"],
      u: "1faab",
      a: "14.0"
    },
    {
      n: ["prise électrique"],
      u: "1f50c",
      a: "0.6"
    },
    {
      n: ["ordinateur", "ordinateur personnel"],
      u: "1f4bb",
      a: "0.6"
    },
    {
      n: ["ordinateur de bureau"],
      u: "1f5a5-fe0f",
      a: "0.7"
    },
    {
      n: ["imprimante"],
      u: "1f5a8-fe0f",
      a: "0.7"
    },
    {
      n: ["clavier"],
      u: "2328-fe0f",
      a: "1.0"
    },
    {
      n: ["souris d'ordinateur", "souris à trois boutons"],
      u: "1f5b1-fe0f",
      a: "0.7"
    },
    {
      n: ["boule de commande"],
      u: "1f5b2-fe0f",
      a: "0.7"
    },
    {
      n: ["minidisque"],
      u: "1f4bd",
      a: "0.6"
    },
    {
      n: ["disquette"],
      u: "1f4be",
      a: "0.6"
    },
    {
      n: ["CD", "disque optique"],
      u: "1f4bf",
      a: "0.6"
    },
    {
      n: ["DVD"],
      u: "1f4c0",
      a: "0.6"
    },
    {
      n: ["abaque"],
      u: "1f9ee",
      a: "11.0"
    },
    {
      n: ["caméra de cinéma"],
      u: "1f3a5",
      a: "0.6"
    },
    {
      n: ["cadres de films"],
      u: "1f39e-fe0f",
      a: "0.7"
    },
    {
      n: ["projecteur de film"],
      u: "1f4fd-fe0f",
      a: "0.7"
    },
    {
      n: ["battant", "clap"],
      u: "1f3ac",
      a: "0.6"
    },
    {
      n: ["TV", "télévision"],
      u: "1f4fa",
      a: "0.6"
    },
    {
      n: ["caméra"],
      u: "1f4f7",
      a: "0.6"
    },
    {
      n: ["appareil photo avec flash"],
      u: "1f4f8",
      a: "1.0"
    },
    {
      n: ["caméra vidéo"],
      u: "1f4f9",
      a: "0.6"
    },
    {
      n: ["vhs", "vidéocassette"],
      u: "1f4fc",
      a: "0.6"
    },
    {
      n: ["mag", "loupe pointant vers la gauche"],
      u: "1f50d",
      a: "0.6"
    },
    {
      n: ["mag à droite", "loupe pointant vers la droite"],
      u: "1f50e",
      a: "0.6"
    },
    {
      n: ["bougie"],
      u: "1f56f-fe0f",
      a: "0.7"
    },
    {
      n: ["ampoule", "ampoule électrique"],
      u: "1f4a1",
      a: "0.6"
    },
    {
      n: ["lampe de poche", "torche électrique"],
      u: "1f526",
      a: "0.6"
    },
    {
      n: ["lanterne", "lanterne izakaya"],
      u: "1f3ee",
      a: "0.6"
    },
    {
      n: ["lampe diya"],
      u: "1fa94",
      a: "12.0"
    },
    {
      n: ["carnet avec couverture décorative"],
      u: "1f4d4",
      a: "0.6"
    },
    {
      n: ["livre fermé"],
      u: "1f4d5",
      a: "0.6"
    },
    {
      n: ["livre", "livre ouvert"],
      u: "1f4d6",
      a: "0.6"
    },
    {
      n: ["livre vert"],
      u: "1f4d7",
      a: "0.6"
    },
    {
      n: ["livre bleu"],
      u: "1f4d8",
      a: "0.6"
    },
    {
      n: ["livre orange"],
      u: "1f4d9",
      a: "0.6"
    },
    {
      n: ["livres"],
      u: "1f4da",
      a: "0.6"
    },
    {
      n: ["carnet de notes"],
      u: "1f4d3",
      a: "0.6"
    },
    {
      n: ["grand livre"],
      u: "1f4d2",
      a: "0.6"
    },
    {
      n: ["page avec boucle"],
      u: "1f4c3",
      a: "0.6"
    },
    {
      n: ["rouleau"],
      u: "1f4dc",
      a: "0.6"
    },
    {
      n: ["page vers le haut"],
      u: "1f4c4",
      a: "0.6"
    },
    {
      n: ["journal"],
      u: "1f4f0",
      a: "0.6"
    },
    {
      n: ["journal enroulé", "journal enroulé"],
      u: "1f5de-fe0f",
      a: "0.7"
    },
    {
      n: ["onglets de favoris"],
      u: "1f4d1",
      a: "0.6"
    },
    {
      n: ["signet"],
      u: "1f516",
      a: "0.6"
    },
    {
      n: ["étiquette"],
      u: "1f3f7-fe0f",
      a: "0.7"
    },
    {
      n: ["sac d'argent", "sac d'argent"],
      u: "1f4b0",
      a: "0.6"
    },
    {
      n: ["pièce de monnaie"],
      u: "1fa99",
      a: "13.0"
    },
    {
      n: ["yen", "billet de banque avec le signe du yen"],
      u: "1f4b4",
      a: "0.6"
    },
    {
      n: ["dollar", "billet de banque avec signe dollar"],
      u: "1f4b5",
      a: "0.6"
    },
    {
      n: ["euro", "billet de banque avec signe euro"],
      u: "1f4b6",
      a: "1.0"
    },
    {
      n: ["livre", "billet de banque avec signe dièse"],
      u: "1f4b7",
      a: "1.0"
    },
    {
      n: ["argent avec des ailes"],
      u: "1f4b8",
      a: "0.6"
    },
    {
      n: ["carte de crédit"],
      u: "1f4b3",
      a: "0.6"
    },
    {
      n: ["reçu"],
      u: "1f9fe",
      a: "11.0"
    },
    {
      n: ["graphique", "graphique avec tendance à la hausse et signe du yen"],
      u: "1f4b9",
      a: "0.6"
    },
    {
      n: ["e-mail", "enveloppe"],
      u: "2709-fe0f",
      a: "0.6"
    },
    {
      n: ["e-mail", "symbole de courrier électronique"],
      u: "1f4e7",
      a: "0.6"
    },
    {
      n: ["enveloppe entrante"],
      u: "1f4e8",
      a: "0.6"
    },
    {
      n: [
        "enveloppe avec flèche",
        "enveloppe avec flèche vers le bas au-dessus"
      ],
      u: "1f4e9",
      a: "0.6"
    },
    {
      n: ["bac de boîte d'envoi"],
      u: "1f4e4",
      a: "0.6"
    },
    {
      n: ["bac de réception"],
      u: "1f4e5",
      a: "0.6"
    },
    {
      n: ["emballer"],
      u: "1f4e6",
      a: "0.6"
    },
    {
      n: ["boîte aux lettres", "boîte aux lettres fermée avec drapeau levé"],
      u: "1f4eb",
      a: "0.6"
    },
    {
      n: [
        "boîte aux lettres fermée",
        "boîte aux lettres fermée avec drapeau abaissé"
      ],
      u: "1f4ea",
      a: "0.6"
    },
    {
      n: [
        "boîte aux lettres avec courrier",
        "boîte aux lettres ouverte avec drapeau levé"
      ],
      u: "1f4ec",
      a: "0.7"
    },
    {
      n: [
        "boîte aux lettres sans courrier",
        "boîte aux lettres ouverte avec drapeau abaissé"
      ],
      u: "1f4ed",
      a: "0.7"
    },
    {
      n: ["boîte aux lettres"],
      u: "1f4ee",
      a: "0.6"
    },
    {
      n: ["urne avec bulletin de vote"],
      u: "1f5f3-fe0f",
      a: "0.7"
    },
    {
      n: ["crayon", "crayon2"],
      u: "270f-fe0f",
      a: "0.6"
    },
    {
      n: ["plume noire"],
      u: "2712-fe0f",
      a: "0.6"
    },
    {
      n: ["stylo plume", "stylo plume en bas à gauche"],
      u: "1f58b-fe0f",
      a: "0.7"
    },
    {
      n: ["stylo", "stylo à bille en bas à gauche"],
      u: "1f58a-fe0f",
      a: "0.7"
    },
    {
      n: ["pinceau", "pinceau en bas à gauche"],
      u: "1f58c-fe0f",
      a: "0.7"
    },
    {
      n: ["crayon", "crayon en bas à gauche"],
      u: "1f58d-fe0f",
      a: "0.7"
    },
    {
      n: ["note", "crayon"],
      u: "1f4dd",
      a: "0.6"
    },
    {
      n: ["mallette"],
      u: "1f4bc",
      a: "0.6"
    },
    {
      n: ["dossier de fichiers"],
      u: "1f4c1",
      a: "0.6"
    },
    {
      n: ["ouvrir le dossier de fichiers"],
      u: "1f4c2",
      a: "0.6"
    },
    {
      n: ["séparateurs de fiches"],
      u: "1f5c2-fe0f",
      a: "0.7"
    },
    {
      n: ["date", "calendrier"],
      u: "1f4c5",
      a: "0.6"
    },
    {
      n: ["calendrier", "calendrier détachable"],
      u: "1f4c6",
      a: "0.6"
    },
    {
      n: ["bloc-notes à spirale", "bloc-notes en spirale"],
      u: "1f5d2-fe0f",
      a: "0.7"
    },
    {
      n: ["calendrier en spirale", "bloc-calendrier en spirale"],
      u: "1f5d3-fe0f",
      a: "0.7"
    },
    {
      n: ["fiche"],
      u: "1f4c7",
      a: "0.6"
    },
    {
      n: ["graphique avec tendance à la hausse"],
      u: "1f4c8",
      a: "0.6"
    },
    {
      n: ["graphique avec tendance à la baisse"],
      u: "1f4c9",
      a: "0.6"
    },
    {
      n: ["graphique à barres"],
      u: "1f4ca",
      a: "0.6"
    },
    {
      n: ["presse-papiers"],
      u: "1f4cb",
      a: "0.6"
    },
    {
      n: ["punaise"],
      u: "1f4cc",
      a: "0.6"
    },
    {
      n: ["punaise ronde"],
      u: "1f4cd",
      a: "0.6"
    },
    {
      n: ["trombone"],
      u: "1f4ce",
      a: "0.6"
    },
    {
      n: ["trombones liés"],
      u: "1f587-fe0f",
      a: "0.7"
    },
    {
      n: ["règle droite"],
      u: "1f4cf",
      a: "0.6"
    },
    {
      n: ["règle triangulaire"],
      u: "1f4d0",
      a: "0.6"
    },
    {
      n: ["ciseaux", "ciseaux noirs"],
      u: "2702-fe0f",
      a: "0.6"
    },
    {
      n: ["boîte à fiches"],
      u: "1f5c3-fe0f",
      a: "0.7"
    },
    {
      n: ["classeur"],
      u: "1f5c4-fe0f",
      a: "0.7"
    },
    {
      n: ["corbeille"],
      u: "1f5d1-fe0f",
      a: "0.7"
    },
    {
      n: ["verrouillage"],
      u: "1f512",
      a: "0.6"
    },
    {
      n: ["ouvrir", "ouvrir la serrure"],
      u: "1f513",
      a: "0.6"
    },
    {
      n: ["verrouiller avec un stylo à encre"],
      u: "1f50f",
      a: "0.6"
    },
    {
      n: ["serrure fermée avec clé"],
      u: "1f510",
      a: "0.6"
    },
    {
      n: ["clé"],
      u: "1f511",
      a: "0.6"
    },
    {
      n: ["ancienne clé"],
      u: "1f5dd-fe0f",
      a: "0.7"
    },
    {
      n: ["marteau"],
      u: "1f528",
      a: "0.6"
    },
    {
      n: ["hache"],
      u: "1fa93",
      a: "12.0"
    },
    {
      n: ["prendre"],
      u: "26cf-fe0f",
      a: "0.7"
    },
    {
      n: ["marteau et pioche"],
      u: "2692-fe0f",
      a: "1.0"
    },
    { n: ["pelle"], u: "1fa8f", a: "16.0" },
    {
      n: ["marteau et clé"],
      u: "1f6e0-fe0f",
      a: "0.7"
    },
    {
      n: ["poignard", "couteau poignard"],
      u: "1f5e1-fe0f",
      a: "0.7"
    },
    {
      n: ["épées croisées"],
      u: "2694-fe0f",
      a: "1.0"
    },
    {
      n: ["pistolet", "pistolet"],
      u: "1f52b",
      a: "0.6"
    },
    {
      n: ["boomerang"],
      u: "1fa83",
      a: "13.0"
    },
    {
      n: ["arc et flèche"],
      u: "1f3f9",
      a: "1.0"
    },
    {
      n: ["bouclier"],
      u: "1f6e1-fe0f",
      a: "0.7"
    },
    {
      n: ["scie à menuiserie"],
      u: "1fa9a",
      a: "13.0"
    },
    {
      n: ["clé"],
      u: "1f527",
      a: "0.6"
    },
    {
      n: ["tournevis"],
      u: "1fa9b",
      a: "13.0"
    },
    {
      n: ["écrou et boulon"],
      u: "1f529",
      a: "0.6"
    },
    {
      n: ["engrenage"],
      u: "2699-fe0f",
      a: "1.0"
    },
    {
      n: ["serrer", "compression"],
      u: "1f5dc-fe0f",
      a: "0.7"
    },
    {
      n: ["Balance", "balance"],
      u: "2696-fe0f",
      a: "1.0"
    },
    {
      n: ["canne de sondage"],
      u: "1f9af",
      a: "12.0"
    },
    {
      n: ["lien", "symbole de lien"],
      u: "1f517",
      a: "0.6"
    },
    {
      n: ["chaînes"],
      u: "26d3-fe0f",
      a: "0.7"
    },
    { n: ["chaîne brisée"], u: "26d3-fe0f-200d-1f4a5", a: "15.1" },
    {
      n: ["crochet"],
      u: "1fa9d",
      a: "13.0"
    },
    {
      n: ["boîte à outils"],
      u: "1f9f0",
      a: "11.0"
    },
    {
      n: ["aimant"],
      u: "1f9f2",
      a: "11.0"
    },
    {
      n: ["échelle"],
      u: "1fa9c",
      a: "13.0"
    },
    {
      n: ["alambic"],
      u: "2697-fe0f",
      a: "1.0"
    },
    {
      n: ["éprouvette"],
      u: "1f9ea",
      a: "11.0"
    },
    {
      n: ["boîte de Pétri"],
      u: "1f9eb",
      a: "11.0"
    },
    {
      n: ["ADN", "double hélice d'ADN"],
      u: "1f9ec",
      a: "11.0"
    },
    {
      n: ["microscope"],
      u: "1f52c",
      a: "1.0"
    },
    {
      n: ["télescope"],
      u: "1f52d",
      a: "1.0"
    },
    {
      n: ["antenne satellite"],
      u: "1f4e1",
      a: "0.6"
    },
    {
      n: ["seringue"],
      u: "1f489",
      a: "0.6"
    },
    {
      n: ["goutte de sang"],
      u: "1fa78",
      a: "12.0"
    },
    {
      n: ["pilule"],
      u: "1f48a",
      a: "0.6"
    },
    {
      n: ["bandage adhésif"],
      u: "1fa79",
      a: "12.0"
    },
    {
      n: ["béquille"],
      u: "1fa7c",
      a: "14.0"
    },
    {
      n: ["stéthoscope"],
      u: "1fa7a",
      a: "12.0"
    },
    {
      n: ["radiographie"],
      u: "1fa7b",
      a: "14.0"
    },
    {
      n: ["porte"],
      u: "1f6aa",
      a: "0.6"
    },
    {
      n: ["ascenseur"],
      u: "1f6d7",
      a: "13.0"
    },
    {
      n: ["miroir"],
      u: "1fa9e",
      a: "13.0"
    },
    {
      n: ["fenêtre"],
      u: "1fa9f",
      a: "13.0"
    },
    {
      n: ["lit"],
      u: "1f6cf-fe0f",
      a: "0.7"
    },
    {
      n: ["canapé et lampe"],
      u: "1f6cb-fe0f",
      a: "0.7"
    },
    {
      n: ["chaise"],
      u: "1fa91",
      a: "12.0"
    },
    {
      n: ["toilettes"],
      u: "1f6bd",
      a: "0.6"
    },
    {
      n: ["piston"],
      u: "1faa0",
      a: "13.0"
    },
    {
      n: ["douche"],
      u: "1f6bf",
      a: "1.0"
    },
    {
      n: ["baignoire"],
      u: "1f6c1",
      a: "1.0"
    },
    {
      n: ["piège à souris"],
      u: "1faa4",
      a: "13.0"
    },
    {
      n: ["rasoir"],
      u: "1fa92",
      a: "12.0"
    },
    {
      n: ["bouteille de lotion"],
      u: "1f9f4",
      a: "11.0"
    },
    {
      n: ["épingle de sûreté"],
      u: "1f9f7",
      a: "11.0"
    },
    {
      n: ["balai"],
      u: "1f9f9",
      a: "11.0"
    },
    {
      n: ["panier"],
      u: "1f9fa",
      a: "11.0"
    },
    {
      n: ["rouleau de papier"],
      u: "1f9fb",
      a: "11.0"
    },
    {
      n: ["seau"],
      u: "1faa3",
      a: "13.0"
    },
    {
      n: ["savon", "morceau de savon"],
      u: "1f9fc",
      a: "11.0"
    },
    {
      n: ["bulles"],
      u: "1fae7",
      a: "14.0"
    },
    {
      n: ["brosse à dents"],
      u: "1faa5",
      a: "13.0"
    },
    {
      n: ["éponge"],
      u: "1f9fd",
      a: "11.0"
    },
    {
      n: ["extincteur"],
      u: "1f9ef",
      a: "11.0"
    },
    {
      n: ["caddie"],
      u: "1f6d2",
      a: "3.0"
    },
    {
      n: ["fumeur", "symbole de fumer"],
      u: "1f6ac",
      a: "0.6"
    },
    {
      n: ["cercueil"],
      u: "26b0-fe0f",
      a: "1.0"
    },
    {
      n: ["pierre tombale"],
      u: "1faa6",
      a: "13.0"
    },
    {
      n: ["urne funéraire"],
      u: "26b1-fe0f",
      a: "1.0"
    },
    {
      n: ["Moyaï"],
      u: "1f5ff",
      a: "0.6"
    },
    {
      n: ["placard"],
      u: "1faa7",
      a: "13.0"
    },
    {
      n: ["carte d'identité"],
      u: "1faaa",
      a: "14.0"
    }
  ],
  symbols: [
    {
      n: ["ATM", "distributeur automatique de billets"],
      u: "1f3e7",
      a: "0.6"
    },
    {
      n: [
        "mettre la litière à sa place",
        "mettre les détritus à leur place symbole"
      ],
      u: "1f6ae",
      a: "1.0"
    },
    {
      n: ["eau potable", "symbole de l'eau potable"],
      u: "1f6b0",
      a: "1.0"
    },
    {
      n: ["fauteuil roulant", "symbole de fauteuil roulant"],
      u: "267f",
      a: "0.6"
    },
    {
      n: ["Pour des hommes", "symbole des hommes"],
      u: "1f6b9",
      a: "0.6"
    },
    {
      n: ["aux femmes", "symbole des femmes"],
      u: "1f6ba",
      a: "0.6"
    },
    {
      n: ["toilettes"],
      u: "1f6bb",
      a: "0.6"
    },
    {
      n: ["symbole de bébé"],
      u: "1f6bc",
      a: "0.6"
    },
    {
      n: ["toilettes", "WC"],
      u: "1f6be",
      a: "0.6"
    },
    {
      n: ["contrôle des passeports"],
      u: "1f6c2",
      a: "1.0"
    },
    {
      n: ["douane"],
      u: "1f6c3",
      a: "1.0"
    },
    {
      n: ["récupération des bagages"],
      u: "1f6c4",
      a: "1.0"
    },
    {
      n: ["consigne à bagages"],
      u: "1f6c5",
      a: "1.0"
    },
    {
      n: ["avertissement", "panneau d'avertissement"],
      u: "26a0-fe0f",
      a: "0.6"
    },
    {
      n: ["enfants traversant"],
      u: "1f6b8",
      a: "1.0"
    },
    {
      n: ["Entrée interdite"],
      u: "26d4",
      a: "0.6"
    },
    {
      n: ["pas de panneau d'entrée"],
      u: "1f6ab",
      a: "0.6"
    },
    {
      n: ["Bicyclettes interdites"],
      u: "1f6b3",
      a: "1.0"
    },
    {
      n: ["Interdiction de fumer", "symbole non fumeur"],
      u: "1f6ad",
      a: "0.6"
    },
    {
      n: ["ne pas jeter", "ne pas jeter le symbole"],
      u: "1f6af",
      a: "1.0"
    },
    {
      n: ["eau non potable", "symbole d'eau non potable"],
      u: "1f6b1",
      a: "1.0"
    },
    {
      n: ["Pas de piétons"],
      u: "1f6b7",
      a: "1.0"
    },
    {
      n: ["pas de téléphones portables"],
      u: "1f4f5",
      a: "1.0"
    },
    {
      n: ["mineur", "personne de moins de dix-huit ans symbole"],
      u: "1f51e",
      a: "0.6"
    },
    {
      n: ["radioactif", "signe radioactif"],
      u: "2622-fe0f",
      a: "1.0"
    },
    {
      n: ["risque biologique", "signe de danger biologique"],
      u: "2623-fe0f",
      a: "1.0"
    },
    {
      n: ["flèche vers le haut", "flèche noire vers le haut"],
      u: "2b06-fe0f",
      a: "0.6"
    },
    {
      n: ["flèche nord-est", "flèche en haut à droite"],
      u: "2197-fe0f",
      a: "0.6"
    },
    {
      n: ["flèche vers la droite", "flèche noire vers la droite"],
      u: "27a1-fe0f",
      a: "0.6"
    },
    {
      n: ["flèche sud-est", "flèche en bas à droite"],
      u: "2198-fe0f",
      a: "0.6"
    },
    {
      n: ["flèche vers le bas", "flèche noire vers le bas"],
      u: "2b07-fe0f",
      a: "0.6"
    },
    {
      n: ["flèche sud ouest", "flèche en bas à gauche"],
      u: "2199-fe0f",
      a: "0.6"
    },
    {
      n: ["flèche vers la gauche", "flèche noire vers la gauche"],
      u: "2b05-fe0f",
      a: "0.6"
    },
    {
      n: ["flèche nord ouest", "flèche en haut à gauche"],
      u: "2196-fe0f",
      a: "0.6"
    },
    {
      n: ["flèche haut vers le bas", "flèche vers le haut vers le bas"],
      u: "2195-fe0f",
      a: "0.6"
    },
    {
      n: ["flèche gauche droite"],
      u: "2194-fe0f",
      a: "0.6"
    },
    {
      n: ["flèche vers la gauche avec crochet"],
      u: "21a9-fe0f",
      a: "0.6"
    },
    {
      n: ["flèche droite crochet", "flèche vers la droite avec crochet"],
      u: "21aa-fe0f",
      a: "0.6"
    },
    {
      n: [
        "flèche vers le haut",
        "flèche pointant vers la droite puis se courbant vers le haut"
      ],
      u: "2934-fe0f",
      a: "0.6"
    },
    {
      n: [
        "flèche vers le bas",
        "flèche pointant vers la droite puis se courbant vers le bas"
      ],
      u: "2935-fe0f",
      a: "0.6"
    },
    {
      n: [
        "flèches dans le sens des aiguilles d'une montre",
        "flèches en cercle ouvert vers le bas et vers le haut dans le sens des aiguilles d'une montre"
      ],
      u: "1f503",
      a: "0.6"
    },
    {
      n: [
        "flèches dans le sens inverse des aiguilles d'une montre",
        "flèches en cercle ouvert vers le bas et vers le haut dans le sens inverse des aiguilles d'une montre"
      ],
      u: "1f504",
      a: "1.0"
    },
    {
      n: ["dos", "retour avec la flèche vers la gauche au dessus"],
      u: "1f519",
      a: "0.6"
    },
    {
      n: ["fin", "terminer par la flèche vers la gauche ci-dessus"],
      u: "1f51a",
      a: "0.6"
    },
    {
      n: [
        "sur",
        "dessus avec un point d'exclamation avec une flèche gauche droite au-dessus"
      ],
      u: "1f51b",
      a: "0.6"
    },
    {
      n: ["bientôt", "bientôt avec la flèche vers la droite au dessus"],
      u: "1f51c",
      a: "0.6"
    },
    {
      n: ["haut", "en haut avec une flèche vers le haut au-dessus"],
      u: "1f51d",
      a: "0.6"
    },
    {
      n: ["lieu de culte"],
      u: "1f6d0",
      a: "1.0"
    },
    {
      n: ["symbole de l'atome"],
      u: "269b-fe0f",
      a: "1.0"
    },
    {
      n: ["oh", "symbole de l'OM"],
      u: "1f549-fe0f",
      a: "0.7"
    },
    {
      n: ["étoile de David"],
      u: "2721-fe0f",
      a: "0.7"
    },
    {
      n: ["roue du dharma"],
      u: "2638-fe0f",
      a: "0.7"
    },
    {
      n: ["yin yang"],
      u: "262f-fe0f",
      a: "0.7"
    },
    {
      n: ["croix latine"],
      u: "271d-fe0f",
      a: "0.7"
    },
    {
      n: ["croix orthodoxe"],
      u: "2626-fe0f",
      a: "1.0"
    },
    {
      n: ["étoile et croissant"],
      u: "262a-fe0f",
      a: "0.7"
    },
    {
      n: ["symbole de paix"],
      u: "262e-fe0f",
      a: "1.0"
    },
    {
      n: ["menorah à neuf branches"],
      u: "1f54e",
      a: "1.0"
    },
    {
      n: ["étoile à six branches", "étoile à six branches avec point central"],
      u: "1f52f",
      a: "0.6"
    },
    {
      n: ["Bélier"],
      u: "2648",
      a: "0.6"
    },
    {
      n: ["Taureau"],
      u: "2649",
      a: "0.6"
    },
    {
      n: ["Gémeaux"],
      u: "264a",
      a: "0.6"
    },
    {
      n: ["cancer"],
      u: "264b",
      a: "0.6"
    },
    {
      n: ["Lion"],
      u: "264c",
      a: "0.6"
    },
    {
      n: ["Vierge"],
      u: "264d",
      a: "0.6"
    },
    {
      n: ["Balance"],
      u: "264e",
      a: "0.6"
    },
    {
      n: ["scorpion"],
      u: "264f",
      a: "0.6"
    },
    {
      n: ["Sagittaire"],
      u: "2650",
      a: "0.6"
    },
    {
      n: ["Capricorne"],
      u: "2651",
      a: "0.6"
    },
    {
      n: ["verseau"],
      u: "2652",
      a: "0.6"
    },
    {
      n: ["Poissons"],
      u: "2653",
      a: "0.6"
    },
    {
      n: ["ophiuchus"],
      u: "26ce",
      a: "0.6"
    },
    {
      n: ["flèches tordues vers la droite"],
      u: "1f500",
      a: "1.0"
    },
    {
      n: [
        "répéter",
        "flèches en cercle ouvert vers la droite et vers la gauche dans le sens des aiguilles d'une montre"
      ],
      u: "1f501",
      a: "1.0"
    },
    {
      n: [
        "répéter un",
        "flèches en cercle ouvert dans le sens des aiguilles d'une montre vers la droite et vers la gauche avec une superposition encerclée"
      ],
      u: "1f502",
      a: "1.0"
    },
    {
      n: ["flèche vers l'avant", "triangle noir pointant vers la droite"],
      u: "25b6-fe0f",
      a: "0.6"
    },
    {
      n: ["avance rapide", "double triangle noir pointant vers la droite"],
      u: "23e9",
      a: "0.6"
    },
    {
      n: [
        "bouton de la piste suivante",
        "double triangle noir pointant vers la droite avec barre verticale"
      ],
      u: "23ed-fe0f",
      a: "0.7"
    },
    {
      n: [
        "bouton lecture ou pause",
        "triangle pointant vers la droite noir avec double barre verticale"
      ],
      u: "23ef-fe0f",
      a: "1.0"
    },
    {
      n: ["flèche vers l'arrière", "triangle noir pointant vers la gauche"],
      u: "25c0-fe0f",
      a: "0.6"
    },
    {
      n: ["rembobiner", "double triangle noir pointant vers la gauche"],
      u: "23ea",
      a: "0.6"
    },
    {
      n: [
        "bouton de la dernière piste",
        "double triangle noir pointant vers la gauche avec barre verticale"
      ],
      u: "23ee-fe0f",
      a: "0.7"
    },
    {
      n: [
        "petite flèche vers le haut",
        "petit triangle rouge pointant vers le haut"
      ],
      u: "1f53c",
      a: "0.6"
    },
    {
      n: [
        "flèche double vers le haut",
        "double triangle noir pointant vers le haut"
      ],
      u: "23eb",
      a: "0.6"
    },
    {
      n: [
        "petite flèche vers le bas",
        "petit triangle rouge pointant vers le bas"
      ],
      u: "1f53d",
      a: "0.6"
    },
    {
      n: [
        "flèche double vers le bas",
        "double triangle noir pointant vers le bas"
      ],
      u: "23ec",
      a: "0.6"
    },
    {
      n: ["bouton pause", "double barre verticale"],
      u: "23f8-fe0f",
      a: "0.7"
    },
    {
      n: ["bouton d'arrêt", "carré noir pour l'arrêt"],
      u: "23f9-fe0f",
      a: "0.7"
    },
    {
      n: ["bouton d'enregistrement", "cercle noir pour enregistrement"],
      u: "23fa-fe0f",
      a: "0.7"
    },
    {
      n: ["éjecter", "bouton d'éjection"],
      u: "23cf-fe0f",
      a: "1.0"
    },
    {
      n: ["cinéma"],
      u: "1f3a6",
      a: "0.6"
    },
    {
      n: ["faible luminosité", "symbole de faible luminosité"],
      u: "1f505",
      a: "1.0"
    },
    {
      n: ["haute luminosité", "symbole de haute luminosité"],
      u: "1f506",
      a: "1.0"
    },
    {
      n: ["force du signal", "antenne à barres"],
      u: "1f4f6",
      a: "0.6"
    },
    {
      n: ["mode vibration"],
      u: "1f4f3",
      a: "0.6"
    },
    {
      n: ["téléphone portable éteint"],
      u: "1f4f4",
      a: "0.6"
    },
    {
      n: ["signe féminin"],
      u: "2640-fe0f",
      a: "4.0"
    },
    {
      n: ["signe masculin"],
      u: "2642-fe0f",
      a: "4.0"
    },
    {
      n: ["symbole transgenre"],
      u: "26a7-fe0f",
      a: "13.0"
    },
    {
      n: ["multiplication lourde x"],
      u: "2716-fe0f",
      a: "0.6"
    },
    {
      n: ["signe plus lourd"],
      u: "2795",
      a: "0.6"
    },
    {
      n: ["signe moins lourd"],
      u: "2796",
      a: "0.6"
    },
    {
      n: ["signe de division lourde"],
      u: "2797",
      a: "0.6"
    },
    {
      n: ["signe égal lourd"],
      u: "1f7f0",
      a: "14.0"
    },
    {
      n: ["infini"],
      u: "267e-fe0f",
      a: "11.0"
    },
    {
      n: ["bangbang", "double point d'exclamation"],
      u: "203c-fe0f",
      a: "0.6"
    },
    {
      n: ["interrobang", "point d'interrogation d'exclamation"],
      u: "2049-fe0f",
      a: "0.6"
    },
    {
      n: ["question", "ornement de point d'interrogation noir"],
      u: "2753",
      a: "0.6"
    },
    {
      n: ["question grise", "Ornement de point d'interrogation blanc"],
      u: "2754",
      a: "0.6"
    },
    {
      n: ["exclamation grise", "ornement de point d'exclamation blanc"],
      u: "2755",
      a: "0.6"
    },
    {
      n: [
        "exclamation",
        "gros point d'exclamation",
        "lourd symbole de point d'exclamation"
      ],
      u: "2757",
      a: "0.6"
    },
    {
      n: ["tiret ondulé"],
      u: "3030-fe0f",
      a: "0.6"
    },
    {
      n: ["change de devises"],
      u: "1f4b1",
      a: "0.6"
    },
    {
      n: ["signe du dollar lourd"],
      u: "1f4b2",
      a: "0.6"
    },
    {
      n: ["symbole médical", "bâton d'Esculape"],
      u: "2695-fe0f",
      a: "4.0"
    },
    {
      n: ["recycler", "symbole de recyclage universel noir"],
      u: "267b-fe0f",
      a: "0.6"
    },
    {
      n: ["fleur de lys", "fleur de lys"],
      u: "269c-fe0f",
      a: "1.0"
    },
    {
      n: ["trident", "emblème du trident"],
      u: "1f531",
      a: "0.6"
    },
    {
      n: ["insigne nominatif"],
      u: "1f4db",
      a: "0.6"
    },
    {
      n: ["débutant", "symbole japonais pour débutant"],
      u: "1f530",
      a: "0.6"
    },
    {
      n: ["o", "grand cercle lourd"],
      u: "2b55",
      a: "0.6"
    },
    {
      n: ["coche blanche", "coche épaisse blanche"],
      u: "2705",
      a: "0.6"
    },
    {
      n: ["urne avec chèque"],
      u: "2611-fe0f",
      a: "0.6"
    },
    {
      n: ["grosse coche"],
      u: "2714-fe0f",
      a: "0.6"
    },
    {
      n: ["x", "marque de croix"],
      u: "274c",
      a: "0.6"
    },
    {
      n: ["croix au carré négatif"],
      u: "274e",
      a: "0.6"
    },
    {
      n: ["boucle bouclée"],
      u: "27b0",
      a: "0.6"
    },
    {
      n: ["boucle", "double boucle bouclée"],
      u: "27bf",
      a: "1.0"
    },
    {
      n: ["marque d'alternance de pièces"],
      u: "303d-fe0f",
      a: "0.6"
    },
    {
      n: ["astérisque à huit branches"],
      u: "2733-fe0f",
      a: "0.6"
    },
    {
      n: ["étoile noire à huit branches"],
      u: "2734-fe0f",
      a: "0.6"
    },
    {
      n: ["éclat"],
      u: "2747-fe0f",
      a: "0.6"
    },
    {
      n: ["droit d'auteur", "signe de droit d'auteur"],
      u: "00a9-fe0f",
      a: "0.6"
    },
    {
      n: ["inscrit", "signe enregistré"],
      u: "00ae-fe0f",
      a: "0.6"
    },
    {
      n: ["tm", "signe de marque"],
      u: "2122-fe0f",
      a: "0.6"
    },
    {
      n: ["hacher", "clé de hachage"],
      u: "0023-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["touche : *", "étoile du clavier"],
      u: "002a-fe0f-20e3",
      a: "2.0"
    },
    {
      n: ["zéro", "touche 0"],
      u: "0030-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["un", "touche 1"],
      u: "0031-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["deux", "touche 2"],
      u: "0032-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["trois", "touche 3"],
      u: "0033-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["quatre", "touche 4"],
      u: "0034-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["cinq", "touche 5"],
      u: "0035-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["six", "touche 6"],
      u: "0036-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["Sept", "touche 7"],
      u: "0037-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["huit", "touche 8"],
      u: "0038-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["neuf", "touche 9"],
      u: "0039-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["touche dix"],
      u: "1f51f",
      a: "0.6"
    },
    {
      n: [
        "majuscule abcd",
        "symbole d'entrée pour les lettres majuscules latines"
      ],
      u: "1f520",
      a: "0.6"
    },
    {
      n: ["abcd", "symbole d'entrée pour les minuscules latines"],
      u: "1f521",
      a: "0.6"
    },
    {
      n: ["1234", "symbole de saisie pour les nombres"],
      u: "1f522",
      a: "0.6"
    },
    {
      n: ["symboles", "symbole d'entrée pour les symboles"],
      u: "1f523",
      a: "0.6"
    },
    {
      n: ["abc", "symbole d'entrée pour les lettres latines"],
      u: "1f524",
      a: "0.6"
    },
    {
      n: ["un", "lettre majuscule latine au carré négatif a"],
      u: "1f170-fe0f",
      a: "0.6"
    },
    {
      n: ["ab", "carré négatif ab"],
      u: "1f18e",
      a: "0.6"
    },
    {
      n: ["b", "lettre majuscule latine au carré négatif b"],
      u: "1f171-fe0f",
      a: "0.6"
    },
    {
      n: ["cl", "cl au carré"],
      u: "1f191",
      a: "0.6"
    },
    {
      n: ["cool", "au carré cool"],
      u: "1f192",
      a: "0.6"
    },
    {
      n: ["gratuit", "au carré libre"],
      u: "1f193",
      a: "0.6"
    },
    {
      n: ["source d'informations"],
      u: "2139-fe0f",
      a: "0.6"
    },
    {
      n: ["identifiant", "identifiant au carré"],
      u: "1f194",
      a: "0.6"
    },
    {
      n: ["m", "lettre majuscule latine m cerclée"],
      u: "24c2-fe0f",
      a: "0.6"
    },
    {
      n: ["nouveau", "au carré nouveau"],
      u: "1f195",
      a: "0.6"
    },
    {
      n: ["ng", "au carré ng"],
      u: "1f196",
      a: "0.6"
    },
    {
      n: ["o2", "lettre majuscule latine au carré négatif o"],
      u: "1f17e-fe0f",
      a: "0.6"
    },
    {
      n: ["d'accord", "au carré ok"],
      u: "1f197",
      a: "0.6"
    },
    {
      n: ["parking", "lettre majuscule latine au carré négatif p"],
      u: "1f17f-fe0f",
      a: "0.6"
    },
    {
      n: ["sos", "sos au carré"],
      u: "1f198",
      a: "0.6"
    },
    {
      n: ["en haut", "au carré avec un point d'exclamation"],
      u: "1f199",
      a: "0.6"
    },
    {
      n: ["contre", "au carré contre"],
      u: "1f19a",
      a: "0.6"
    },
    {
      n: ["Koko", "katakana koko carré"],
      u: "1f201",
      a: "0.6"
    },
    {
      n: ["sa", "katakana carré sa"],
      u: "1f202-fe0f",
      a: "0.6"
    },
    {
      n: ["u6708", "idéogramme unifié cjk au carré-6708"],
      u: "1f237-fe0f",
      a: "0.6"
    },
    {
      n: ["u6709", "idéogramme unifié cjk au carré-6709"],
      u: "1f236",
      a: "0.6"
    },
    {
      n: ["u6307", "idéogramme unifié cjk au carré-6307"],
      u: "1f22f",
      a: "0.6"
    },
    {
      n: ["avantage idéographique", "avantage de l'idéogramme cerclé"],
      u: "1f250",
      a: "0.6"
    },
    {
      n: ["u5272", "idéogramme unifié cjk au carré-5272"],
      u: "1f239",
      a: "0.6"
    },
    {
      n: ["u7121", "idéogramme unifié cjk au carré-7121"],
      u: "1f21a",
      a: "0.6"
    },
    {
      n: ["u7981", "idéogramme unifié cjk au carré-7981"],
      u: "1f232",
      a: "0.6"
    },
    {
      n: ["accepter", "idéogramme encerclé accepter"],
      u: "1f251",
      a: "0.6"
    },
    {
      n: ["u7533", "idéogramme unifié cjk au carré-7533"],
      u: "1f238",
      a: "0.6"
    },
    {
      n: ["u5408", "idéogramme unifié cjk au carré-5408"],
      u: "1f234",
      a: "0.6"
    },
    {
      n: ["u7a7a", "idéogramme unifié cjk au carré-7a7a"],
      u: "1f233",
      a: "0.6"
    },
    {
      n: ["Félicitations", "félicitation idéogramme encerclé"],
      u: "3297-fe0f",
      a: "0.6"
    },
    {
      n: ["secrète", "secret de l'idéogramme encerclé"],
      u: "3299-fe0f",
      a: "0.6"
    },
    {
      n: ["u55b6", "idéogramme unifié cjk au carré-55b6"],
      u: "1f23a",
      a: "0.6"
    },
    {
      n: ["u6e80", "idéogramme unifié cjk au carré-6e80"],
      u: "1f235",
      a: "0.6"
    },
    {
      n: ["cercle rouge", "grand cercle rouge"],
      u: "1f534",
      a: "0.6"
    },
    {
      n: ["grand cercle orange"],
      u: "1f7e0",
      a: "12.0"
    },
    {
      n: ["grand cercle jaune"],
      u: "1f7e1",
      a: "12.0"
    },
    {
      n: ["grand cercle vert"],
      u: "1f7e2",
      a: "12.0"
    },
    {
      n: ["grand cercle bleu"],
      u: "1f535",
      a: "0.6"
    },
    {
      n: ["grand cercle violet"],
      u: "1f7e3",
      a: "12.0"
    },
    {
      n: ["grand cercle marron"],
      u: "1f7e4",
      a: "12.0"
    },
    {
      n: ["cercle noir", "cercle noir moyen"],
      u: "26ab",
      a: "0.6"
    },
    {
      n: ["cercle blanc", "cercle blanc moyen"],
      u: "26aa",
      a: "0.6"
    },
    {
      n: ["grand carré rouge"],
      u: "1f7e5",
      a: "12.0"
    },
    {
      n: ["grand carré orange"],
      u: "1f7e7",
      a: "12.0"
    },
    {
      n: ["grand carré jaune"],
      u: "1f7e8",
      a: "12.0"
    },
    {
      n: ["grand carré vert"],
      u: "1f7e9",
      a: "12.0"
    },
    {
      n: ["grand carré bleu"],
      u: "1f7e6",
      a: "12.0"
    },
    {
      n: ["grand carré violet"],
      u: "1f7ea",
      a: "12.0"
    },
    {
      n: ["grand carré marron"],
      u: "1f7eb",
      a: "12.0"
    },
    {
      n: ["grand carré noir"],
      u: "2b1b",
      a: "0.6"
    },
    {
      n: ["grand carré blanc"],
      u: "2b1c",
      a: "0.6"
    },
    {
      n: ["carré moyen noir"],
      u: "25fc-fe0f",
      a: "0.6"
    },
    {
      n: ["carré moyen blanc"],
      u: "25fb-fe0f",
      a: "0.6"
    },
    {
      n: ["noir moyen petit carré"],
      u: "25fe",
      a: "0.6"
    },
    {
      n: ["carré blanc moyen petit"],
      u: "25fd",
      a: "0.6"
    },
    {
      n: ["petit carré noir"],
      u: "25aa-fe0f",
      a: "0.6"
    },
    {
      n: ["petit carré blanc"],
      u: "25ab-fe0f",
      a: "0.6"
    },
    {
      n: ["gros diamant orange"],
      u: "1f536",
      a: "0.6"
    },
    {
      n: ["gros diamant bleu"],
      u: "1f537",
      a: "0.6"
    },
    {
      n: ["petit diamant orange"],
      u: "1f538",
      a: "0.6"
    },
    {
      n: ["petit diamant bleu"],
      u: "1f539",
      a: "0.6"
    },
    {
      n: ["petit triangle rouge", "triangle rouge pointant vers le haut"],
      u: "1f53a",
      a: "0.6"
    },
    {
      n: [
        "petit triangle rouge vers le bas",
        "triangle rouge pointant vers le bas"
      ],
      u: "1f53b",
      a: "0.6"
    },
    {
      n: ["forme de diamant avec un point à l'intérieur"],
      u: "1f4a0",
      a: "0.6"
    },
    {
      n: ["bouton radio"],
      u: "1f518",
      a: "0.6"
    },
    {
      n: ["bouton carré blanc"],
      u: "1f533",
      a: "0.6"
    },
    {
      n: ["bouton carré noir"],
      u: "1f532",
      a: "0.6"
    }
  ],
  flags: [
    {
      n: ["drapeau à damier", "drapeau à damier"],
      u: "1f3c1",
      a: "0.6"
    },
    {
      n: ["drapeau triangulaire sur le poteau"],
      u: "1f6a9",
      a: "0.6"
    },
    {
      n: ["drapeaux croisés"],
      u: "1f38c",
      a: "0.6"
    },
    {
      n: ["agitant un drapeau noir"],
      u: "1f3f4",
      a: "1.0"
    },
    {
      n: ["drapeau blanc", "agitant un drapeau blanc"],
      u: "1f3f3-fe0f",
      a: "0.7"
    },
    {
      n: ["drapeau arc-en-ciel", "drapeau arc-en-ciel"],
      u: "1f3f3-fe0f-200d-1f308",
      a: "4.0"
    },
    {
      n: ["drapeau transgenre"],
      u: "1f3f3-fe0f-200d-26a7-fe0f",
      a: "13.0"
    },
    {
      n: ["drapeau pirate"],
      u: "1f3f4-200d-2620-fe0f",
      a: "11.0"
    },
    {
      n: ["drapeau-ac", "drapeau de l'île de l'ascension"],
      u: "1f1e6-1f1e8",
      a: "2.0"
    },
    {
      n: ["annonce-drapeau", "drapeau andorre"],
      u: "1f1e6-1f1e9",
      a: "2.0"
    },
    {
      n: ["drapeau-ae", "drapeau des Émirats arabes unis"],
      u: "1f1e6-1f1ea",
      a: "2.0"
    },
    {
      n: ["drapeau-af", "drapeau afghanistan"],
      u: "1f1e6-1f1eb",
      a: "2.0"
    },
    {
      n: ["drapeau-ag", "drapeau antigua-et-barbuda"],
      u: "1f1e6-1f1ec",
      a: "2.0"
    },
    {
      n: ["drapeau-ai", "drapeau d'Anguilla"],
      u: "1f1e6-1f1ee",
      a: "2.0"
    },
    {
      n: ["drapeau-al", "drapeau de l'Albanie"],
      u: "1f1e6-1f1f1",
      a: "2.0"
    },
    {
      n: ["drapeau-am", "drapeau de l'Arménie"],
      u: "1f1e6-1f1f2",
      a: "2.0"
    },
    {
      n: ["drapeau-ao", "drapeau angolais"],
      u: "1f1e6-1f1f4",
      a: "2.0"
    },
    {
      n: ["drapeau-aq", "drapeau de l'Antarctique"],
      u: "1f1e6-1f1f6",
      a: "2.0"
    },
    {
      n: ["drapeau-ar", "drapeau argentin"],
      u: "1f1e6-1f1f7",
      a: "2.0"
    },
    {
      n: ["drapeau-comme", "drapeau des Samoa américaines"],
      u: "1f1e6-1f1f8",
      a: "2.0"
    },
    {
      n: ["drapeau à", "drapeau de l'autriche"],
      u: "1f1e6-1f1f9",
      a: "2.0"
    },
    {
      n: ["drapeau-au", "drapeau de l'australie"],
      u: "1f1e6-1f1fa",
      a: "2.0"
    },
    {
      n: ["drapeau-aw", "drapeau d'Aruba"],
      u: "1f1e6-1f1fc",
      a: "2.0"
    },
    {
      n: ["hache de drapeau", "drapeau des îles åland"],
      u: "1f1e6-1f1fd",
      a: "2.0"
    },
    {
      n: ["drapeau az", "drapeau de l'Azerbaïdjan"],
      u: "1f1e6-1f1ff",
      a: "2.0"
    },
    {
      n: ["drapeau-ba", "drapeau de la Bosnie-Herzégovine"],
      u: "1f1e7-1f1e6",
      a: "2.0"
    },
    {
      n: ["drapeau-bb", "drapeau de la Barbade"],
      u: "1f1e7-1f1e7",
      a: "2.0"
    },
    {
      n: ["drapeau-bd", "drapeau du Bangladesh"],
      u: "1f1e7-1f1e9",
      a: "2.0"
    },
    {
      n: ["drapeau-être", "drapeau belge"],
      u: "1f1e7-1f1ea",
      a: "2.0"
    },
    {
      n: ["drapeau-bf", "drapeau du burkina faso"],
      u: "1f1e7-1f1eb",
      a: "2.0"
    },
    {
      n: ["drapeau-bg", "drapeau de la Bulgarie"],
      u: "1f1e7-1f1ec",
      a: "2.0"
    },
    {
      n: ["drapeau-bh", "drapeau de Bahreïn"],
      u: "1f1e7-1f1ed",
      a: "2.0"
    },
    {
      n: ["drapeau-bi", "drapeau burundais"],
      u: "1f1e7-1f1ee",
      a: "2.0"
    },
    {
      n: ["drapeau-bj", "drapeau du Bénin"],
      u: "1f1e7-1f1ef",
      a: "2.0"
    },
    {
      n: ["drapeau-bl", "St. drapeau barthélemy"],
      u: "1f1e7-1f1f1",
      a: "2.0"
    },
    {
      n: ["drapeau-bm", "drapeau des Bermudes"],
      u: "1f1e7-1f1f2",
      a: "2.0"
    },
    {
      n: ["drapeau-bn", "drapeau de Brunéi"],
      u: "1f1e7-1f1f3",
      a: "2.0"
    },
    {
      n: ["drapeau-bo", "drapeau de la Bolivie"],
      u: "1f1e7-1f1f4",
      a: "2.0"
    },
    {
      n: ["drapeau-bq", "drapeau des pays-bas des Caraïbes"],
      u: "1f1e7-1f1f6",
      a: "2.0"
    },
    {
      n: ["drapeau-br", "drapeau du Brésil"],
      u: "1f1e7-1f1f7",
      a: "2.0"
    },
    {
      n: ["drapeau-bs", "drapeau des Bahamas"],
      u: "1f1e7-1f1f8",
      a: "2.0"
    },
    {
      n: ["drapeau-bt", "drapeau du bhoutan"],
      u: "1f1e7-1f1f9",
      a: "2.0"
    },
    {
      n: ["drapeau-bv", "drapeau de l'île bouvet"],
      u: "1f1e7-1f1fb",
      a: "2.0"
    },
    {
      n: ["drapeau-bw", "drapeau du Botswana"],
      u: "1f1e7-1f1fc",
      a: "2.0"
    },
    {
      n: ["signalement", "drapeau de la Biélorussie"],
      u: "1f1e7-1f1fe",
      a: "2.0"
    },
    {
      n: ["drapeau-bz", "drapeau du Belize"],
      u: "1f1e7-1f1ff",
      a: "2.0"
    },
    {
      n: ["drapeau-ca", "drapeau canadien"],
      u: "1f1e8-1f1e6",
      a: "2.0"
    },
    {
      n: ["drapeau-cc", "drapeau des îles cocos (keeling)"],
      u: "1f1e8-1f1e8",
      a: "2.0"
    },
    {
      n: ["drapeau-cd", "drapeau congo - kinshasa"],
      u: "1f1e8-1f1e9",
      a: "2.0"
    },
    {
      n: ["drapeau-cf", "drapeau de la république centrafricaine"],
      u: "1f1e8-1f1eb",
      a: "2.0"
    },
    {
      n: ["drapeau-cg", "drapeau congo-brazzaville"],
      u: "1f1e8-1f1ec",
      a: "2.0"
    },
    {
      n: ["drapeau-ch", "drapeau suisse"],
      u: "1f1e8-1f1ed",
      a: "2.0"
    },
    {
      n: ["drapeau-ci", "drapeau de la côte d'ivoire"],
      u: "1f1e8-1f1ee",
      a: "2.0"
    },
    {
      n: ["drapeau-ck", "drapeau des îles Cook"],
      u: "1f1e8-1f1f0",
      a: "2.0"
    },
    {
      n: ["drapeau-cl", "drapeau du Chili"],
      u: "1f1e8-1f1f1",
      a: "2.0"
    },
    {
      n: ["drapeau-cm", "drapeau du Cameroun"],
      u: "1f1e8-1f1f2",
      a: "2.0"
    },
    {
      n: ["CN", "drapeau-cn", "drapeau de la Chine"],
      u: "1f1e8-1f1f3",
      a: "0.6"
    },
    {
      n: ["drapeau-co", "drapeau de la Colombie"],
      u: "1f1e8-1f1f4",
      a: "2.0"
    },
    {
      n: ["drapeau-cp", "drapeau de l'île clipperton"],
      u: "1f1e8-1f1f5",
      a: "2.0"
    },
    { n: ["drapeau-cq", "drapeau de sercq"], u: "1f1e8-1f1f6", a: "16.0" },
    {
      n: ["drapeau-cr", "drapeau du costa rica"],
      u: "1f1e8-1f1f7",
      a: "2.0"
    },
    {
      n: ["drapeau-cu", "drapeau cubain"],
      u: "1f1e8-1f1fa",
      a: "2.0"
    },
    {
      n: ["drapeau-cv", "drapeau du Cap-Vert"],
      u: "1f1e8-1f1fb",
      a: "2.0"
    },
    {
      n: ["drapeau-cw", "drapeau de curaçao"],
      u: "1f1e8-1f1fc",
      a: "2.0"
    },
    {
      n: ["drapeau-cx", "drapeau de l'île Noël"],
      u: "1f1e8-1f1fd",
      a: "2.0"
    },
    {
      n: ["drapeau-cy", "drapeau de Chypre"],
      u: "1f1e8-1f1fe",
      a: "2.0"
    },
    {
      n: ["drapeau-cz", "drapeau tchèque"],
      u: "1f1e8-1f1ff",
      a: "2.0"
    },
    {
      n: ["de", "drapeau-de", "drapeau allemand"],
      u: "1f1e9-1f1ea",
      a: "0.6"
    },
    {
      n: ["drapeau-dg", "drapeau diego garcia"],
      u: "1f1e9-1f1ec",
      a: "2.0"
    },
    {
      n: ["drapeau-dj", "drapeau de Djibouti"],
      u: "1f1e9-1f1ef",
      a: "2.0"
    },
    {
      n: ["drapeau-dk", "drapeau du Danemark"],
      u: "1f1e9-1f1f0",
      a: "2.0"
    },
    {
      n: ["drapeau-dm", "drapeau de la Dominique"],
      u: "1f1e9-1f1f2",
      a: "2.0"
    },
    {
      n: ["drapeau-faire", "drapeau de la république dominicaine"],
      u: "1f1e9-1f1f4",
      a: "2.0"
    },
    {
      n: ["drapeau-dz", "drapeau algérien"],
      u: "1f1e9-1f1ff",
      a: "2.0"
    },
    {
      n: ["drapeau-ea", "drapeau de ceuta et melilla"],
      u: "1f1ea-1f1e6",
      a: "2.0"
    },
    {
      n: ["drapeau-ec", "drapeau de l'Équateur"],
      u: "1f1ea-1f1e8",
      a: "2.0"
    },
    {
      n: ["drapeau-ee", "drapeau estonie"],
      u: "1f1ea-1f1ea",
      a: "2.0"
    },
    {
      n: ["drapeau-par exemple", "drapeau égyptien"],
      u: "1f1ea-1f1ec",
      a: "2.0"
    },
    {
      n: ["drapeau-hein", "drapeau du Sahara occidental"],
      u: "1f1ea-1f1ed",
      a: "2.0"
    },
    {
      n: ["drapeau-er", "drapeau de l'Érythrée"],
      u: "1f1ea-1f1f7",
      a: "2.0"
    },
    {
      n: ["es", "drapeaux", "drapeau de l'espagne"],
      u: "1f1ea-1f1f8",
      a: "0.6"
    },
    {
      n: ["drapeau-et", "drapeau éthiopien"],
      u: "1f1ea-1f1f9",
      a: "2.0"
    },
    {
      n: ["drapeau-eu", "drapeau de l'union européenne"],
      u: "1f1ea-1f1fa",
      a: "2.0"
    },
    {
      n: ["drapeau-fi", "drapeau finlandais"],
      u: "1f1eb-1f1ee",
      a: "2.0"
    },
    {
      n: ["drapeau-fj", "drapeau des Fidji"],
      u: "1f1eb-1f1ef",
      a: "2.0"
    },
    {
      n: ["drapeau-fk", "drapeau des îles Falkland"],
      u: "1f1eb-1f1f0",
      a: "2.0"
    },
    {
      n: ["drapeau-fm", "drapeau de la Micronésie"],
      u: "1f1eb-1f1f2",
      a: "2.0"
    },
    {
      n: ["drapeau-fo", "drapeau des îles Féroé"],
      u: "1f1eb-1f1f4",
      a: "2.0"
    },
    {
      n: ["fr", "flag-fr", "drapeau français"],
      u: "1f1eb-1f1f7",
      a: "0.6"
    },
    {
      n: ["drapeau-ga", "drapeau du Gabon"],
      u: "1f1ec-1f1e6",
      a: "2.0"
    },
    {
      n: ["go", "Royaume-Uni", "drapeau-gb", "drapeau du royaume-uni"],
      u: "1f1ec-1f1e7",
      a: "0.6"
    },
    {
      n: ["drapeau-gd", "drapeau de la grenade"],
      u: "1f1ec-1f1e9",
      a: "2.0"
    },
    {
      n: ["drapeau-ge", "drapeau de la Géorgie"],
      u: "1f1ec-1f1ea",
      a: "2.0"
    },
    {
      n: ["drapeau-gf", "drapeau de la Guyane française"],
      u: "1f1ec-1f1eb",
      a: "2.0"
    },
    {
      n: ["drapeau-gg", "drapeau de Guernesey"],
      u: "1f1ec-1f1ec",
      a: "2.0"
    },
    {
      n: ["drapeau-gh", "drapeau du Ghana"],
      u: "1f1ec-1f1ed",
      a: "2.0"
    },
    {
      n: ["drapeau-gi", "drapeau de Gibraltar"],
      u: "1f1ec-1f1ee",
      a: "2.0"
    },
    {
      n: ["drapeau-gl", "drapeau du Groenland"],
      u: "1f1ec-1f1f1",
      a: "2.0"
    },
    {
      n: ["drapeau-gm", "drapeau de la Gambie"],
      u: "1f1ec-1f1f2",
      a: "2.0"
    },
    {
      n: ["drapeau-gn", "drapeau de la Guinée"],
      u: "1f1ec-1f1f3",
      a: "2.0"
    },
    {
      n: ["drapeau-gp", "drapeau guadeloupéen"],
      u: "1f1ec-1f1f5",
      a: "2.0"
    },
    {
      n: ["drapeau-gq", "drapeau de la Guinée équatoriale"],
      u: "1f1ec-1f1f6",
      a: "2.0"
    },
    {
      n: ["drapeau-gr", "drapeau de la grèce"],
      u: "1f1ec-1f1f7",
      a: "2.0"
    },
    {
      n: [
        "drapeau-gs",
        "drapeau de la géorgie du sud et des îles sandwich du sud"
      ],
      u: "1f1ec-1f1f8",
      a: "2.0"
    },
    {
      n: ["drapeau-gt", "drapeau du Guatemala"],
      u: "1f1ec-1f1f9",
      a: "2.0"
    },
    {
      n: ["drapeau-gu", "drapeau de Guam"],
      u: "1f1ec-1f1fa",
      a: "2.0"
    },
    {
      n: ["drapeau-gw", "drapeau de la Guinée-Bissau"],
      u: "1f1ec-1f1fc",
      a: "2.0"
    },
    {
      n: ["drapeau-gy", "drapeau de la Guyane"],
      u: "1f1ec-1f1fe",
      a: "2.0"
    },
    {
      n: ["drapeau-hk", "drapeau de la chine hong kong"],
      u: "1f1ed-1f1f0",
      a: "2.0"
    },
    {
      n: ["drapeau-hm", "drapeau des îles Heard et McDonald"],
      u: "1f1ed-1f1f2",
      a: "2.0"
    },
    {
      n: ["drapeau-hn", "drapeau du Honduras"],
      u: "1f1ed-1f1f3",
      a: "2.0"
    },
    {
      n: ["drapeau-heure", "drapeau de la Croatie"],
      u: "1f1ed-1f1f7",
      a: "2.0"
    },
    {
      n: ["drapeau-ht", "drapeau d'Haïti"],
      u: "1f1ed-1f1f9",
      a: "2.0"
    },
    {
      n: ["drapeau-hu", "drapeau de la Hongrie"],
      u: "1f1ed-1f1fa",
      a: "2.0"
    },
    {
      n: ["drapeau-ic", "drapeau des îles Canaries"],
      u: "1f1ee-1f1e8",
      a: "2.0"
    },
    {
      n: ["identifiant du drapeau", "drapeau de l'indonésie"],
      u: "1f1ee-1f1e9",
      a: "2.0"
    },
    {
      n: ["drapeau-ie", "drapeau de l'Irlande"],
      u: "1f1ee-1f1ea",
      a: "2.0"
    },
    {
      n: ["drapeau-il", "drapeau israélien"],
      u: "1f1ee-1f1f1",
      a: "2.0"
    },
    {
      n: ["je suis un drapeau", "drapeau de l'île de Man"],
      u: "1f1ee-1f1f2",
      a: "2.0"
    },
    {
      n: ["signaler", "drapeau de l'Inde"],
      u: "1f1ee-1f1f3",
      a: "2.0"
    },
    {
      n: ["drapeau-io", "drapeau du territoire britannique de l'océan Indien"],
      u: "1f1ee-1f1f4",
      a: "2.0"
    },
    {
      n: ["drapeau-iq", "drapeau de l'Irak"],
      u: "1f1ee-1f1f6",
      a: "2.0"
    },
    {
      n: ["drapeau-ir", "drapeau iranien"],
      u: "1f1ee-1f1f7",
      a: "2.0"
    },
    {
      n: ["le drapeau est", "drapeau islandais"],
      u: "1f1ee-1f1f8",
      a: "2.0"
    },
    {
      n: ["il", "drapeau-le", "drapeau italien"],
      u: "1f1ee-1f1f9",
      a: "0.6"
    },
    {
      n: ["drapeau-je", "drapeau de maillot"],
      u: "1f1ef-1f1ea",
      a: "2.0"
    },
    {
      n: ["drapeau-jm", "drapeau de la Jamaïque"],
      u: "1f1ef-1f1f2",
      a: "2.0"
    },
    {
      n: ["drapeau-jo", "drapeau jordanie"],
      u: "1f1ef-1f1f4",
      a: "2.0"
    },
    {
      n: ["jp", "drapeau-jp", "drapeau du japon"],
      u: "1f1ef-1f1f5",
      a: "0.6"
    },
    {
      n: ["drapeau-ke", "drapeau du Kenya"],
      u: "1f1f0-1f1ea",
      a: "2.0"
    },
    {
      n: ["drapeau-kg", "drapeau du Kirghizistan"],
      u: "1f1f0-1f1ec",
      a: "2.0"
    },
    {
      n: ["drapeau-kh", "drapeau du cambodge"],
      u: "1f1f0-1f1ed",
      a: "2.0"
    },
    {
      n: ["drapeau-ki", "drapeau des Kiribati"],
      u: "1f1f0-1f1ee",
      a: "2.0"
    },
    {
      n: ["drapeau-km", "drapeau des comores"],
      u: "1f1f0-1f1f2",
      a: "2.0"
    },
    {
      n: ["drapeau-kn", "St. drapeau kitts-et-nevis"],
      u: "1f1f0-1f1f3",
      a: "2.0"
    },
    {
      n: ["drapeau-kp", "drapeau de la corée du nord"],
      u: "1f1f0-1f1f5",
      a: "2.0"
    },
    {
      n: ["kr", "drapeau-kr", "drapeau de la corée du sud"],
      u: "1f1f0-1f1f7",
      a: "0.6"
    },
    {
      n: ["drapeau-kw", "drapeau du Koweït"],
      u: "1f1f0-1f1fc",
      a: "2.0"
    },
    {
      n: ["drapeau-ky", "drapeau des îles Caïmans"],
      u: "1f1f0-1f1fe",
      a: "2.0"
    },
    {
      n: ["drapeau-kz", "drapeau du Kazakhstan"],
      u: "1f1f0-1f1ff",
      a: "2.0"
    },
    {
      n: ["drapeau-la", "drapeau du Laos"],
      u: "1f1f1-1f1e6",
      a: "2.0"
    },
    {
      n: ["drapeau-lb", "drapeau du Liban"],
      u: "1f1f1-1f1e7",
      a: "2.0"
    },
    {
      n: ["drapeau-lc", "St. drapeau lucie"],
      u: "1f1f1-1f1e8",
      a: "2.0"
    },
    {
      n: ["drapeau-li", "drapeau du Liechtenstein"],
      u: "1f1f1-1f1ee",
      a: "2.0"
    },
    {
      n: ["drapeau-lk", "drapeau du Sri Lanka"],
      u: "1f1f1-1f1f0",
      a: "2.0"
    },
    {
      n: ["drapeau-lr", "drapeau du Libéria"],
      u: "1f1f1-1f1f7",
      a: "2.0"
    },
    {
      n: ["drapeau-ls", "drapeau du Lesotho"],
      u: "1f1f1-1f1f8",
      a: "2.0"
    },
    {
      n: ["drapeau-lt", "drapeau de la Lituanie"],
      u: "1f1f1-1f1f9",
      a: "2.0"
    },
    {
      n: ["drapeau-lu", "drapeau luxembourgeois"],
      u: "1f1f1-1f1fa",
      a: "2.0"
    },
    {
      n: ["drapeau-lv", "drapeau de la Lettonie"],
      u: "1f1f1-1f1fb",
      a: "2.0"
    },
    {
      n: ["drapeau", "drapeau de la Libye"],
      u: "1f1f1-1f1fe",
      a: "2.0"
    },
    {
      n: ["drapeau-ma", "drapeau du maroc"],
      u: "1f1f2-1f1e6",
      a: "2.0"
    },
    {
      n: ["drapeau-mc", "drapeau monégasque"],
      u: "1f1f2-1f1e8",
      a: "2.0"
    },
    {
      n: ["drapeau-md", "drapeau de la Moldavie"],
      u: "1f1f2-1f1e9",
      a: "2.0"
    },
    {
      n: ["signale-moi", "drapeau du Monténégro"],
      u: "1f1f2-1f1ea",
      a: "2.0"
    },
    {
      n: ["drapeau-mf", "St. drapeau martine"],
      u: "1f1f2-1f1eb",
      a: "2.0"
    },
    {
      n: ["drapeau-mg", "drapeau de Madagascar"],
      u: "1f1f2-1f1ec",
      a: "2.0"
    },
    {
      n: ["drapeau-mh", "drapeau des îles marshall"],
      u: "1f1f2-1f1ed",
      a: "2.0"
    },
    {
      n: ["drapeau-mk", "drapeau de la Macédoine du Nord"],
      u: "1f1f2-1f1f0",
      a: "2.0"
    },
    {
      n: ["drapeau-ml", "drapeau du mali"],
      u: "1f1f2-1f1f1",
      a: "2.0"
    },
    {
      n: ["drapeau-mm", "drapeau du myanmar (birmanie)"],
      u: "1f1f2-1f1f2",
      a: "2.0"
    },
    {
      n: ["drapeau-mn", "drapeau de la Mongolie"],
      u: "1f1f2-1f1f3",
      a: "2.0"
    },
    {
      n: ["drapeau-mo", "drapeau de la Sarre de Macao en Chine"],
      u: "1f1f2-1f1f4",
      a: "2.0"
    },
    {
      n: ["drapeau-mp", "drapeau des îles mariannes du nord"],
      u: "1f1f2-1f1f5",
      a: "2.0"
    },
    {
      n: ["drapeau-mq", "drapeau martiniquais"],
      u: "1f1f2-1f1f6",
      a: "2.0"
    },
    {
      n: ["drapeau-mr", "drapeau de la Mauritanie"],
      u: "1f1f2-1f1f7",
      a: "2.0"
    },
    {
      n: ["drapeau-ms", "drapeau de Montserrat"],
      u: "1f1f2-1f1f8",
      a: "2.0"
    },
    {
      n: ["drapeau-mt", "drapeau de Malte"],
      u: "1f1f2-1f1f9",
      a: "2.0"
    },
    {
      n: ["drapeau-mu", "drapeau maurice"],
      u: "1f1f2-1f1fa",
      a: "2.0"
    },
    {
      n: ["drapeau-mv", "drapeau des maldives"],
      u: "1f1f2-1f1fb",
      a: "2.0"
    },
    {
      n: ["drapeau-mw", "drapeau du Malawi"],
      u: "1f1f2-1f1fc",
      a: "2.0"
    },
    {
      n: ["drapeau-mx", "drapeau du Mexique"],
      u: "1f1f2-1f1fd",
      a: "2.0"
    },
    {
      n: ["drapeau-mon", "drapeau de la Malaisie"],
      u: "1f1f2-1f1fe",
      a: "2.0"
    },
    {
      n: ["drapeau-mz", "drapeau du Mozambique"],
      u: "1f1f2-1f1ff",
      a: "2.0"
    },
    {
      n: ["drapeau-na", "drapeau de la Namibie"],
      u: "1f1f3-1f1e6",
      a: "2.0"
    },
    {
      n: ["drapeau-nc", "drapeau de la nouvelle-calédonie"],
      u: "1f1f3-1f1e8",
      a: "2.0"
    },
    {
      n: ["drapeau-ne", "drapeau du Niger"],
      u: "1f1f3-1f1ea",
      a: "2.0"
    },
    {
      n: ["drapeau-nf", "drapeau de l'île norfolk"],
      u: "1f1f3-1f1eb",
      a: "2.0"
    },
    {
      n: ["drapeau-ng", "drapeau du Nigéria"],
      u: "1f1f3-1f1ec",
      a: "2.0"
    },
    {
      n: ["drapeau-ni", "drapeau du Nicaragua"],
      u: "1f1f3-1f1ee",
      a: "2.0"
    },
    {
      n: ["drapeau-nl", "drapeau des Pays-Bas"],
      u: "1f1f3-1f1f1",
      a: "2.0"
    },
    {
      n: ["drapeau-non", "drapeau de la Norvège"],
      u: "1f1f3-1f1f4",
      a: "2.0"
    },
    {
      n: ["drapeau-np", "drapeau du Népal"],
      u: "1f1f3-1f1f5",
      a: "2.0"
    },
    {
      n: ["numéro de drapeau", "drapeau nauruan"],
      u: "1f1f3-1f1f7",
      a: "2.0"
    },
    {
      n: ["drapeau-nu", "drapeau de Nioué"],
      u: "1f1f3-1f1fa",
      a: "2.0"
    },
    {
      n: ["drapeau-nz", "drapeau de la Nouvelle-Zélande"],
      u: "1f1f3-1f1ff",
      a: "2.0"
    },
    {
      n: ["drapeau-om", "drapeau oman"],
      u: "1f1f4-1f1f2",
      a: "2.0"
    },
    {
      n: ["drapeau-pa", "drapeau panaméen"],
      u: "1f1f5-1f1e6",
      a: "2.0"
    },
    {
      n: ["drapeau-pe", "drapeau du Pérou"],
      u: "1f1f5-1f1ea",
      a: "2.0"
    },
    {
      n: ["drapeau-pf", "drapeau de la polynésie française"],
      u: "1f1f5-1f1eb",
      a: "2.0"
    },
    {
      n: ["drapeau-pg", "drapeau de la Papouasie-Nouvelle-Guinée"],
      u: "1f1f5-1f1ec",
      a: "2.0"
    },
    {
      n: ["drapeau-ph", "drapeau philippin"],
      u: "1f1f5-1f1ed",
      a: "2.0"
    },
    {
      n: ["drapeau-pk", "drapeau du pakistan"],
      u: "1f1f5-1f1f0",
      a: "2.0"
    },
    {
      n: ["drapeau-pl", "drapeau de la pologne"],
      u: "1f1f5-1f1f1",
      a: "2.0"
    },
    {
      n: ["drapeau-pm", "St. drapeau pierre et miquelon"],
      u: "1f1f5-1f1f2",
      a: "2.0"
    },
    {
      n: ["drapeau-pn", "drapeau des îles Pitcairn"],
      u: "1f1f5-1f1f3",
      a: "2.0"
    },
    {
      n: ["drapeau-pr", "drapeau de Porto Rico"],
      u: "1f1f5-1f1f7",
      a: "2.0"
    },
    {
      n: ["drapeau-ps", "drapeau des territoires palestiniens"],
      u: "1f1f5-1f1f8",
      a: "2.0"
    },
    {
      n: ["drapeau-pt", "drapeau portugais"],
      u: "1f1f5-1f1f9",
      a: "2.0"
    },
    {
      n: ["drapeau-pw", "drapeau des Palaos"],
      u: "1f1f5-1f1fc",
      a: "2.0"
    },
    {
      n: ["drapeau-py", "drapeau du Paraguay"],
      u: "1f1f5-1f1fe",
      a: "2.0"
    },
    {
      n: ["drapeau-qa", "drapeau du qatar"],
      u: "1f1f6-1f1e6",
      a: "2.0"
    },
    {
      n: ["drapeau-re", "drapeau de la réunion"],
      u: "1f1f7-1f1ea",
      a: "2.0"
    },
    {
      n: ["drapeau-ro", "drapeau de la Roumanie"],
      u: "1f1f7-1f1f4",
      a: "2.0"
    },
    {
      n: ["drapeau-rs", "drapeau de la serbie"],
      u: "1f1f7-1f1f8",
      a: "2.0"
    },
    {
      n: ["ru", "drapeau-ru", "drapeau de la Russie"],
      u: "1f1f7-1f1fa",
      a: "0.6"
    },
    {
      n: ["drapeau-rw", "drapeau rwandais"],
      u: "1f1f7-1f1fc",
      a: "2.0"
    },
    {
      n: ["drapeau-sa", "drapeau de l'arabie saoudite"],
      u: "1f1f8-1f1e6",
      a: "2.0"
    },
    {
      n: ["drapeau-sb", "drapeau des îles salomon"],
      u: "1f1f8-1f1e7",
      a: "2.0"
    },
    {
      n: ["drapeau-sc", "drapeau des seychelles"],
      u: "1f1f8-1f1e8",
      a: "2.0"
    },
    {
      n: ["drapeau-sd", "drapeau du Soudan"],
      u: "1f1f8-1f1e9",
      a: "2.0"
    },
    {
      n: ["drapeau-se", "drapeau de la Suède"],
      u: "1f1f8-1f1ea",
      a: "2.0"
    },
    {
      n: ["drapeau-sg", "drapeau de Singapour"],
      u: "1f1f8-1f1ec",
      a: "2.0"
    },
    {
      n: ["drapeau-sh", "St. drapeau d'Hélène"],
      u: "1f1f8-1f1ed",
      a: "2.0"
    },
    {
      n: ["drapeau-si", "drapeau de la Slovénie"],
      u: "1f1f8-1f1ee",
      a: "2.0"
    },
    {
      n: ["drapeau-sj", "drapeau du svalbard et de janvier mayen"],
      u: "1f1f8-1f1ef",
      a: "2.0"
    },
    {
      n: ["drapeau-sk", "drapeau de la Slovaquie"],
      u: "1f1f8-1f1f0",
      a: "2.0"
    },
    {
      n: ["drapeau-sl", "drapeau de la Sierra Leone"],
      u: "1f1f8-1f1f1",
      a: "2.0"
    },
    {
      n: ["drapeau-sm", "drapeau de Saint-Marin"],
      u: "1f1f8-1f1f2",
      a: "2.0"
    },
    {
      n: ["drapeau-sn", "drapeau du Sénégal"],
      u: "1f1f8-1f1f3",
      a: "2.0"
    },
    {
      n: ["drapeau-donc", "drapeau de la Somalie"],
      u: "1f1f8-1f1f4",
      a: "2.0"
    },
    {
      n: ["drapeau-sr", "drapeau du surinam"],
      u: "1f1f8-1f1f7",
      a: "2.0"
    },
    {
      n: ["drapeau-ss", "drapeau du Soudan du Sud"],
      u: "1f1f8-1f1f8",
      a: "2.0"
    },
    {
      n: ["drapeau-st", "drapeau de são tomé et príncipe"],
      u: "1f1f8-1f1f9",
      a: "2.0"
    },
    {
      n: ["drapeau-sv", "drapeau du Salvador"],
      u: "1f1f8-1f1fb",
      a: "2.0"
    },
    {
      n: ["drapeau-sx", "drapeau de Saint-Martin"],
      u: "1f1f8-1f1fd",
      a: "2.0"
    },
    {
      n: ["drapeau-sy", "drapeau de la Syrie"],
      u: "1f1f8-1f1fe",
      a: "2.0"
    },
    {
      n: ["drapeau-sz", "drapeau eswatini"],
      u: "1f1f8-1f1ff",
      a: "2.0"
    },
    {
      n: ["drapeau-ta", "drapeau tristan da cunha"],
      u: "1f1f9-1f1e6",
      a: "2.0"
    },
    {
      n: ["drapeau-tc", "drapeau des îles Turques et Caïques"],
      u: "1f1f9-1f1e8",
      a: "2.0"
    },
    {
      n: ["drapeau-td", "drapeau du Tchad"],
      u: "1f1f9-1f1e9",
      a: "2.0"
    },
    {
      n: ["drapeau-tf", "drapeau des territoires du sud français"],
      u: "1f1f9-1f1eb",
      a: "2.0"
    },
    {
      n: ["drapeau-tg", "drapeau togolais"],
      u: "1f1f9-1f1ec",
      a: "2.0"
    },
    {
      n: ["drapeau-ème", "drapeau de la Thaïlande"],
      u: "1f1f9-1f1ed",
      a: "2.0"
    },
    {
      n: ["drapeau-tj", "drapeau du tadjikistan"],
      u: "1f1f9-1f1ef",
      a: "2.0"
    },
    {
      n: ["drapeau-tk", "drapeau des Tokélaou"],
      u: "1f1f9-1f1f0",
      a: "2.0"
    },
    {
      n: ["drapeau-tl", "drapeau du Timor oriental"],
      u: "1f1f9-1f1f1",
      a: "2.0"
    },
    {
      n: ["drapeau-tm", "drapeau du Turkménistan"],
      u: "1f1f9-1f1f2",
      a: "2.0"
    },
    {
      n: ["drapeau-tn", "drapeau tunisien"],
      u: "1f1f9-1f1f3",
      a: "2.0"
    },
    {
      n: ["drapeau à", "drapeau des Tonga"],
      u: "1f1f9-1f1f4",
      a: "2.0"
    },
    {
      n: ["drapeau-tr", "drapeau de la Turquie"],
      u: "1f1f9-1f1f7",
      a: "2.0"
    },
    {
      n: ["drapeau-tt", "drapeau de trinité et tobago"],
      u: "1f1f9-1f1f9",
      a: "2.0"
    },
    {
      n: ["drapeau-tv", "drapeau tuvalu"],
      u: "1f1f9-1f1fb",
      a: "2.0"
    },
    {
      n: ["drapeau-tw", "drapeau de Taïwan"],
      u: "1f1f9-1f1fc",
      a: "2.0"
    },
    {
      n: ["drapeau-tz", "drapeau de la tanzanie"],
      u: "1f1f9-1f1ff",
      a: "2.0"
    },
    {
      n: ["drapeau-ua", "drapeau ukrainien"],
      u: "1f1fa-1f1e6",
      a: "2.0"
    },
    {
      n: ["drapeau-ug", "drapeau ougandais"],
      u: "1f1fa-1f1ec",
      a: "2.0"
    },
    {
      n: ["drapeau-euh", "nous. drapeau des îles éloignées"],
      u: "1f1fa-1f1f2",
      a: "2.0"
    },
    {
      n: ["drapeau-un", "drapeau des nations unies"],
      u: "1f1fa-1f1f3",
      a: "4.0"
    },
    {
      n: ["nous", "signalez-nous", "drapeau des états unis"],
      u: "1f1fa-1f1f8",
      a: "0.6"
    },
    {
      n: ["drapeau-uy", "drapeau de l'Uruguay"],
      u: "1f1fa-1f1fe",
      a: "2.0"
    },
    {
      n: ["drapeau-uz", "drapeau de l'Ouzbékistan"],
      u: "1f1fa-1f1ff",
      a: "2.0"
    },
    {
      n: ["drapeau-va", "drapeau de la cité du Vatican"],
      u: "1f1fb-1f1e6",
      a: "2.0"
    },
    {
      n: ["drapeau-vc", "St. drapeau Vincent et les Grenadines"],
      u: "1f1fb-1f1e8",
      a: "2.0"
    },
    {
      n: ["drapeau-ve", "drapeau du Venezuela"],
      u: "1f1fb-1f1ea",
      a: "2.0"
    },
    {
      n: ["drapeau-vg", "drapeau des îles vierges britanniques"],
      u: "1f1fb-1f1ec",
      a: "2.0"
    },
    {
      n: ["drapeau-vi", "nous. drapeau des îles vierges"],
      u: "1f1fb-1f1ee",
      a: "2.0"
    },
    {
      n: ["drapeau-vn", "drapeau du vietnam"],
      u: "1f1fb-1f1f3",
      a: "2.0"
    },
    {
      n: ["drapeau-vu", "drapeau du Vanuatu"],
      u: "1f1fb-1f1fa",
      a: "2.0"
    },
    {
      n: ["drapeau-wf", "drapeau wallis et futuna"],
      u: "1f1fc-1f1eb",
      a: "2.0"
    },
    {
      n: ["drapeau-ws", "drapeau des Samoa"],
      u: "1f1fc-1f1f8",
      a: "2.0"
    },
    {
      n: ["drapeau-xk", "drapeau du Kosovo"],
      u: "1f1fd-1f1f0",
      a: "2.0"
    },
    {
      n: ["drapeau-ye", "drapeau du Yémen"],
      u: "1f1fe-1f1ea",
      a: "2.0"
    },
    {
      n: ["drapeau-yt", "drapeau de mayotte"],
      u: "1f1fe-1f1f9",
      a: "2.0"
    },
    {
      n: ["drapeau-za", "drapeau de l'Afrique du Sud"],
      u: "1f1ff-1f1e6",
      a: "2.0"
    },
    {
      n: ["drapeau-zm", "drapeau de la Zambie"],
      u: "1f1ff-1f1f2",
      a: "2.0"
    },
    {
      n: ["drapeau-zw", "drapeau du Zimbabwe"],
      u: "1f1ff-1f1fc",
      a: "2.0"
    },
    {
      n: ["drapeau de l'Angleterre", "drapeau-angleterre"],
      u: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
      a: "5.0"
    },
    {
      n: ["drapeau de l'Écosse", "drapeau-ecosse"],
      u: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
      a: "5.0"
    },
    {
      n: ["drapeau du Pays de Galles", "drapeau-pays de galles"],
      u: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
      a: "5.0"
    }
  ]
};
